import Vue from "vue";
import VueRouter from "vue-router";
import HomeNew from "../components/Menu/HomeNew.vue";
import Home from "../components/Home.vue";
import Login from "../components/LoginCommon.vue";
import SsoVerify from "../components/SsoVerify.vue";
import PartnerEntry from "../components/PartnerEntry.vue";
import PartnerSso from "../components/PartnerSso.vue";
import PartnerMagicLogin from "../components/PartnerMagicLogin.vue";
import ClientMagicLogin from "../components/ClientMagicLogin.vue";
import ClientEntry from "../components/ClientEntry.vue";
import VueSimpleAlert from "vue-simple-alert";
import aopRoutes from "./aop_routes";
import workshopRoutes from "./workshop_routes";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      path: "/sso_verify",
      name: "SsoVerify",
      component: SsoVerify,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Public self-service onboarding acknowledgement (emailed token link)
      path: "/employee_ack",
      name: "EmployeeAckView",
      component: () => import("@/views/EmployeeAckView.vue"),
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Partner portal "Enter Workspace" handoff — no auth guard, reads params from URL
      path: "/partner_entry",
      name: "PartnerEntry",
      component: PartnerEntry,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Cross-domain SSO handoff from starrboard-website partner login.
      // Reads base64-encoded partner credentials from URL params,
      // stores them in localStorage, then redirects to /partner_landing.
      path: "/partner_sso",
      name: "PartnerSso",
      component: PartnerSso,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Partner magic link from approval email — validates token, sets password, starts session
      path: "/partner_magic",
      alias: "/partner-login",
      name: "PartnerMagicLogin",
      component: PartnerMagicLogin,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Client magic link from welcome email — validates one-time token and starts workspace session
      path: "/client_magic",
      name: "ClientMagicLogin",
      component: ClientMagicLogin,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Magic login link from welcome email — validates one-time token and sets up session
      path: "/client_entry",
      name: "ClientEntry",
      component: ClientEntry,
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      // Invite-based partner registration — accessed via link in invite email.
      // /partner-signup is the URL sent in invite emails (backend partner_controller.ex:875).
      path: "/partner-register",
      alias: "/partner-signup",
      name: "PartnerRegister",
      component: () => import("../views/PartnerRegister.vue"),
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
    },
    {
      path: "/familybook/login",
      name: "LoginFamily",
      meta: {
        auth: false,
        iscommontoshow: true,
        isnoadmintoshow: true,
      },
      component: () => import("../components/LoginFamily.vue"),
    },
    {
      path: "/forgotpassword",
      name: "ForgotPassword Tenant",
      meta: {
        auth: false,
        isnoadmintoshow: true,
      },
      component: () => import("../components/forgotpassword.vue"),
    },
    {
      path: "/forgotpassword_admin",
      name: "ForgotPassword",
      meta: {
        auth: false,
        isnoadmintoshow: true,
      },
      component: () => import("../components/forgotpassword_admin.vue"),
    },
    {
      path: "/forgotpassword_profile",
      name: "ForgotPasswordProfile",
      meta: {
        auth: true,
        isnoadmintoshow: true,
      },
      component: () => import("../components/forgotpassword.vue"),
    },
    {
      path: "/",
      name: "Home",
      component: HomeNew,
      meta: {
        auth: true,
      },
      children: [
        {
          path: "/employee_onboarding",
          name: "EmployeeOnboarding",
          // Same layout as /solutions/problem_solving: keep the app navbar so the
          // wizard's sticky header (top:64px) sits flush below it (no empty gap).
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/employee_onboarding.vue"),
        },
        {
          path: "/common-grid-demo",
          name: "CommonGridDemo",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/CommonGridDemo.vue"),
        },
        {
          path: "/license-agreement",
          name: "LicenseAgreement",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/license_agreement.vue"),
        },
        {
          path: "/setup_guide",
          name: "SetupGuide",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/setup_guide.vue"),
        },
        {
          path: "/solution_navigator",
          name: "SolutionNavigator",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solution_navigator.vue"),
        },
        {
          path: "/solutions",
          name: "SolutionsHome",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solutions/SolutionsHome.vue"),
        },
        {
          path: "/roles-definition-loop",
          name: "RolesDefinitionLoop",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/roleProfileNew.vue"),
        },
        {
          path: "/role-profile",
          name: "RoleProfile",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/roleProfile.vue"),
        },
        {
          path: "/key-functions",
          name: "KeyFunctions",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/keyFunctions.vue"),
        },
        {
          path: "/responsibilities",
          name: "Responsibilities",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/responsibilities.vue"),
        },
        {
          path: "/authority",
          name: "Authority",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/authority.vue"),
        },
        {
          path: "/reporting",
          name: "Reporting",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/reporting.vue"),
        },
        {
          path: "/kpi-targets",
          name: "KpiTargets",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/kpiTargets.vue"),
        },
        {
          path: "/role-dashboard",
          name: "RoleDashboard",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/roleDashboard.vue"),
        },
        {
          path: "/solutions/problem_solving",
          name: "ProblemSolvingLoop",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solutions/ProblemSolvingLoop.vue"),
        },
        {
          path: "/solutions/employee_onboarding",
          name: "EmployeeOnboarding",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solutions/EmployeeOnboarding.vue"),
        },
        {
          path: "/solutions/family_business",
          name: "FamilyBusinessTransformation",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solutions/FamilyBusinessTransformation.vue"),
        },
        {
          path: "/solutions/business_planning",
          name: "BusinessPlanningLoop",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solutions/BusinessPlanningLoop.vue"),
        },
        // Quotation Cost Analyst. `/new` is declared before `/:id` so the literal
        // path is matched first — otherwise "new" is read as an assessment id.
        {
          path: "/solutions/quotation_navigator",
          name: "QuotationNavigatorHome",
          meta: { auth: true, iscommontoshow: true },
          component: () =>
            import("@/views/solutions/quotation_navigator/QuotationNavigatorHome.vue"),
        },
        {
          path: "/solutions/quotation_navigator/new",
          name: "QuotationNewAssessment",
          meta: { auth: true, iscommontoshow: true },
          component: () =>
            import("@/views/solutions/quotation_navigator/QuotationNewAssessment.vue"),
        },
        {
          path: "/solutions/quotation_navigator/:id",
          name: "QuotationDetail",
          meta: { auth: true, iscommontoshow: true },
          component: () =>
            import("@/views/solutions/quotation_navigator/QuotationDetail.vue"),
        },
        // Payroll Automation. `/runs/:id` is declared after the home path so the
        // literal "/solutions/payroll_automation" wins first, matching the
        // Quotation Navigator ordering above.
        {
          path: "/solutions/payroll_automation",
          name: "PayrollAutomationHome",
          meta: { auth: true, iscommontoshow: true },
          component: () =>
            import("@/views/solutions/payroll_automation/PayrollHome.vue"),
        },
        {
          path: "/solutions/payroll_automation/runs/:id",
          name: "PayrollRunDetail",
          meta: { auth: true, iscommontoshow: true },
          component: () =>
            import("@/views/solutions/payroll_automation/PayrollRunDetail.vue"),
        },
        {
          path: "/transactions",
          name: "TransactionList",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/transactions/TransactionList.vue"),
        },
        {
          path: "/admin-transactions",
          name: "AdminTransactions",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/transactions/AdminTransactions.vue"),
        },
        {
          path: "/admin/release-notes",
          name: "ReleaseNotesAdmin",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/admin/release_notes_admin.vue"),
        },
        {
          path: "/admin/scheduler-logs",
          name: "SchedulerLogs",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/admin/scheduler_logs.vue"),
        },
        {
          path: "/sn-modules-pricing",
          name: "SnModulesPricing",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/solution_navigator/SnModulesPricing.vue"),
        },
        {
          path: "/payment-required",
          name: "PaymentRequired",
          meta: { auth: false },
          component: () => import("@/views/PaymentRequired.vue"),
        },
        {
          path: "/help",
          name: "HelpLayout",
          meta: { auth: true, iscommontoshow: true },
          component: () => import("@/views/help/HelpLayout.vue"),
          children: [
            {
              path: "",
              name: "HelpDashboard",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/HelpDashboard.vue"),
            },
            {
              path: "automate-scorecard",
              name: "AutomateScorecardGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/AutomateScorecardGuide.vue"),
            },
            {
              path: "budget-vs-actual",
              name: "BudgetVsActualGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/BudgetVsActualGuide.vue"),
            },
            {
              path: "checklist-engine",
              name: "ChecklistEngineGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/ChecklistEngineGuide.vue"),
            },
            {
              path: "data-management",
              name: "DataManagementGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/DataManagementGuide.vue"),
            },
            {
              path: "financial-forecasting",
              name: "FinancialForecastingGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/FinancialForecastingGuide.vue"),
            },
            {
              path: "financial-health-check",
              name: "FinancialHealthCheckGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/FinancialHealthCheckGuide.vue"),
            },
            {
              path: "goals-strategy",
              name: "GoalsStrategyGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/GoalsStrategyGuide.vue"),
            },
            {
              path: "meetings",
              name: "MeetingsGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/MeetingsGuide.vue"),
            },
            {
              path: "operational-health-check",
              name: "OperationalHealthCheckGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/OperationalHealthCheckGuide.vue"),
            },
            {
              path: "organisational-structure",
              name: "OrganisationalStructureGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/OrganisationalStructureGuide.vue"),
            },
            {
              path: "survey-engine",
              name: "SurveyEngineGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/SurveyEngineGuide.vue"),
            },
            {
              path: "ticket-engine",
              name: "TicketEngineGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/TicketEngineGuide.vue"),
            },
            {
              path: "management-alignment",
              name: "ManagementAlignmentGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/ManagementAlignmentGuide.vue"),
            },
            {
              path: "kpi-weightage-target",
              name: "KpiWeightageTargetGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/KpiWeightageTargetGuide.vue"),
            },
             {
              path: "forms-user",
              name: "FormsUserGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/FormsUserGuide.vue"),
            },
            {
              path: "dashboards-reports",
              name: "DashboardsExceptionsReportsGuide",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/DashboardsExceptionsReportsGuide.vue"),
            },
            {
              path: "guide",
              name: "GuideViewer",
              meta: { auth: true, iscommontoshow: true },
              component: () => import("@/views/help/GuideViewer.vue"),
            },
          ],
        },
        {
          path: "/library",
          name: "Library",
          meta: {
            auth: true,
          },
          component: () => import("../views/library.vue"),
        },
        {
          path: "/core_account",
          name: "core_account",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/AdminMasters/Core/core_account.vue"),
        },
        {
          path: "/template_process",
          name: "TemplateProcess",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Checklists/checklist_process.vue"),
        },
        {
          path: "/template_responsibility",
          name: "Responsibility",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Checklists/checklist_responsibility.vue"),
        },
        {
          path: "/template_casebased",
          name: "Case",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Checklists/checklist_casebased.vue"),
        },
        {
          path: "/task_template/:id/tasks",
          name: "task_view",
          meta: {
            auth: true,
          },
          component: () => import("../views/Template/Tasks/task.vue"),
        },
        {
          path: "/subtask_template/:id/subtasks",
          name: "subtask_view",
          meta: {
            auth: true,
          },
          component: () => import("../views/Template/Subtasks/subtasks.vue"),
        },
        {
          path: "/checklist_template/add",
          name: "checklist_template_add",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Checklists/checklist_add.vue"),
        },
        {
          path: "/task_template/add",
          name: "task_template_add",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Tasks/task_template_add.vue"),
        },
        {
          path: "/subtask_template/add",
          name: "subtask_template_add",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Subtasks/subtask_template_add.vue"),
        },
        {
          path: "/checklist_template/edit/:id",
          name: "checklist_template_edit",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Checklists/checklist_edit.vue"),
        },
        {
          path: "/task_template/edit/:taskid",
          name: "task_template_edit",
          meta: {
            auth: true,
          },
          component: () => import("../views/Template/Tasks/tasks_edit.vue"),
        },
        {
          path: "/subtask_template/edit/:subtaskid",
          name: "subtask_template_edit",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/Template/Subtasks/subtasks_edit.vue"),
        },
        {
          path: "/adoptchecklist/:id",
          name: "adopt_chk",
          meta: {
            auth: true,
          },
          component: () => import("../views/Template/adopt_view.vue"),
        },
        {
          path: "/team_list",
          name: "Team_list",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/team_list.vue"),
        },
        {
          path: "/quick_links",
          name: "ACT",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/quick_links.vue"),
        },
        {
          path: "/score_list",
          name: "Score_list",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/score_list.vue"),
        },
        // Workings

        {
          path: "/masters_dashboard",
          name: "masters_dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_MASTERS_DASHBOARD",
            page_type: "landing",
            breadcrumb: "Masters / Dashboard",
          },
          component: () => import("../views/masters/masters_dashboard.vue"),
        },
        {
          path: "/visits_dashboard",
          name: "visits_dashboard",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "landing",
            breadcrumb: "Visits / Dashboard",
          },
          component: () => import("../views/visits/visit_dashboard.vue"),
        },
        {
          path: "/ai_dashboard",
          name: "ai_dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_AI_DASHBOARD",
            page_type: "landing",
            breadcrumb: "AI / Dashboard",
          },
          component: () => import("../views/ai/ai_dashboard.vue"),
        },

        {
          path: "/settings_dashboard",
          name: "settings_dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SETTINGS_DASHBOARD",
            page_type: "landing",
            breadcrumb: "Settings / Dashboard",
          },
          component: () => import("../views/Settings/settings_dashboard.vue"),
        },

        {
          path: "/master_builder",
          name: "master_builder",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/master_builder.vue"),
        },

        {
          path: "/branch",
          name: "branch",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
            branch: "Masters/ Global/ Branch",
          },
          component: () => import("../views/masters/Dashboard.vue"),
        },
        {
          path: "/objective",
          name: "Objective",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_OBJECTIVE",
            page_type: "landing",
            breadcrumb: "Masters / Business Plan / Objective",
          },
          component: () => import("../views/masters/objective.vue"),
        },
        {
          path: "/objective/add",
          name: "Objective_Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OBJECTIVE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/objective_add.vue"),
        },
        {
          path: "/objective/edit/:id",
          name: "objective_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OBJECTIVE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/objective_edit.vue"),
        },
        {
          path: "/familybook/family_company",
          name: "Family_Company",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_COMPANY",
            page_type: "landing",
            breadcrumb: "Masters / Family Book / Company",
          },
          component: () => import("../views/masters/Family_Company.vue"),
        },
        {
          path: "/familybook/family_company_add",
          name: "Family_Company_Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_COMPANY",
            page_type: "add_screen",
            breadcrumb: "Masters / Family Book / Company",
          },
          component: () => import("../views/masters/Family_Company_Add.vue"),
        },
        {
          path: "/familybook/family_company_edit/:id",
          name: "Family_Company_Edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_COMPANY",
            page_type: "edit_screen",
            breadcrumb: "Masters / Family Book / Company",
          },
          component: () => import("../views/masters/Family_Company_Edit.vue"),
        },
        {
          path: "/strategy",
          name: "Strategy",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_MST_STRATEGY_GROUP",
            page_type: "landing",
            breadcrumb: "Masters / Business Plan / Strategy",
          },
          component: () => import("../views/masters/strategy_group.vue"),
        },
        {
          path: "/strategy/add",
          name: "strategy Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_MST_STRATEGY_GROUP",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/strategy_add.vue"),
        },
        {
          path: "/strategy/edit/:id",
          name: "strategy_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_MST_STRATEGY_GROUP",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/strategy_edit.vue"),
        },
        {
          path: "/business_plan",
          name: "business_plan",
          meta: {
            auth: true,
            screen_code: "SCN_PLANNING",
            //isnoadmintoshow: true,
            page_code: "SCN_PLANNING",
            page_type: "landing",
            breadcrumb: "Strategy / Goal Setting / Goals",
          },
          component: () => import("../views/masters/buisness_plan.vue"),
        },
        {
          path: "/set_strategy",
          name: "set_strategy",
          meta: {
            auth: true,
            screen_code: "SCN_STRATEGY",
            //isnoadmintoshow: true,
            page_code: "SCN_STRATEGY",
            page_type: "landing",
            breadcrumb: "Strategy / Goal Setting / Strategy",
          },
          component: () => import("../views/masters/set_strategy.vue"),
        },
        {
          path: "/business_report",
          name: "business_plan_report",
          meta: {
            auth: true,
            screen_code: "SCN_BUSINESS_REPORT",
            //isnoadmintoshow: true,
            page_code: "SCN_BUSINESS_REPORT",
            page_type: "landing",
          },
          component: () => import("../views/masters/business_plan_report.vue"),
        },
        {
          path: "/visittype",
          name: "Visittype",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_TYPE",
            page_code: "SCN_VISIT_TYPE",
            page_type: "landing",
            breadcrumb: "Masters / Visits / Visit Type",
          },
          component: () => import("../views/masters/visittype.vue"),
        },

        {
          path: "/PurposeOfMeeting",
          name: "PurposeOfMeeting",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_POM",
            page_code: "SCN_VISIT_POM",
            page_type: "landing",
            breadcrumb: "Masters / Visits / Purpose Of Meeting",
          },
          component: () => import("../views/masters/PurposeOfMeeting.vue"),
        },

        {
          path: "/department",
          name: "Department",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "landing",
            department: "Masters/ Global/ Department",
          },
          component: () => import("../views/masters/Department.vue"),
        },
        {
          path: "/segment",
          name: "Segment",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "landing",
            segment: "Masters/ Global/ Segment",
          },
          component: () => import("../views/masters/Segment.vue"),
        },
        {
          path: "/subdepartment",
          name: "SubDepartment",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DEPARTMENT",
            page_type: "landing",
            subdepartment: "Masters/ Global/ Subdepartment",
          },
          component: () => import("../views/masters/SubDepartment.vue"),
        },
        {
          path: "/addsubdepartment",
          name: "AddSubDepartment",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DEPARTMENT",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/SubDepartment_add.vue"),
        },

        {
          path: "/subdepartment/edit/:id",
          name: "SubDepartment_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DEPARTMENT",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/SubDepartment_edit.vue"),
        },

        {
          path: "/region",
          name: "Region",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_REGION",
            page_type: "landing",
            breadcrumb: "Masters/ Global/ Region",
          },
          component: () => import("../views/masters/Region.vue"),
        },
        {
          path: "/subregion/landing",
          name: "Sub Region Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUBREGION",
            page_type: "landing",
            subregion: "Masters/ Global/ Subregion",
          },
          component: () => import("../views/masters/Subregion.vue"),
        },
        {
          path: "/subregion/add",
          name: "Sub Region Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUBREGION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/subregion_add.vue"),
        },
        {
          path: "/subregion",
          name: "Sub Region",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUBREGION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/subregion_editview.vue"),
        },
        {
          path: "/business_type/landing",
          name: "Business Type Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUSINESS_TYPE",
            page_type: "landing",
            business: "Masters/ Global/ Business_type",
          },
          component: () => import("../views/masters/BusinessType.vue"),
        },
        {
          path: "/business_type/add",
          name: "Business Type Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUSINESS_TYPE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/businesstype_add.vue"),
        },
        {
          path: "/business_type",
          name: "Business Type",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUSINESS_TYPE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/businesstype_editview.vue"),
        },
        {
          path: "/zone/landing",
          name: "Zone Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ZONE",
            page_type: "landing",
            zone: "Masters/ Global/ Zone",
          },
          component: () => import("../views/masters/Zone.vue"),
        },
        {
          path: "/zone/add",
          name: "Zone Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ZONE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/zone_add.vue"),
        },
        {
          path: "/zone",
          name: "Zone",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ZONE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/zone_editview.vue"),
        },
        {
          path: "/district/landing",
          name: "District Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DISTRICT",
            page_type: "landing",
            district: "Masters/ Global/ District",
          },
          component: () => import("../views/masters/District.vue"),
        },
        {
          path: "/district/add",
          name: "District Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DISTRICT",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/district_add.vue"),
        },
        {
          path: "/district",
          name: "District",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DISTRICT",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/district_editview.vue"),
        },
        {
          path: "/outlet/landing",
          name: "Outlet Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OUTLET",
            page_type: "landing",
            outlet: "Masters/ Global/ Outlet",
          },
          component: () => import("../views/masters/Outlet.vue"),
        },
        {
          path: "/outlet/add",
          name: "Outlet Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OUTLET",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/outlet_add.vue"),
        },
        {
          path: "/outlet",
          name: "Outlet",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OUTLET",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/outlet_editview.vue"),
        },
        {
          path: "/region/add",
          name: "AddRegion",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_REGION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Region_add.vue"),
        },

        {
          path: "/region/edit/:id",
          name: "Region_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_REGION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Region_edit.vue"),
        },
        {
          path: "/channel",
          name: "channel",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CHANNEL",
            page_type: "edit_screen",
            breadcrumb: "Masters / Performance / Channel",
          },
          component: () => import("../views/masters/channel.vue"),
        },

        {
          path: "/channel/add",
          name: "channel_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CHANNEL",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/channel_add.vue"),
        },
        {
          path: "/channel/edit/:id",
          name: "channel_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CHANNEL",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/channel_edit.vue"),
        },
        {
          path: "/uom",
          name: "uom",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_UOM",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Uom",
          },
          component: () => import("../views/masters/uom.vue"),
        },

        {
          path: "/uom/add",
          name: "uom_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_UOM",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/uom_add.vue"),
        },
        {
          path: "/uom/edit/:id",
          name: "uom_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_UOM",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/uom_edit.vue"),
        },
        {
          path: "/function",
          name: "Function ",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            function: "Masters/ Global/ Function",
          },
          component: () => import("../views/masters/function.vue"),
        },
        {
          path: "/function/add",
          name: "Function Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/function_add.vue"),
        },
        {
          path: "/function/edit/:id",
          name: "Function Edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/function_edit.vue"),
        },
        {
          path: "/skillsgroup",
          name: "skillsgroup ",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            skillsgroup: "Masters/ Global/ Skillsgroup",
          },
          component: () => import("../views/masters/skillsgroup.vue"),
        },
        {
          path: "/skillsgroup/add",
          name: "skillsgroup Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/skillsgroup_add.vue"),
        },
        {
          path: "/skillsgroup/edit/:id",
          name: "skillsgroup Edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/skillsgroup_edit.vue"),
        },
        {
          path: "/competencies",
          name: "competencies ",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            competencies: "Masters/ Global/ Competencies",
          },
          component: () => import("../views/masters/competencies.vue"),
        },
        {
          path: "/competencies/add",
          name: "competencies Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/competencies__add.vue"),
        },
        {
          path: "/competencies/edit/:id",
          name: "competencies Edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/competencies_edit.vue"),
        },
        {
          path: "/distinct_role_assignments",
          name: "Role Assignments Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            disroleassignment: "Masters/ Global/ Role Assignments",
          },
          component: () =>
            import("../views/masters/distinct_RoleAssignments.vue"),
        },
        {
          path: "/role_assignments",
          name: "Role Assignments",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            roleassignments: "Masters/ Global/ Role Assignments/ Details Role",
          },
          component: () => import("../views/masters/RoleAssignments.vue"),
        },

        {
          path: "/role_assignments/add",
          name: "Role Assignments_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/RoleAssignments_add.vue"),
        },
        {
          path: "/role_assignments/edit/:id",
          name: "Role Assignments_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/RoleAssignments_edit.vue"),
        },
        {
          path: "/skills",
          name: "Skills",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
          },
          component: () => import("../views/masters/Skills.vue"),
        },
        {
          path: "/skills_add",
          name: "Skills_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/skills_add.vue"),
        },
        {
          path: "/skills_edit/:id",
          name: "Skills edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/skills_edit.vue"),
        },
        {
          path: "/competencies_add",
          name: "Competencies_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/competencies_add.vue"),
        },
        {
          path: "/Target_type",
          name: "Target_type",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_TARGET_TYPE",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Target Type",
          },
          component: () => import("../views/masters/Target_type.vue"),
        },
        {
          path: "/Target_type/add",
          name: "Target_type_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_TARGET_TYPE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Target_type_add.vue"),
        },
        {
          path: "/Target_type/edit/:id",
          name: "Target_type_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_TARGET_TYPE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Target_type_edit.vue"),
        },
        {
          path: "/familybook/Family_birthday",
          name: "Family_birthday",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_BIRTHDAY",
            page_type: "landing",
            breadcrumb: "Masters / Family / Family Birthday",
          },
          component: () => import("../views/masters/Family_birthday.vue"),
        },
        {
          path: "/familybook/Family_birthday/add",
          name: "Family_birthday_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_BIRTHDAY",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Family_birthday_add.vue"),
        },
        {
          path: "/familybook/Family_birthday/edit/:id",
          name: "Family_birthday_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_BIRTHDAY",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Family_birthday_edit.vue"),
        },
        {
          path: "/familybook/Family_anniversary",
          name: "Family_anniversary",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_ANNIVERSARY",
            page_type: "landing",
            breadcrumb: "Masters / Family / Family Anniversary",
          },
          component: () => import("../views/masters/Family_anniversary.vue"),
        },
        {
          path: "/familybook/Family_anniversary/add",
          name: "Family_anniversary_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_ANNIVERSARY",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Family_anniversary_add.vue"),
        },
        {
          path: "/familybook/Family_anniversary/edit/:id",
          name: "Family_anniversary_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_ANNIVERSARY",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Family_anniversary_edit.vue"),
        },
        {
          path: "/familybook/Family_event",
          name: "Family_event",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_EVENT",
            page_type: "landing",
            breadcrumb: "Masters / Family / Family Event",
          },
          component: () => import("../views/masters/Family_event.vue"),
        },
        {
          path: "/familybook/Family_event/add",
          name: "Family_event_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_EVENT",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Family_event_add.vue"),
        },
        {
          path: "/familybook/Family_event/edit/:id",
          name: "Family_event_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_EVENT",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Family_event_edit.vue"),
        },
        {
          path: "/familybook/Family_announcement",
          name: "Family_announcement",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_ANNOUNCEMENT",
            page_type: "landing",
            breadcrumb: "Masters / Family / Family Announcement",
          },
          component: () => import("../views/masters/Family_Announcement.vue"),
        },
        {
          path: "/familybook/Family_announcement/add",
          name: "Family_announcement_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_ANNOUNCEMENT",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/masters/Family_Announcement_add.vue"),
        },
        {
          path: "/familybook/Family_announcement/edit/:id",
          name: "Family_announcement_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FAMILY_ANNOUNCEMENT",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/masters/Family_Announcement_edit.vue"),
        },
        {
          path: "/kpi_type",
          name: "kpi_type",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_TYPE",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Kpi Type",
          },
          component: () => import("../views/masters/kpi_type.vue"),
        },

        {
          path: "/kpi_type/add",
          name: "kpi_type_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_TYPE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/kpi_type_add.vue"),
        },
        {
          path: "/kpi_type/edit/:id",
          name: "kpi_type_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_TYPE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/kpi_type_edit.vue"),
        },
        {
          path: "/Subdivision",
          name: "Subdivision",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DIVISION",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Subdivision",
          },
          component: () => import("../views/masters/Subdivision.vue"),
        },
        {
          path: "/Branch",
          name: "branch_mstr",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DIVISION",
            page_type: "landing",
          },
          component: () => import("../views/masters/branch.vue"),
        },
        {
          path: "/Subdivision/add",
          name: "Subdivision_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DIVISION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Subdivision_add.vue"),
        },
        {
          path: "/Subdivision/edit/:id",
          name: "Subdivision_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_DIVISION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Subdivision_edit.vue"),
        },
        {
          path: "/Division",
          name: "Division",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DIVISION",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Division",
          },
          component: () => import("../views/masters/Division.vue"),
        },

        {
          path: "/Division/add",
          name: "Division_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DIVISION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Division_add.vue"),
        },
        {
          path: "/Division/edit/:id",
          name: "Division_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DIVISION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Division_edit.vue"),
        },
        {
          path: "/subchannel",
          name: "subchannel",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_CHANNEL",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Subchannel",
          },
          component: () => import("../views/masters/subchannel.vue"),
        },
        {
          path: "/subchannel/add",
          name: "subchannel_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_CHANNEL",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/subchannel_add.vue"),
        },
        {
          path: "/subchannel/edit/:id",
          name: "subchannel_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_CHANNEL",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/subchannel_edit.vue"),
        },
        {
          path: "/category",
          name: "category",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CATEGORY",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Category",
          },
          component: () => import("../views/masters/category.vue"),
        },
        {
          path: "/category/add",
          name: "category_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CATEGORY",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/category_add.vue"),
        },
        {
          path: "/category/edit/:id",
          name: "category_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CATEGORY",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/category_edit.vue"),
        },

        {
          path: "/store",
          name: "store",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_STORE",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Store",
          },
          component: () => import("../views/masters/store.vue"),
        },
        {
          path: "/store/add",
          name: "store_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_STORE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/store_add.vue"),
        },
        {
          path: "/store/edit/:id",
          name: "store_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_STORE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/store_edit.vue"),
        },

        {
          path: "/service",
          name: "Service",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SERVICE",
            page_type: "landing",
            service: "Masters/ Ticket/ Service",
          },
          component: () => import("../views/masters/service.vue"),
        },

        {
          path: "/ticket",
          name: "Ticket",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/tickets/ticketIndex/newMain.vue"),
        },
        {
          path: "/tickets_report",
          name: "TicketReport",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_REPORTS",
            page_type: "landing",
          },
          component: () => import("../views/tickets/Reports/report_view.vue"),
        },
        {
          path: "/ticket/view/:id",
          name: "TicketView",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/tickets/ticket_drawer_assign.vue"),
        },

        {
          path: "/ticket/add",
          name: "TicketAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "add_screen",
          },
          component: () => import("../views/tickets/ticket_add.vue"),
        },

        {
          path: "/ticket/forward",
          name: "Ticketforward",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/tickets/ticket_forward.vue"),
        },

        {
          path: "/ticket/edit/:id",
          name: "TicketEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "edit_screen",
          },
          component: () => import("../views/tickets/ticket_edit.vue"),
        },

        {
          path: "/service/add",
          name: "ServiceAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SERVICE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/service_add.vue"),
        },

        {
          path: "/service/edit/:id",
          name: "ServiceEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SERVICE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/service_edit.vue"),
        },

        {
          path: "/serviceCategory",
          name: "ServiceCategory",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SERVICE_CATEGORY",
            page_type: "landing",
            servicecategory: "Masters/ Ticket/ Service Category",
          },
          component: () => import("../views/masters/Service_category.vue"),
        },

        {
          path: "/serviceCategory/add",
          name: "ServiceCategoryAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SERVICE_CATEGORY",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Service_category_add.vue"),
        },

        {
          path: "/serviceCategory/edit/:id",
          name: "ServiceCategoryEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SERVICE_CATEGORY",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Service_category_edit.vue"),
        },

        {
          path: "/designation",
          name: "Designation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            designation: "Masters/ Global/ Designation",
          },
          component: () => import("../views/masters/Designation.vue"),
        },

        {
          path: "/designation_mstr/add",
          name: "Designation_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Designation_add.vue"),
        },
        {
          path: "/role_assignments",
          name: "Role Assignments Screen",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
          },
          component: () => import("../views/masters/RoleAssignments.vue"),
        },

        {
          path: "/role_assignments/add",
          name: "Role Assignments Screen Add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/RoleAssignments_add.vue"),
        },
        {
          path: "/role_assignments/edit/:id",
          name: "Role Assignments Edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/RoleAssignments_edit.vue"),
        },
        {
          path: "/department_mstr/add",
          name: "Department_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Department_add.vue"),
        },
        {
          path: "/segment_mstr/add",
          name: "Segment_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Segment_add.vue"),
        },

        {
          path: "/branch_mstr/add",
          name: "Dashboard_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Dashboard_add.vue"),
        },

        {
          path: "/branch_mstr/edit/:id",
          name: "Dashboard_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Dashboard_edit.vue"),
        },
        {
          path: "/visittype/add",
          name: "Visittype_add",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_TYPE",
            page_code: "SCN_VISIT_TYPE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/visittype_add.vue"),
        },

        {
          path: "/visittype/edit/:id",
          name: "Visittype_edit",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_TYPE",
            page_code: "SCN_VISIT_TYPE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/visittype_edit.vue"),
        },

        {
          path: "/PurposeOfMeeting/add",
          name: "PurposeOfMeeting_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/PurposeOfMeeting_add.vue"),
        },

        {
          path: "/PurposeOfMeeting/edit/:id",
          name: "PurposeOfMeeting_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/PurposeOfMeeting_edit.vue"),
        },

        {
          path: "/department_mstr/edit/:id",
          name: "Department_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Department_edit.vue"),
        },
        {
          path: "/segment_mstr/edit/:id",
          name: "Segment_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Segment_edit.vue"),
        },

        {
          path: "/designation_mstr/edit/:id",
          name: "Designation_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Designation_edit.vue"),
        },
        {
          path: "/employee",
          name: "Employee",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "landing",
            employee: "Masters/ Global/ Empolyee",
          },
          component: () => import("../views/masters/Employee.vue"),
        },
        {
          path: "/employee_mstr/add",
          name: "Employee_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Employee_add.vue"),
        },
        {
          path: "/employee_mstr/edit/:id",
          name: "Employee_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Employee_edit.vue"),
        },
        {
          path: "/employee_mstr/view/:id",
          name: "Employee_view",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Employee_view.vue"),
        },
        {
          path: "/walkins/reports",
          name: "Walkins_reports",
          meta: {
            auth: true,
            screen_code: "SCN_WLK_RPRT",
            page_code: "SCN_WLK_RPRT",
            page_type: "landing",
          },
          component: () => import("../views/walkins_reports.vue"),
        },
        {
          path: "/walkin/landing",
          name: "Walkin_landing",
          meta: {
            auth: true,
            screen_code: "SCN_WALKINS",
            page_code: "SCN_WALKINS",
            page_type: "landing",
          },
          component: () => import("../views/walkin_landing.vue"),
        },
        {
          path: "/walkin/feedback",
          name: "Walkins_feedback",
          meta: {
            auth: true,
            screen_code: "SCN_WLKN_FEEDBACK",
            page_code: "SCN_WLKN_FEEDBACK",
            page_type: "landing",
            breadcrumb: "Settings / Walkins / Feedback",
          },
          component: () => import("../views/walkins_feedback.vue"),
        },
        {
          path: "/feedback/question/add",
          name: "Walkins_feedback_add",
          meta: {
            auth: true,
            screen_code: "SCN_WLKN_FEEDBACK",
            page_code: "SCN_WLKN_FEEDBACK",
            page_type: "add_screen",
          },
          component: () => import("../views/wlk_feedback_ques_add.vue"),
        },
        {
          path: "/feedback/question/edit/:id",
          name: "Walkins_feedback_edit",
          meta: {
            auth: true,
            screen_code: "SCN_WLKN_FEEDBACK",
            page_code: "SCN_WLKN_FEEDBACK",
            page_type: "edit_screen",
          },
          component: () => import("../views/wlk_feedback_ques_edit.vue"),
        },
        {
          path: "/feedback/results/:id",
          name: "Feedback_Result",
          meta: {
            auth: true,
            screen_code: "SCN_WLKN_FEEDBACK",
            page_code: "SCN_WLKN_FEEDBACK",
            page_type: "landing",
          },
          component: () => import("../views/wlk_feedback_result.vue"),
        },
        {
          path: "/feedback/reports",
          name: "Walkins_feedback_reports",
          meta: {
            auth: true,
            screen_code: "SCN_WLKN_FEEDBACK_RPRT",
            page_code: "SCN_WLKN_FEEDBACK_RPRT",
            page_type: "landing",
          },
          component: () => import("../views/wlk_feedback_report.vue"),
        },
        // pavithran
        {
          path: "/visits/landing",
          name: "visits_landing",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "landing",
          },
          component: () => import("../views/visits_landing.vue"),
        },
        //
        {
          path: "/visitReport",
          name: "visitreport",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_REPORTS",
            page_code: "SCN_VISIT_REPORTS",
            page_type: "landing",
          },
          component: () => import("../views/visit_report.vue"),
        },
        {
          path: "/attendance_landing",
          name: "attendance_landing",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "landing",
          },
          component: () => import("../views/Attendance/attendance.vue"),
        },
        {
          path: "/visits/attendance_report",
          name: "visits_attendance_report",
          meta: {
            auth: true,
            screen_code: "SCN_ATTENDANCE_REPORTS",
            page_code: "SCN_ATTENDANCE_REPORTS",
            page_type: "landing",
          },
          component: () =>
            import("../views/Attendance/chck_attendance_reports.vue"),
        },
        {
          path: "/plan",
          name: "plan",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "add_screen",
          },
          component: () => import("../views/plan_visit.vue"),
        },
        {
          path: "/logvisit",
          name: "visit",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "add_screen",
          },
          component: () => import("../views/log_visit.vue"),
        },
        {
          path: "/logvisit/add",
          name: "logvisit_add",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "add_screen",
          },
          component: () => import("../views/logvisit_add.vue"),
        },
        {
          path: "/logvisit/edit/:id",
          name: "logvisit_edit",
          meta: {
            auth: true,
            screen_code: "SCN_VISITS",
            page_code: "SCN_VISITS",
            page_type: "edit_screen",
          },
          component: () => import("../views/logvisit_edit.vue"),
        },
        {
          path: "/crm/landing",
          name: "Crm",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "landing",
          },
          component: () => import("../views/crm_landing.vue"),
        },
        {
          // Google Sheet → CRM lead sync: configure sheets, sync on demand,
          // and check the connection. Scheduled sync runs 6x daily.
          path: "/crm/sheet_sync",
          name: "CrmSheetSync",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "landing",
          },
          component: () => import("../views/crm_sheet_sync.vue"),
        },
        {
          path: "crm_add",
          name: "crm_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "add_screen",
          },
          component: () => import("../views/crm_add.vue"),
        },
        {
          path: "crm_edit/:id",
          name: "crm_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "edit_screen",
          },
          component: () => import("../views/crm_edit.vue"),
        },
        {
          path: "/lead_source/landing",
          name: "Lead Source",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "landing",
          },
          component: () => import("../views/lead_source_landing.vue"),
        },
        {
          path: "/lead_source/add",
          name: "Lead Source add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "add_screen",
          },
          component: () => import("../views/lead_source_add.vue"),
        },
        {
          path: "/lead_source/edit/:id",
          name: "Lead Source edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "edit_screen",
          },
          component: () => import("../views/lead_source_edit.vue"),
        },
        {
          path: "/wlk_campaign",
          name: "wlk_Campaign",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "landing",
            breadcrumb: "Masters / Walkins / Campaign",
          },
          component: () => import("../views/wlk_campaign.vue"),
        },
        {
          path: "/campaign/add",
          name: "Campaign_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "add_screen",
          },
          component: () => import("../views/campaign_add.vue"),
        },
        {
          path: "/occasion/landing",
          name: "Occasion",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "landing",
            breadcrumb: "Masters / Walkins / Occasion",
          },
          component: () => import("../views/occasion.vue"),
        },
        {
          path: "/occasion/add",
          name: "occasion_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "add_screen",
          },
          component: () => import("../views/occasion_add.vue"),
        },
        {
          path: "/occasion/edit/:id",
          name: "occasion_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "edit_screen",
          },
          component: () => import("../views/occasion_edit.vue"),
        },
        {
          path: "/campaign/edit/:id",
          name: "Campaign_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "add_screen",
          },
          component: () => import("../views/campaign_edit.vue"),
        },
        {
          path: "/seo_sm_manager",
          name: "SeoSmManager",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/seo_sm/SeoSmManager.vue"),
        },
        {
          path: "/employee_mstr/reporting",
          name: "Employee_Reporting",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMPLOYEE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/employee_reporting.vue"),
        },
        {
          path: "/scenarios",
          name: "Scenarios",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "landing",
          },
          component: () => import("../views/masters/scenarios.vue"),
        },
        {
          path: "/Trigger_Analytics",
          name: "Trigger_Analytics",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "landing",
            breadcrumb: "Setting / Global / Trigger Analytics",
          },
          component: () => import("../views/masters/Trigger_Analytics.vue"),
        },
        {
          path: "/scenarios/add",
          name: "Scenarios_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/scenarios_add.vue"),
        },
        {
          path: "/scenarios/edit/:id",
          name: "scenarios_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/scenarios_edit.vue"),
        },
        {
          path: "/esclation",
          name: "Esclation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_MAIL_CONFIGURATION",
            page_type: "landing",
            breadcrumb: "Settings / Global / Mail Configuration",
          },
          component: () => import("../views/masters/esclation.vue"),
        },
        {
          path: "/esclation/edit/:id",
          name: "Esclation_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_MAIL_CONFIGURATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/esclation_notify.vue"),
        },
        {
          path: "/users",
          name: "Users",
          meta: {
            auth: true,
            screen_code: "CREATE_USERS",
            page_code: "SCN_USERS",
            page_type: "landing",
            breadcrumb: "Settings / Users",
          },
          component: () => import("../views/masters/Users.vue"),
        },
        {
          path: "/familybook/users",
          name: "FamilyUsers",
          meta: {
            auth: true,
            screen_code: "CREATE_USERS",
            page_code: "SCN_USERS",
            page_type: "landing",
            breadcrumb: "Settings / Users",
          },
          component: () => import("../views/masters/Users.vue"),
        },
        {
          path: "/password_portal",
          name: "password_portal",
          meta: {
            auth: true,
            screen_code: "CREATE_USERS",
            page_code: "SCN_PASSWORD_PORTAL",
            page_type: "landing",
            breadcrumb: "Setting / Users / Password Portal",
          },
          component: () => import("../views/masters/password_portal.vue"),
        },
        {
          path: "/function",
          name: "Function",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/function.vue"),
        },
        {
          path: "/function/add",
          name: "Function_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/function_add.vue"),
        },
        {
          path: "/function/edit/:id",
          name: "Function_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SCENARIOS",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/function_edit.vue"),
        },
        {
          path: "/incentive",
          name: "Incentive",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PAYROLL",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Payroll",
          },
          component: () => import("../views/masters/incentive.vue"),
        },
        {
          path: "/incentive/add",
          name: "AddIncentive",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PAYROLL",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/incentive_add.vue"),
        },
        {
          path: "/incentive/edit/:id",
          name: "EditIncentive",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PAYROLL",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/incentive_edit.vue"),
        },
        {
          path: "/incentive/view/:id",
          name: "ViewIncentive",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PAYROLL",
            page_type: "landing",
          },
          component: () => import("../views/masters/incentive_view.vue"),
        },

        {
          path: "/users_mstr/add",
          name: "Users_add",
          meta: {
            auth: true,
            screen_code: "CREATE_USERS",
            page_code: "SCN_USERS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Users_add.vue"),
        },
        {
          path: "/users_mstr/edit/:id",
          name: "Users_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_USERS",
            page_code: "SCN_USERS",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Users_edit.vue"),
        },
        {
          path: "/master_checklist",
          name: "MasterChecklist",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/master_checklist.vue"),
        },
        {
          path: "/master_checklist/add",
          name: "AddMasterChecklist",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/master_checklist_add.vue"),
        },
        {
          path: "/master_checklist/edit/:id",
          name: "EditMasterChecklist",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/master_checklist_edit.vue"),
        },

        {
          path: "/master_checklist_tasks/:id",
          name: "master_checklist_tasks",
          meta: {
            auth: true,
          },
          component: () => import("../views/master_checklist/tasks/tasks.vue"),
        },

        // Tasks
        {
          path: "/checklist_tasks/add/:id",
          name: "AddChecklistTasks",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/tasks/tasks_add.vue"),
        },
        {
          path: "/checklist_tasks/edit/:id/:mstr_chk_id",
          name: "EditChecklistTasks",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/tasks/tasks_edit.vue"),
        },

        // Subtasks

        {
          path: "/master_checklist_subtasks/:id",
          name: "master_checklist_subtasks",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/subtasks/subtasks.vue"),
        },
        {
          path: "/chcklist_subtasks/add/:id",
          name: "AddChcklistSubtasks",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/subtasks/subtasks_add.vue"),
        },
        {
          path: "/chcklist_subtasks/edit/:id/:task_id",
          name: "EditChcklistSubtasks",
          meta: {
            auth: true,
          },
          component: () =>
            import("../views/master_checklist/subtasks/subtasks_edit.vue"),
        },
        {
          path: "/client",
          name: "Client",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Client.vue"),
        },
        {
          path: "/client_subscription_logs/:id",
          name: "ClientSubscriptionLogs",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ClientSubscriptionLogs.vue"),
        },
        {
          path: "/Assets",
          name: "Assets",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/masters/assets.vue"),
        },
        {
          path: "/lead_landing",
          name: "Lead",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/lead_landing.vue"),
        },
        {
          path: "lead_add",
          name: "lead_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/lead_add.vue"),
        },
        {
          path: "lead_edit/:id",
          name: "Lead_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/lead_edit.vue"),
        },
        {
          path: "/campaign_landing",
          name: "Lead Campaign",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/campaign_landing.vue"),
        },
        {
          path: "/lead_source_landing",
          name: "Lead Source",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/lead_source_landing.vue"),
        },
        // Jewellery Ledger Mapping Route
        {
          path: "/jewellery_ledger_mapping_tree",
          name: "jewellery_ledger_mapping_tree",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/ThirdPartyAPI/Jewellery/jewellery_ledger_mapping_tree.vue"
            ),
        },
        // Trade Ledger Mapping Route
        {
          path: "/trade_ledger_mapping_tree",
          name: "trade_ledger_mapping_tree",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/ThirdPartyAPI/Trade/trade_ledger_mapping_tree.vue"
            ),
        },

        {
          path: "/ledger_mapping",
          name: "ledger_mapping",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ThirdPartyAPI/ledger_mapping.vue"),
        },
        // Zoho CRM Configuration Routes
        {
          path: "/zoho_config_landing",
          name: "zoho_config_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/ZohoConfig/zoho_config_landing.vue"),
        },
        {
          path: "/zoho_config_add",
          name: "zoho_config_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/ZohoConfig/zoho_config_add.vue"),
        },
        {
          path: "/zoho_config_edit/:id",
          name: "zoho_config_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/ZohoConfig/zoho_config_edit.vue"),
        },
        {
          path: "/zoho_config_view/:id",
          name: "zoho_config_view",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/ZohoConfig/zoho_config_view.vue"),
        },
        // API Configuration Routes
        {
          path: "/api_config_landing",
          name: "api_config_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ThirdPartyAPI/ApiConfig/api_config_landing.vue"),
        },
        {
          path: "/api_config_add",
          name: "api_config_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ThirdPartyAPI/ApiConfig/api_config_add.vue"),
        },
        {
          path: "/api_config_edit/:id",
          name: "api_config_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ThirdPartyAPI/ApiConfig/api_config_edit.vue"),
        },
        {
          path: "/api_config_view/:id",
          name: "api_config_view",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ThirdPartyAPI/ApiConfig/api_config_view.vue"),
        },
        {
          path: "/xero_config_landing",
          name: "xero_config_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/XeroConfig/xero_config_landing.vue"),
        },
        {
          path: "/xero_config_add",
          name: "xero_config_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/XeroConfig/xero_config_add.vue"),
        },
        {
          path: "/xero_config_edit/:id",
          name: "xero_config_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/XeroConfig/xero_config_edit.vue"),
        },
        {
          path: "/xero_config_view/:id",
          name: "xero_config_view",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/ThirdPartyAPI/XeroConfig/xero_config_view.vue"),
        },
        {
          path: "/subscription_plans",
          name: "subscription_plans",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/subscription/subscription_plans.vue"),
        },
        {
          path: "/marketing/leads-landing",
          name: "leads_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/marketing/leads_dashboard.vue"),
        },
        {
          path: "/marketing/leads",
          name: "leads_dashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/marketing/leads_dashboard.vue"),
        },
        {
          path: "/marketing/healthchecks",
          name: "healthcheck_admin",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/marketing/healthcheck_admin.vue"),
        },
        {
          path: "/modules",
          name: "modules",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/modules/modules.vue"),
        },
        {
          path: "/addmodules",
          name: "addmodules",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/modules/addmodules.vue"),
        },

        {
          path: "/editmodules/:id",
          name: "editmodules",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/modules/editmodules.vue"),
        },
        {
          path: "/addscreen",
          name: "addscreen",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/modules/addscreen.vue"),
        },
        {
          path: "/editscreen/:id",
          name: "editscreen",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/modules/editscreen.vue"),
        },
        {
          path: "/image",
          name: "Image",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Image.vue"),
        },

        {
          path: "/product",
          name: "Products",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Product.vue"),
        },
        {
          path: "/show_list",
          name: "Show List",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/show_list.vue"),
        },
        {
          path: "/my_work",
          name: "My Work",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/MyWork.vue"),
        },
        {
          path: "/my_work_inbox",
          name: "My Work Inbox",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/MyWorkMail.vue"),
        },
        {
          path: "/welcome_page",
          name: "Welcome Page",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/FMS/welcome_page.vue"),
        },
        {
          path: "/tasks_detail",
          name: "tasks_detail",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/tasks_detail/checklist_detail.vue"),
        },
        {
          path: "/tasks_detail_mobile",
          name: "tasks_detail_mobile",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/tasks_detail/checklist_detail_mobile.vue"),
        },

        {
          path: "/Dashboard_checklist",
          name: "Dashboard",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/Dashboard1.vue"),
        },
        {
          path: "/Industry",
          name: "Industry",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Industry.vue"),
        },

        {
          path: "/process",
          name: "Process",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Process.vue"),
        },
        {
          path: "/MainBoard_Designation",
          name: "Check List New",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () =>
            import("../views/master_checklist/checklist/MainChecklist_new.vue"),
        },
        {
          path: "/MainChecklist",
          name: "Check List",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () =>
            import("../views/master_checklist/checklist/MainChecklist.vue"),
        },
        {
          path: "/MyTasks",
          name: "My Check List",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/show_list_bulk_update_Task.vue"),
        },
        {
          path: "/uichanges",
          name: "My Checklist - New UI",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/master_checklist/checklist/MainChecklistuichanges.vue"
            ),
        },
        // checklist_Template_page
        {
          path: "/checklist_Template_page",
          name: "checklist_Template_page",
          meta: {
            auth: true,
            screen_code: "ADOPT_CHK",
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "../views/master_checklist/checklist_typ/checklist_Template_page.vue"
            ),
        },
        {
          path: "/Case_Based_Checklist",
          name: "Case Based Checklist",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_CASE_BASED",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/master_checklist/case_Based/Case_Based_Checklist.vue"
            ),
        },
        {
          path: "/showlist_all_report",
          name: "Reports",
          meta: {
            auth: true,
            screen_code: "RUN_REPORTS",
            page_code: "SCN_CHCK_REPORTS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/master_checklist/reports/showlist_all_report_new.vue"
            ),
        },
        {
          path: "/dynamicFormDetails",
          name: "dynamicFormDetails",
          meta: {
            auth: true,
            screen_code: "RUN_REPORTS",
            page_code: "SCN_CHCK_REPORTS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/master_checklist/checklist/dynamicFormDetails.vue"
            ),
        },
        //
        // budget

        {
          path: "/budget",
          name: "budget",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () => import("../views/Budget/budget.vue"),
        },

        {
          path: "/chatwindow",
          name: "chatwindow",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () => import("../views/chatdetails/chatwindow.vue"),
        },

        {
          path: "/weeklycountreport",
          name: "weeklycountreport",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () => import("../views/reports/weeklycountreport.vue"),
        },

        {
          path: "/budget/add",
          name: "budget_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "add_screen",
          },
          component: () => import("../views/Budget/budget_add.vue"),
        },
        {
          path: "/budget/edit/:id",
          name: "budget_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "add_screen",
          },
          component: () => import("../views/Budget/budget_edit.vue"),
        },
        {
          path: "/budget_reports",
          name: "budget_reports",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "add_screen",
          },
          component: () => import("../views/Budget/budget_reports.vue"),
        },
        //
        {
          path: "/actual",
          name: "actual",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ACTUAL",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () => import("../views/actual/actual.vue"),
        },
        {
          path: "/actual/add",
          name: "actual_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ACTUAL",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/actual_add.vue"),
        },
        {
          path: "/actual/edit/:id",
          name: "actual_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ACTUAL",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/actual_edit.vue"),
        },
        {
          path: "/actual_reports",
          name: "actual_reports",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ACTUAL",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/actual_reports.vue"),
        },
        {
          path: "/budget_new",
          component: () => import("../views/Budget_New/budget_new.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "budget_new", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "active", name: "budget-active", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "inactive", name: "budget-inactive", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
          ],
        },

        {
          path: "/actual_new",
          component: () => import("../views/Actual_New/actualNewUI.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "actual_new", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "active", name: "actual-active", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "inactive", name: "actual-inactive", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
          ],
        },

        {
          path: "/profitability_improvement",
          name: "profitability_improvement",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ACTUAL",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "../views/Financial Dashboards/Profitability_Improvement.vue"
            ),
        },

        {
          path: "/cashflow_management",
          name: "cashflow_management",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CASHFLOW",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/Cashflow_Management.vue"),
        },

        {
          path: "/networth_monitoring",
          name: "networth_monitoring",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_NETWORTH",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/Networth_Monitoring.vue"),
        },

        {
          path: "/working_capital_management",
          name: "working_capital_management",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WORKING_CAPITAL",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "../views/Financial Dashboards/Working_Capital_Management.vue"
            ),
        },

        {
          path: "/efficiency_improvement",
          name: "efficiency_improvement",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EFFICIENCY",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/Efficiency_Improvement.vue"),
        },

        {
          path: "/red_flags_books",
          name: "red_flags_books",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_RED_FLAGS",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/Red_Flags_Books.vue"),
        },

        {
          path: "/financial_performance_dashboard",
          name: "financial_performance_dashboard",
          redirect: "/financial_performance_dashboard/executive",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_FINANCIAL_PERFORMANCE_DASHBOARD",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/financialPerformanceExicuteDashboard.vue"),
          children: [
            {
              path: "executive",
              name: "fpd_executive",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/ExecutiveDashboard.vue"),
            },
            {
              path: "profitability",
              name: "fpd_profitability",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/ProfitabilityTab.vue"),
            },
            {
              path: "profitability-analysis",
              name: "fpd_profitability_analysis",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/ProfitabilityAnalysis.vue"),
            },
            {
              path: "liquidity",
              name: "fpd_liquidity",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/LiquidityTab.vue"),
            },
            {
              path: "cashflow",
              name: "fpd_cashflow",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Cashflow_Management.vue"),
            },
            {
              path: "leverage-solvency",
              name: "fpd_leverage_solvency",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/LeverageSolvencyTab.vue"),
            },
            {
              path: "working-capital",
              name: "fpd_working_capital",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Working_Capital_Management.vue"),
            },
            {
              path: "network-monitoring",
              name: "fpd_network_monitoring",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Networth_Monitoring.vue"),
            },
            {
              path: "efficiency-improvement",
              name: "fpd_efficiency_improvement",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Efficiency_Improvement.vue"),
            },
            {
              path: "benchmarks",
              name: "fpd_benchmarks",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/BenchmarksTab.vue"),
            },
            {
              path: "ai-advisory",
              name: "fpd_ai_advisory",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/AIAdvisoryTab.vue"),
            },
            {
              path: "data-source",
              name: "fpd_data_source",
              meta: { auth: true, isnoadmintoshow: true },
              component: () =>
                import("../views/Financial Dashboards/Financial Performance Dashboard/DataSourceTab.vue"),
            },
          ],
        },

        {
          path: "/report_builder_ui",
          name: "report_builder_ui",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_REPORT_BUILDER_UI",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/reportBuilderUi.vue"),
        },

        {
          path: "/employee_dashboard_ui",
          name: "employee_dashboard_ui",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_EMPLOYEE_DASHBOARD_UI",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/employeeDashboardUi.vue"),
        },

        {
          path: "/profile_dashboard",
          component: () =>
            import("../views/Financial Dashboards/profile_dashboard.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_PROFILE_DASHBOARD",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "profile_dashboard", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "roles", name: "profile_dashboard-roles", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "skills", name: "profile_dashboard-skills", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "kpi", name: "profile_dashboard-kpi", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "appr", name: "profile_dashboard-appr", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "team", name: "profile_dashboard-team", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "ai", name: "profile_dashboard-ai", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "tasks", name: "profile_dashboard-tasks", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
            { path: "feedback", name: "profile_dashboard-feedback", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCRN_PROFILE_DASHBOARD", page_type: "landing", isnoadmintoshow: true } },
          ],
        },

        {
          path: "/exicute_summary_dashboard_ui",
          name: "exicute_summary_dashboard_ui",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_EXICUTE_SUMMARY_DASHBOARD_UI",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Financial Dashboards/exicuteSummaryDashboardUi.vue"),
        },

        {
          path: "/mandate_board_dashboard",
          name: "mandate_board_dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_BOARD_DASHBOARD",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Mandate_dashboard.vue"),
        },

        {
          path: "/mandate_all_mandates",
          name: "mandate_all_mandates",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_ALL_MANDATES",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/All_Mandate.vue"),
        },

        {
          path: "/mandate_escalation_matrix",
          name: "mandate_escalation_matrix",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_ESCALATION_MATRIX",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Escalation_Matrix.vue"),
        },

        {
          path: "/mandate_emp_ticket_escalation",
          name: "mandate_emp_ticket_escalation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_EMP_ESCALATION",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Emp_Ticket_Escalation.vue"),
        },

        {
          path: "/mandate_escalated",
          name: "mandate_escalated",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_ESCALATED",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Escalated_Mandate.vue"),
        },

        {
          path: "/mandate_analytics",
          name: "mandate_analytics",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_ANALYTICS",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Mandate_Analytics.vue"),
        },

        {
          path: "/mandate_tickets_report",
          name: "mandate_tickets_report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_TICKETS_REPORT",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Mandate_Tickets_Report.vue"),
        },

        {
          path: "/mandate_flow",
          name: "mandate_flow",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_MANDATE_FLOW",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Mandate_Board/Mandate_Flow.vue"),
        },

        {
          path: "/budget_vs_actual_reports",
          component: () =>
            import("../views/Actual_New/budget_vs_actual_reports.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "budget_vs_actual_reports", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "p-and-l", name: "bva-P_AND_L", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "stock", name: "bva-STOCK", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "balance-sheet", name: "bva-BALANCE_SHEET", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
            { path: "cash-flow", name: "bva-CASH_FLOW", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_BUDGET", page_type: "landing", isnoadmintoshow: true } },
          ],
        },

        {
          path: "/media",
          name: "media",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/Media/media.vue"),
        },
        {
          path: "/media_page_config_landing",
          name: "MediaPageConfig",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
          },
          component: () =>
            import("../views/media_page/media_page_config_landing.vue"),
        },
        {
          path: "/health_check",
          name: "health_check",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/health_check.vue"),
        },
        {
          path: "/health_check_report",
          name: "health_check_report",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/health_check_report.vue"),
        },
        {
          path: "/health_check_view_answers/:customer_id/:version/:sub_domain",
          name: "health_check_view_answers",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/actual/health_check_view_answers.vue"),
        },
        {
          path: "/health_check_invite_details",
          name: "health_check_invite_details",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/actual/health_check_invite_details.vue"),
        },
        {
          path: "/health_check_answer/:industry/:country/:version/:question_type/:customer_type/:customer_id",
          name: "health_check_answer",
          meta: {
            auth: false,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () => import("../views/actual/health_check_answer.vue"),
        },
        // /:version/:question_type/:customer_type/:customer_id
        {
          path: "/health_check_home_screen/:version/:question_type/:customer_type/:customer_id",
          name: "health_check_home_screen",
          meta: {
            auth: false,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/health_check_home_screen.vue"),
        },
        {
          path: "/admin_health_check_homescreen",
          name: "admin_health_check_homescreen",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/admin_health_check_homescreen.vue"),
        },
        {
          path: "/admin_homescreen_operational",
          name: "admin_homescreen_operational",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/admin_homescreen_operational.vue"),
        },
        {
          path: "/completion_screen_health_check/:version/:customer_id/:question_type/:country/:industry_name",
          name: "completion_screen_health_check",
          meta: {
            auth: false,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/completion_screen_health_check.vue"),
        },

        {
          path: "/admin_completion_screen_health_check/:version/:customer_id/:question_type/:country/:industry_name",
          name: "admin_completion_screen_health_check",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/admin_completion_screen_health_check.vue"),
        },
        {
          path: "/customer_list_bis_hlth",
          name: "customer_list_bis_hlth",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/customer_list_bis_hlth.vue"),
        },

        // Feartues
        {
          path: "/feature",
          name: "feature",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
          },
          component: () => import("../views/feature/feature.vue"),
        },
        {
          path: "/feature/add",
          name: "feature_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
          },
          component: () => import("../views/feature/feature_add.vue"),
        },

        {
          path: "/feature/edit/:id",
          name: "feature_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
          },
          component: () => import("../views/feature/feature_edit.vue"),
        },
        {
          path: "/role",
          name: "role",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ROLE",
            page_type: "landing",
            isnoadmintoshow: true,
            breadcrumb: "Settings / Global / Role",
          },
          component: () => import("../views/role/role.vue"),
        },
        {
          path: "/role/add",
          name: "role_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ROLE",
            page_type: "add_screen",
          },
          component: () => import("../views/role/role_add.vue"),
        },
        {
          path: "/role/edit/:id",
          name: "role_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ROLE",
            page_type: "edit_screen",
          },
          component: () => import("../views/role/role_edit.vue"),
        },
        // holiday
        {
          path: "/holiday",
          name: "holiday",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_HOLIDAY",
            page_type: "landing",
            breadcrumb: "Settings / Global / Holiday",
          },
          component: () => import("../views/holiday/holiday.vue"),
        },
        {
          path: "/holiday/add",
          name: "holiday_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_HOLIDAY",
            page_type: "add_screen",
          },
          component: () => import("../views/holiday/holiday_add.vue"),
        },
        {
          path: "/holiday/edit/:id",
          name: "holiday_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_HOLIDAY",
            page_type: "edit_screen",
          },
          component: () => import("../views/holiday/holiday_edit.vue"),
        },
        {
          path: "/slab",
          name: "slab",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "landing",
            breadcrumb: "Settings / Global / Slab",
          },
          component: () => import("../views/masters/slab.vue"),
        },
        {
          path: "/slab/add",
          name: "slabAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "landing",
          },
          component: () => import("../views/masters/slab_add.vue"),
        },
        {
          path: "/designation_setting",
          name: "designation_setting",
          meta: {
            auth: true,
            screen_code: "SCN_WALKINS",
            page_code: "SCN_WALKINS",
            page_type: "add_screen",
            breadcrumb: "Settings / Walkins / Manager Setting",
          },
          component: () => import("../views/masters/walkin_setting.vue"),
        },
        {
          path: "/designation_setting_add",
          name: "designation_setting_add",
          meta: {
            auth: true,
            screen_code: "SCN_WALKINS",
            page_code: "SCN_WALKINS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/designation_setting.vue"),
        },
        {
          path: "/sales_landing",
          name: "sales_landing",
          meta: {
            auth: true,
            screen_code: "SCN_WALKINS",
            page_code: "SCN_WALKINS",
            page_type: "add_screen",
            breadcrumb: "Settings / Walkins / Salesman Setting",
          },
          component: () => import("../views/masters/sales_landing.vue"),
        },
        {
          path: "/sales_setting",
          name: "sales_setting",
          meta: {
            auth: true,
            screen_code: "SCN_WALKINS",
            page_code: "SCN_WALKINS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/sales_setting.vue"),
        },
        {
          path: "/slab/edit/:id",
          name: "slabEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "landing",
          },
          component: () => import("../views/masters/slab_edit.vue"),
        },
        {
          path: "/slab/ticket/edit/:id",
          name: "slabtktEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "landing",
          },
          component: () => import("../views/masters/slabticket_edit.vue"),
        },
        {
          path: "/slab/ticket/add",
          name: "slabtktAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "landing",
          },
          component: () => import("../views/masters/slabticket_add.vue"),
        },
        {
          path: "/SlaScore",
          name: "SlaScore",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/Mandate_Board/Sla_Score_Page.vue"),
        },
        {
          path: "/weekoff",
          name: "WeekOff",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "landing",
            breadcrumb: "Settings / Global / Week Off",
          },
          component: () => import("../views/masters/weekoff.vue"),
        },
        {
          path: "/weekoff/add",
          name: "AddWeekOff",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/weekoff_add.vue"),
        },
        {
          path: "/weekoff/edit/:id",
          name: "EditWeekOff",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_WEEKOFF",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/weekoff_edit.vue"),
        },
        {
          path: "/organization_chart",
          name: "organization_chart",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () => import("../views/organization_chart.vue"),
        },

        {
          path: "/orgchart_sample",
          name: "orgchart_sample",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "sample",
          },
          component: () => import("../views/orgchart_sample.vue"),
        },
        {
          path: "/org_ui_new",
          name: "org_ui_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "sample",
          },
          component: () => import("../views/org_ui_new.vue"),
        },
        {
          path: "/org_chart_dashboard",
          component: () => import("../views/org_chart_DashboardNew.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "sample",
          },
          children: [
            { path: "", name: "org_chart_dashboard", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_ORG_CHART", page_type: "sample" } },
            { path: "chart", name: "org_chart_dashboard-chart", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_ORG_CHART", page_type: "sample" } },
            { path: "table", name: "org_chart_dashboard-table", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_ORG_CHART", page_type: "sample" } },
            { path: "integrations", name: "org_chart_dashboard-integrations", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_ORG_CHART", page_type: "sample" } },
          ],
        },
        {
          path: "/kpi_bots",
          name: "kpi_bots",
          meta: {
            auth: true,
            screen_code: "SCN_ANALYTICS",
            page_code: "SCN_ANALYTICS",
            page_type: "landing",
          },
          component: () => import("../views/kpi_bots.vue"),
        },
        {
          path: "/business_intelligence",
          name: "business_intelligence",
          meta: {
            auth: true,
            screen_code: "SCN_BUSINESS_INTELLIGENCE",
            page_code: "SCN_BUSINESS_INTELLIGENCE",
            page_type: "landing",
          },
          component: () => import("../views/businessIntelligence.vue"),
        },
        {
          path: "/kpi_bots_common_analytics",
          name: "kpi_bots_common_analytics",
          meta: {
            auth: true,
            screen_code: "SCN_ANALYTICS",
            page_code: "SCN_ANALYTICS",
            page_type: "landing",
          },
          component: () => import("../views/kpi_bots_common_analytics.vue"),
        },

        // Common Analytics IFrame Integration
        {
          path: "/common-analytics",
          name: "common_analytics",
          meta: {
            auth: true,
            screen_code: "SCN_COMMON_ANALYTICS",
            page_code: "SCN_COMMON_ANALYTICS",
            page_type: "landing",
            breadcrumb: "Common Analytics",
          },
          component: () =>
            import("../views/common_analytics/CommonAnalyticsWrapper.vue"),
        },
        {
          path: "/common-analytics/*",
          name: "common_analytics_subroute",
          meta: {
            auth: true,
            screen_code: "SCN_COMMON_ANALYTICS",
            page_code: "SCN_COMMON_ANALYTICS",
            page_type: "landing",
            breadcrumb: "Common Analytics",
          },
          component: () =>
            import("../views/common_analytics/CommonAnalyticsWrapper.vue"),
        },

        {
          path: "/sales_dashboard",
          name: "sales_dashboard",
          meta: {
            auth: true,
            screen_code: "SCN_SALES_DASHBOARD",
            page_code: "SCN_SALES_DASHBOARD",
            page_type: "landing",
          },
          component: () => import("../views/sales_dashboard.vue"),
        },
        {
          path: "/meetings",
          name: "meetings",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () => import("../views/meeting_statutory.vue"),
        },
        {
          path: "/meetings_new",
          name: "meetings_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () => import("../views/meeting_landing.vue"),
        },
        {
          path: "/meeting_dashboard_new",
          name: "meeting_dashboard_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () =>
            import("../views/Meeting_dashboard_new_module.vue"),
        },
        {
          path: "/past_meeting_pdf_content",
          name: "past_meeting_pdf_content",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () => import("../views/past_meeting_pdf_content.vue"),
        },
        {
          path: "/past_meeting_pdf_content_download",
          name: "past_meeting_pdf_content_download",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () =>
            import("../views/past_meeting_pdf_content_download.vue"),
        },
        {
          path: "/kpi/mapping",
          name: "kpi_mapping",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () => import("../views/kpiMapping/kpi_mapping.vue"),
        },
        {
          path: "/kpi/push",
          name: "kpi_push",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ORG_CHART",
            page_type: "landing",
          },
          component: () => import("../views/kpiMapping/kpi_push.vue"),
        },
        {
          path: "appraisal",
          name: "Appraisal",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            isnoadmintoshow: true,
          },
          component: () => import("../views/masters/Appraisal.vue"),
        },
        {
          path: "/appraisal_add",
          name: "appraisal",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRAISAL_SET_APPRAISAL_CYCLE",
            isnoadmintoshow: true,
          },
          component: () => import("../views/masters/AddAppraisal.vue"),
        },
        {
          path: "/My_profile",
          name: "My_profile",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            isnoadmintoshow: true,
          },
          component: () => import("../views/My_Profile.vue"),
        },
        {
          path: "/Calendar",
          name: "Calendar",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            isnoadmintoshow: true,
          },
          component: () => import("../views/Calendar.vue"),
        },

        {
          path: "/appraisal_launch",
          name: "appraisal_launch",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRAISAL_VIEW_APPRAISAL",
            isnoadmintoshow: true,
            appraisal: "Masters/ Performance/ ViewAppraisals",
          },
          component: () => import("../views/masters/AppraisalLaunch.vue"),
        },
        {
          path: "/appraisal_launch/editappraisal",
          name: "appraisal_launch_editappraisal",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            isnoadmintoshow: true,
          },
          component: () => import("../views/masters/editappraisal.vue"),
        },
        {
          path: "/kpiroles",
          name: "kpiroles",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/kpiroles.vue"),
        },
        {
          path: "/templatelibrary",
          name: "templatelibrary",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
          },
          component: () =>
            import(
              "../views/master_checklist/checklist_typ/templatelibrary.vue"
            ),
        },
        {
          path: "/kpi_additions",
          name: "kpi_additions",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_KPI_ADDITION",
            page_type: "landing",
            kpiaddition: "Masters/ Kpi_Addition",
          },
          component: () => import("../views/kpilist/kpi_additions.vue"),
        },
        {
          path: "/kpi_impact_landing",
          name: "kpi_impact",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/KPI_SETUP.vue"),
        },
        {
          path: "/kpi_impact_detailed_view",
          name: "kpi_impact_detailed_view",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/kpi_impact_detailed_view.vue"),
        },
        {
          path: "/kpi_impact_chart_percentage_view",
          name: "kpi_impact_chart_percentage_view",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/kpi_impact_chart_percentage_view.vue"),
        },
        {
          path: "/chart_of_accounts",
          name: "Chart of Accounts",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_CHART_OF_ACCOUNTS",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/chart_of_accounts.vue"),
        },
        {
          path: "/kpi_impact_add",
          name: "kpi_impact_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_impact_add.vue"),
        },
        {
          path: "/kpi_impact_tree",
          name: "kpi_impact_tree",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_impact_tree.vue"),
        },
        {
          path: "/kpi_impact_tree_new",
          name: "kpi_impact_tree_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_impact_tree_new.vue"),
        },
        {
          path: "/kpi_impact_edit/:id",
          name: "kpi_impact_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_impact_edit.vue"),
        },
        {
          path: "/kpi_additions_edit/:id",
          name: "kpi_additions_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_KPI_ADDITION",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/kpi_addition_edit_tenant.vue"),
        },
        {
          path: "/kpi_addition_tenant",
          name: "kpi_addition_tenant",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_KPI_ADDITION",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_addition_tenent.vue"),
        },
        {
          path: "/kpi_settings",
          name: "kpi_settings",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_SETTING",
            page_type: "add_screen",
          },
          component: () => import("../views/kpilist/kpi_settings_add.vue"),
        },
        {
          path: "/kpi_settings_landing",
          name: "kpi_settings_landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_SETTING",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_settings_landing.vue"),
        },
        {
          path: "/kpi_settings_edit/:id",
          name: "kpi_settings_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_SETTING",
            page_type: "edit_screen",
          },
          component: () => import("../views/kpilist/kpi_settings_edit.vue"),
        },
        {
          path: "/employee_kpi",
          name: "employee_kpi",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/employee_kpi.vue"),
        },
        {
          path: "/dashboard_home_employee_kpi",
          name: "dashboard_home_employee_kpi",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/dashboard_home_employee_kpi.vue"),
        },

        // {
        //     path: '/assign_kpi',
        //     name: 'assign_kpi',
        //     meta: {
        //         auth: true,
        //         screen_code: 'CREATE_MASTERS'
        //     },
        //     component: () => import ('../views/kpilist/assign_kpi.vue')
        // },
        {
          path: "/set_weightage",
          name: "set_weightage",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_WEIGHTAGE",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/set_weightage/set_weightage.vue"),
        },
        {
          path: "/set_weightage_add",
          name: "set_weightage_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_WEIGHTAGE",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/kpilist/set_weightage/set_weightage_add.vue"),
        },
        {
          path: "/profile",
          name: "profile",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/appraisal/landing.vue"),
        },
        {
          path: "/tkt_service_category",
          name: "tkt_service_category",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/masters/tkt_service_category.vue"),
        },
        {
          path: "/process_mstr",
          name: "process_mstr",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PROCESS",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/process_mstr.vue"),
        },
        {
          path: "/set_target",
          name: "set_target",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/Targets_Actuals/TargetsOnly/set_target.vue"
            ),
        },
        {
          path: "/incentives",
          name: "Incentives",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_POLICY",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/incentive/incentive_landing.vue"),
        },
        {
          path: "/set_incentive",
          name: "Set Incentives",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_POLICY",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/incentive/set_incentive_main.vue"),
        },
        {
          path: "/functions_scores",
          name: "Functions Scores",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FUNCTIONS_SCORES",
            page_type: "landing",
            breadcrumb: "Functions Scores",
          },
          component: () =>
            import("../views/kpilist/incentive/functions_scores.vue"),
        },
        {
          path: "/team_scores",
          name: "Team Scores",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_TEAM_SCORES",
            page_type: "landing",
            breadcrumb: "Team Scores",
          },
          component: () =>
            import("../views/kpilist/incentive/team_scores.vue"),
        },
         {
          path: "/business_scores",
          name: "Business Scores",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUSINESS_SCORES",
            page_type: "landing",
            breadcrumb: "Business Scores",
          },
          component: () =>
            import("../views/kpilist/incentive/business_scores.vue"),
        },
        {
          path: "/naga_employee_incentives",
          name: "NAGA Employee Incentives",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_NAGA_EMPLOYEE_INCENTIVES",
            page_type: "landing",
            breadcrumb: "NAGA Employee Incentives",
          },
          component: () =>
            import("../views/kpilist/incentive/naga_employee_incentives.vue"),
        },
        {
          path: "/naga_incentive_summary",
          name: "NAGA Incentive Summary",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_INCENTIVE_SUMMARY",
            page_type: "landing",
            breadcrumb: "NAGA Incentive Summary",
          },
          component: () =>
            import("../views/kpilist/incentive/naga_incentive_summary.vue"),
        },
        {
          path: "/set_frequency",
          name: "set_frequency",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_SET_FREQUENCY",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/set_frequency/set_frequency_landing.vue"),
        },
        {
          path: "/set_frequency_main",
          name: "set_frequency_main",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_SET_FREQUENCY",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/set_frequency/set_frequency_main.vue"),
        },
        {
          path: "/performance_rating",
          name: "performance_rating",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
            breadcrumb: "Masters / Performance / Performance Rating",
          },
          component: () => import("../views/masters/performance_rating.vue"),
        },
        {
          path: "/base_performance",
          name: "base_performance",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
            breadcrumb: "Settings / Performance / Base Performance",
          },
          component: () => import("../views/masters/base_performance.vue"),
        },
        {
          path: "/base_performance/add",
          name: "base_performance_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () => import("../views/masters/base_performance_add.vue"),
        },
        {
          path: "/base_performance/edit/:id",
          name: "base_performance_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () => import("../views/masters/base_performance_edit.vue"),
        },
        {
          path: "/module_rights/:id",
          name: "module_rights",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ROLE",
            page_type: "edit_screen",
            isnoadmintoshow: true,
          },
          component: () => import("../views/role/module_rights.vue"),
        },
        {
          path: "/screen_rights/:id",
          name: "screen_rights",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ROLE",
            page_type: "edit_screen",
            isnoadmintoshow: true,
          },
          component: () => import("../views/role/screen_rights.vue"),
        },
        {
          path: "/idp",
          name: "Idp",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_CHANNEL",
            page_type: "landing",
          },
          component: () => import("../views/idp.vue"),
        },
        {
          path: "/tbl_kpi_additions",
          name: "tbl_kpi_additions",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SUB_CHANNEL",
            page_type: "landing",
          },
          component: () => import("../views/kpilist/kpi_additions.vue"),
        },
        {
          path: "/actual_updation",
          name: "actual_updation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/Targets_Actuals/actual_updation.vue"),
        },
        {
          path: "/admin_actual_updation",
          name: "admin_actual_updation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/Targets_Actuals/admin_actual_updation.vue"
            ),
        },
        {
          path: "/actual_updation_main",
          name: "actual_updation_main",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/Targets_Actuals/ActualsOnly/actual_updation_main.vue"
            ),
        },
        {
          path: "/set_target_ViewLanding",
          name: "set_target_ViewLanding",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/Targets_Actuals/TargetsOnly/set_target_ViewLanding.vue"
            ),
        },
        {
          path: "/actual_ViewLanding",
          name: "actual_ViewLanding",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/Targets_Actuals/ActualsOnly/actual_ViewLanding.vue"
            ),
        },
        {
          path: "/set_actual_v2",
          name: "set_actual_v2",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/Targets_Actuals/ActualsOnly/set_actual_v2.vue"
            ),
        },
        {
          path: "/pms",
          component: () =>
            import("../views/kpilist/employee_target.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          children: [
            { path: "", name: "pms", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "assign-kpi", name: "pms-assignKpi", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "set-target", name: "pms-setTarget", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "set-weight", name: "pms-setWeight", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "weightage-matrix", name: "pms-weightMatrix", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "kpi-update", name: "pms-kpiUpdate", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "dashboard", name: "pms-dash", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "master", name: "pms-master", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "assign", name: "pms-assign", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "actuals", name: "pms-actuals", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "bulk", name: "pms-bulk", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "ack-report", name: "pms-ackReport", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "feedback", name: "pms-feedback", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
            { path: "feedback-report", name: "pms-feedbackReport", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_PMS_SET_TARGET", page_type: "landing" } },
          ],
        },
        {
          path: "/kpi_role_ack_report",
          name: "Acknowledgement Report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_KPI_ROLES_REPORT",
            page_type: "landing",
          },
          component: () => import("../views/role/kpi_role_ack_report.vue"),
        },
        {
          path: "/kpi_overall_ack_report",
          name: "Overall Acknowledgement Report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OVERALL_ACK_REPORT",
            page_type: "landing",
          },
          component: () => import("../views/role/kpi_overall_ack_report.vue"),
        },
        {
          path: "/kpi_detailed_report_view",
          name: "kpi_detailed_report_view",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_OVERALL_ACK_REPORT",
            page_type: "landing",
          },
          component: () => import("../views/role/kpi_detailed_report_view.vue"),
        },
        {
          path: "/Appraisaltrend",
          name: "Appraisaltrend",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRISALTRENDREPORT",
            page_type: "landing",
          },
          component: () => import("../views/reports/Appraisal_Trend.vue"),
        },
        {
          path: "/appraisal_trend_chart",
          name: "appraisal_trend_chart",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/reports/appraisal_trend_chart.vue"),
        },
        {
          path: "/targetandactual",
          name: "targetandactual",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRISALTRENDREPORT",
            page_type: "landing",
          },
          component: () => import("../views/reports/targetandactual.vue"),
        },
        {
          path: "/cumulative_actuals_targets_report",
          name: "cumulative_actuals_targets_report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRISALTRENDREPORT",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/cumulative_actuals_targets_report.vue"),
        },
        {
          path: "/new_appraisal_detail_report",
          name: "new_appraisal_detail_report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/appraisal/new_appraisal_detail_report.vue"
            ),
        },
        {
          path: "/apparaisal_rating_report",
          name: "appraisal_rating_report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
            breadcrumb: "Rewards / Appraisal / Appraisal Rating Report",
          },
          component: () =>
            import("../views/kpilist/appraisal/financial_rating_report.vue"),
        },
        {
          path: "/appraisal_heatmap",
          name: "appraisal_heatmap",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
            breadcrumb: "Rewards / Appraisal / Appraisal Heatmap",
          },
          component: () =>
            import("../views/kpilist/appraisal/appraisalheatmap.vue"),
        },
        {
          path: "/kpi_spiderweb_report",
          name: "kpi_spiderweb_report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
            breadcrumb: "Rewards / Appraisal / Kpi Rating Report",
          },
          component: () => import("../views/reports/Spiderwebchart.vue"),
        },
        {
          path: "/reportees_rating_updates",
          name: "reportees_rating_updates",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/appraisal/reportees_rating_updates.vue"),
        },
        {
          path: "/reportees_rating_updates/scorecard",
          name: "scorecardUpadateReportees",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/appraisal/scorecardUpadateReportees.vue"),
        },
        {
          path: "/admin_landing",
          name: "admin_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/admin_landing.vue"),
        },
        {
          path: "/healthcheck_portal",
          name: "healthcheck_portal",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/healthcheck_portal.vue"),
        },
        {
          path: "/jb-healthcheck-portal",
          name: "jb_healthcheck_portal",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/jb_healthcheck_portal.vue"),
        },
        {
          path: "/invite-centre",
          name: "invite_centre",
          meta: {
            auth: true,
            iscommontoshow: true,
            breadcrumb: "Admin / Invite Centre",
          },
          component: () => import("../views/invite_centre.vue"),
        },
        {
          path: "/user_type",
          name: "user_type",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/user_type.vue"),
        },
        {
          path: "/Common_user",
          name: "Common_user",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Common_user.vue"),
        },
        {
          path: "/admin_password_reset",
          name: "AdminPasswordReset",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/AdminPasswordReset.vue"),
        },
        {
          path: "/Common_user_add/add",
          name: "Common_user_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Common_user_add.vue"),
        },
        {
          path: "/Common_user_edit/:id",
          name: "Common_user_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Common_user_edit.vue"),
        },
        {
          path: "/common_rights",
          name: "common_rights",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/common_rights.vue"),
        },
        {
          path: "/onboarding",
          name: "Onboarding",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Onboarding/Onboarding_Setting.vue"),
        },
        {
          path: "/partner",
          name: "partner",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/partner.vue"),
        },
        {
          // NOTE (20260824065511): V2, same as every other entry point.
          //
          // This is the route the admin partner list opens from its dashboard
          // icon, and it was the last one still rendering V1 — login,
          // magic-link, SSO and the side menu had all been moved to V2, so an
          // admin viewing a partner saw the old presentation while the partner
          // themselves saw the new one. The :id is read by
          // partner_dashboard.logic.js, which both versions share, so V2 picks
          // the parameter up unchanged.
          path: "/partner-dashboard/:id?",
          name: "partner-dashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/partner_dashboard_v2.vue"),
        },
        {
          path: "/partner_landing",
          name: "partner_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            hideNavigation: true,
          },
          component: () => import("../views/partner_dashboard.vue"),
        },
        {
          // NOTE (20260822011233): V2 of the partner portal — same behaviour,
          // new presentation. Both render from partner_dashboard.logic.js, so
          // this is a look-and-feel comparison, not a fork. Kept on its own
          // path so V1 stays reachable until V2 is signed off.
          path: "/partner_landing_v2/:id?",
          name: "partner_landing_v2",
          meta: {
            auth: true,
            iscommontoshow: true,
            hideNavigation: true,
          },
          component: () => import("../views/partner_dashboard_v2.vue"),
        },
        {
          // Facilitator availability calendar — a partner opens the days they
          // can deliver workshops, or uploads them as a CSV.
          path: "/partner_workshop_calendar",
          name: "partner_workshop_calendar",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/workshop/partner/ExpertCalendar.vue"),
        },
        {
          path: "/partner_commission",
          name: "partner_commission",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/partner_commission.vue"),
        },
        {
          path: "/partner_approvals",
          name: "partner_approvals",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/partner_approvals.vue"),
        },
        {
          // NOTE (20260821232014): Who receives and may approve partner blog
          // submissions. Its own screen right rather than SCN_BLOG — writing a
          // blog and appointing its approvers are different privileges.
          // Seeded by migration 20260821231710.
          path: "/blog_approval_settings",
          name: "blog_approval_settings",
          meta: {
            auth: true,
            // NOTE (20260823200511): iscommontoshow alongside the code.
            // The guard blocks a route whose page_code is not in the user's
            // screen rights. SCN_BLOG_APPROVAL_SETTINGS is seeded by migration
            // 20260821231710, so until that runs NOBODY can hold the right and
            // the page cannot be opened at all — it just redirected. This
            // matches the sibling admin routes (partner_approvals et al) and
            // becomes rights-controlled once the code precedence change lands.
            iscommontoshow: true,
            screen_code: "SCN_BLOG_APPROVAL_SETTINGS",
            page_code: "SCN_BLOG_APPROVAL_SETTINGS",
            page_type: "landing",
            breadcrumb: "Content Hub / Blog Approval Settings",
          },
          component: () => import("../views/blog_approval_settings.vue"),
        },
        {
          path: "/billing_admin",
          name: "billing_admin",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/BillingAdmin.vue"),
        },
        {
          path: "/billing_report",
          name: "billing_report",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/BillingReport.vue"),
        },
        {
          path: "/promo_redemptions",
          name: "promo_redemptions",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/PromoRedemptionsReport.vue"),
        },
        {
          path: "/client_billing",
          name: "client_billing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/ClientBilling.vue"),
        },
        {
          path: "/buy_users",
          name: "buy_users",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/BuyUsers.vue"),
        },
        {
          path: "/marketplace",
          name: "marketplace",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/marketplace.vue"),
        },
        {
          path: "/dashboard_oro",
          name: "Dashboard oro",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../dashboard_oro.vue"),
        },
        {
          path: "/oasisdashboard",
          name: "oasisdashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../oasisdashboard.vue"),
        },
        {
          path: "/dashboard_landing",
          name: "Dashboard ",
          meta: {
            auth: true,
            iscommontoshow: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DASHBOARD",
            page_type: "landing",
          },
          component: () => import("../dashboard_landing.vue"),
        },
        {
          path: "/survey",
          name: "Survey",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/survey.vue"),
        },
        {
          path: "/survey_new",
          name: "Survey_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/Survey_New/survey_new.vue"),
        },
        {
          path: "/survey_section/:id",
          name: "survey_section",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/survey_section.vue"),
        },
        {
          path: "/survey_reports",
          name: "Survey Reports",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/survey_reports.vue"),
        },
        {
          path: "/survey_dashboard",
          name: "SurveyDashboard",
          meta: {
            auth: true,
            screen_code: "TECTALIK_SURVEY",
            page_code: "SCN_SURVEY",
            page_type: "landing",
          },
          component: () => import("../views/Survey_New/survey_dashboard.vue"),
        },
        {
          path: "/survey_answer_customer_result/:prefix/:survey_id/:entity/:email/:name",
          name: "survey_answer_customer_result",
          meta: {
            auth: false,
            screen_code: "TECTALIK_SURVEY",
            page_code: "SCN_SURVEY",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/survey_answer_customer_result.vue"),
        },
        {
          path: "/survey_answer_customer_result_/:entity/:prefix/:survey_id/:unique_string",
          name: "survey_answer_customer_result",
          meta: {
            auth: false,
            screen_code: "TECTALIK_SURVEY",
            page_code: "SCN_SURVEY",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/survey_answer_customer_result.vue"),
        },
        {
          path: "/survey_answer_customer_result_new_/:entity/:prefix/:survey_id/:unique_string",
          name: "survey_answer_customer_result_new",
          meta: {
            auth: false,
            screen_code: "TECTALIK_SURVEY",
            page_code: "SCN_SURVEY",
            page_type: "landing",
          },
          component: () =>
            import("../views/Survey_New/survey_answer_customer_result_new.vue"),
        },
        {
          path: "/survey_results/:id/:type",
          name: "SurveyResult",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/survey_view_results.vue"),
        },
        {
          path: "/customer",
          name: "Customer",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_CUSTOMER",
            page_code: "SCN_VISIT_CUSTOMER",
            page_type: "landing",
            breadcrumb: "Masters / Visits / Customer",
          },
          component: () => import("../views/masters/customer/customer.vue"),
        },
        {
          path: "/customer/add/:value",
          name: "Customer Add",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_CUSTOMER",
            page_code: "SCN_VISIT_CUSTOMER",
            page_type: "landing",
          },
          component: () => import("../views/masters/customer/customer_add.vue"),
        },
        {
          path: "/customer/add/:value",
          name: "Customer Add New",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_CUSTOMER",
            page_code: "SCN_VISIT_CUSTOMER",
            page_type: "landing",
          },
          component: () => import("../views/Survey_New/customer_add_new.vue"),
        },
        {
          path: "/customer/edit/:id",
          name: "Customer Edit",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_CUSTOMER",
            page_code: "SCN_VISIT_CUSTOMER",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/customer/customer_edit.vue"),
        },
        {
          path: "/customer/target",
          name: "Customer Target",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_CUSTOMER",
            page_code: "SCN_VISIT_CUSTOMER",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/customer/customer_target.vue"),
        },
        {
          path: "/customer/target/report",
          name: "Customer Report",
          meta: {
            auth: true,
            screen_code: "SCN_VISIT_CUSTOMER",
            page_code: "SCN_VISIT_CUSTOMER",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/customer/customer_target_report.vue"),
        },
        {
          path: "/survey/add",
          name: "survey_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_SURVEY",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/survey_add.vue"),
        },
        {
          path: "/survey_question/:id/:type",
          name: "survey_question",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/survey_question.vue"),
        },
        {
          path: "/survey_question/add/:id/:type",
          name: "survey_question_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/survey_question_add.vue"),
        },
        {
          path: "/survey_question_new/add/:id/:type",
          name: "survey_question_add_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/Survey_New/survey_questions_add_new.vue"),
        },
        {
          path: "/survey_template_preview/:id",
          name: "survey_template_preview",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/Survey_New/survey_template_preview.vue"),
        },
        {
          path: "/survey_question_new/edit/:id/:type",
          name: "survey_question_edit_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/Survey_New/survey_questions_edit_new.vue"),
        },
        {
          path: "/survey_question/edit/:id/:type",
          name: "survey_question_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/survey_question_edit.vue"),
        },
        {
          path: "/type_of_questionaire",
          name: "type_of_questionaire",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/type_of_questionaire.vue"),
        },
        {
          path: "/type_of_questionaire_add",
          name: "type_of_questionaire_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/masters/type_of_questionaire_add.vue"),
        },
        {
          path: "/type_of_questionaire_edit/:id",
          name: "type_of_questionaire_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/masters/type_of_questionaire_edit.vue"),
        },
        {
          path: "/survey/edit/:id",
          name: "survey_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/survey_edit.vue"),
        },
        {
          path: "/customers/:id/:type/:frequency",
          name: "Customers",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/customers.vue"),
        },
        {
          path: "/customers_survey/:id/:type/:frequency",
          name: "Customers_survey",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/Survey_New/customers_suvey.vue"),
        },

        {
          path: "/survey_customer_upload",
          name: "survey_customer_upload",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/survey_customer_upload.vue"),
        },

        {
          path: "/survey_answer/add",
          name: "survey_answer_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/survey_answer_add.vue"),
        },

        {
          path: "/survey_answer_result/:id/:type",
          name: "survey_answer_result",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "landing",
          },
          component: () => import("../views/masters/survey_answer_result.vue"),
        },
        {
          path: "/survey_answer_employee_result/:userId/:surveyId/:entityId/:prefix/:email/:name",
          name: "survey_answer_employee_result",
          meta: {
            auth: false,
            screen_code: "TECTALIK_SURVEY",
            page_code: "SCN_SURVEY",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/survey_answer_result_employee.vue"),
        },
        {
          path: "/sur_employee/:id/:frequency",
          name: "sur_employee",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BRANCH",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/sur_employee.vue"),
        },
        {
          path: "/appraisal_launch/period/add",
          name: "/appraisal_launch/period/add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () => import("../views/masters/appraisal_period_add.vue"),
        },
        // employee_scorecard_landing
        {
          path: "/employee_scorecard",
          name: "employee_scorecard_landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/employee_scorecard/employee_scorecard_landing.vue"
            ),
        },
        {
          path: "/non_appraisals_based_incentive_landing",
          name: "non_appraisals_based_incentive_landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS_SET_TARGET",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/non_appraisals_based_incentive/non_appraisals_inc_landing.vue"
            ),
        },

        {
          path: "/admin_desig_landing",
          name: "admin_desig_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Designation/desig_landing.vue"),
        },
        {
          path: "/admin_desig_landing_add",
          name: "admin_desig_landing_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Designation/desig_landing_add.vue"),
        },

        {
          path: "/admin_dept_landing",
          name: "admin_dept_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Department/dept_landing.vue"),
        },
        {
          path: "/admin_dept_landing_add",
          name: "admin_dept_landing_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Department/dept_landing_add.vue"),
        },
        {
          path: "/admin_function_landing",
          name: "admin_function_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Function/function_landing.vue"),
        },
        {
          path: "/admin_function_landing_add",
          name: "admin_function_landing_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Function/function_landing_add.vue"),
        },
        {
          path: "/admin_role_assignments_landing",
          name: "admin_role_assignments_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/RoleAssignments/role_assignments_landing.vue"
            ),
        },
        {
          path: "/admin_role_assignments_group",
          name: "admin_role_assignments_group",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/RoleAssignments/admin_role_assignments_group.vue"
            ),
        },
        {
          path: "/admin_role_assignments_add",
          name: "admin_role_assignments_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/RoleAssignments/role_assignments_add.vue"
            ),
        },
        {
          path: "/admin_skills_add",
          name: "admin_skills_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Skills/skills_add.vue"),
        },
        {
          path: "/admin_skills_landing",
          name: "admin_rskills_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Skills/skills_landing.vue"),
        },
        {
          path: "/admin_skills_group",
          name: "admin_skills_group",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import("../views/AdminMasters/Skills/skills_group.vue"),
        },
        {
          path: "/admin_skills_group_landing",
          name: "admin_skills_group_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/SkillsGroup/skills_group_landing.vue"
            ),
        },
        {
          path: "/admin_skills_group_landing_add",
          name: "admin_skills_group_landing_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/SkillsGroup/skills_group_landing_add.vue"
            ),
        },
        {
          path: "/admin_competencies_landing",
          name: "admin_competencies_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/Competencies/competencies_landing.vue"
            ),
        },
        {
          path: "/admin_competencies_landing_add",
          name: "admin_competencies_landing_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () =>
            import(
              "../views/AdminMasters/Competencies/competencies_landing_add.vue"
            ),
        },
        {
          path: "/incentive_reports",
          name: "incentive_reports",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_POLICY",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/kpilist/appraisal/incentive_reports_wo_payout.vue"
            ),
        },
        {
          path: "/incentive_report",
          name: "incentive_report",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_POLICY",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/appraisal/incentive_report.vue"),
        },
        {
          path: "/promotions",
          name: "promotions",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PROMOTIONS",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/promotions/promotions.vue"),
        },
        {
          path: "/calc_settings",
          name: "calc_settings",
          meta: {
            auth: true,
            screen_code: "SCN_SCORECARD_SETTING",
            page_code: "SCN_SCORECARD_SETTING",
            page_type: "landing",
            breadcrumb: "Settings / Performance / Scorecard Setting",
          },
          component: () => import("../views/masters/calc_settings.vue"),
        },
        {
          path: "/rating_setting",
          name: "rating_setting",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_INCENTIVE_POLICY",
            page_type: "landing",
            isnoadmintoshow: true,
            breadcrumb: "Settings / Performance / Appraisal Score",
          },
          component: () =>
            import("../views/masters/RatingSetting/rating_setting.vue"),
        },
        {
          path: "/common_settings",
          name: "common_settings",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_COMMON_SETTINGS",
            page_type: "landing",
            isnoadmintoshow: true,
            breadcrumb: "Settings / Common Settings",
          },
          component: () =>
            import("../views/Settings/common_settings.vue"),
        },
        {
          path: "/businessscores_naga",
          name: "businessscores_naga",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUSINESSSCORES_NAGA",
            page_type: "landing",
            isnoadmintoshow: true,
            breadcrumb: "Settings / Business Scores - Naga",
          },
          component: () =>
            import("../views/Settings/businessscores_naga.vue"),
        },
        {
          path: "/amc_cancel_category_mstr",
          name: "amc_cancel_category_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/amc_cancel_category_mstr.vue"),
        },
        {
          path: "/amc_cancel_category_mstr/add",
          name: "amc_cancel_category_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/amc_cancel_category_mstradd.vue"),
        },

        {
          path: "/amc_cancel_category_mstr/edit/:id",
          name: "amc_cancel_category_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/amc_cancel_category_mstredit.vue"),
        },
        {
          path: "/amc_type_mstr",
          name: "amc_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/amc_type_mstr.vue"),
        },
        {
          path: "/amc_type_mstr/add",
          name: "amc_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/amc_type_mstradd.vue"),
        },

        {
          path: "/amc_type_mstr/edit/:id",
          name: "amc_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/amc_type_mstredit.vue"),
        },
        {
          path: "/area_mstr",
          name: "area_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/area_mstr.vue"),
        },
        {
          path: "/area_mstr/add",
          name: "area_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/area_mstradd.vue"),
        },

        {
          path: "/area_mstr/edit/:id",
          name: "area_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/area_mstredit.vue"),
        },
        {
          path: "/building_type_mstr",
          name: "building_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/building_type_mstr.vue"),
        },
        {
          path: "/building_type_mstr/add",
          name: "building_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/building_type_mstradd.vue"),
        },

        {
          path: "/building_type_mstr/edit/:id",
          name: "building_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/building_type_mstredit.vue"),
        },
        {
          path: "/caroprtr_make_mstr",
          name: "caroprtr_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/caroprtr_make_mstr.vue"),
        },
        {
          path: "/caroprtr_make_mstr/add",
          name: "caroprtr_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/caroprtr_make_mstradd.vue"),
        },

        {
          path: "/caroprtr_make_mstr/edit/:id",
          name: "caroprtr_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/caroprtr_make_mstredit.vue"),
        },
        {
          path: "/city_mstr",
          name: "city_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/city_mstr.vue"),
        },
        {
          path: "/city_mstr/add",
          name: "city_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/city_mstradd.vue"),
        },

        {
          path: "/city_mstr/edit/:id",
          name: "city_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/city_mstredit.vue"),
        },
        {
          path: "/client_type_mstr",
          name: "client_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/client_type_mstr.vue"),
        },
        {
          path: "/client_type_mstr/add",
          name: "client_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/client_type_mstradd.vue"),
        },

        {
          path: "/client_type_mstr/edit/:id",
          name: "client_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/client_type_mstredit.vue"),
        },
        {
          path: "/client_subtype_mstr",
          name: "client_subtype_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/client_subtype_mstr.vue"),
        },
        {
          path: "/client_subtype_mstr/add",
          name: "client_subtype_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/client_subtype_mstradd.vue"),
        },

        {
          path: "/client_subtype_mstr/edit/:id",
          name: "client_subtype_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/client_subtype_mstredit.vue"),
        },

        {
          path: "/customer_grade_mstr",
          name: "customer_grade_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/CustomerGrade.vue"),
        },
        {
          path: "/customer_grade_add",
          name: "customer_grade_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/CustomerGradeForm.vue"),
        },

        {
          path: "/customer_grade_mstr/edit/:id",
          name: "customer_grade_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/CustomerGradeForm.vue"),
        },
        {
          path: "/controller_mstr",
          name: "controller_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/controller_mstr.vue"),
        },
        {
          path: "/controller_mstr/add",
          name: "controller_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/controller_mstradd.vue"),
        },

        {
          path: "/controller_mstr/edit/:id",
          name: "controller_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/controller_mstredit.vue"),
        },
        {
          path: "/customer_group_mstr",
          name: "customer_group_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/customer_group_mstr.vue"),
        },
        {
          path: "/customer_group_mstr/add",
          name: "customer_group_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/customer_group_mstradd.vue"),
        },

        {
          path: "/customer_group_mstr/edit/:id",
          name: "customer_group_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/customer_group_mstredit.vue"),
        },
        {
          path: "/expertise_level",
          name: "expertise_level",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/expertise_level.vue"),
        },
        {
          path: "/expertise_level/add",
          name: "expertise_level_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/expertise_leveladd.vue"),
        },

        {
          path: "/expertise_level/edit/:id",
          name: "expertise_level_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/expertise_leveledit.vue"),
        },
        {
          path: "/landing_display_mstr",
          name: "landing_display_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/landing_display_mstr.vue"),
        },
        {
          path: "/landing_display_mstr/add",
          name: "landing_display_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/landing_display_mstradd.vue"),
        },

        {
          path: "/landing_display_mstr/edit/:id",
          name: "landing_display_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/landing_display_mstredit.vue"),
        },

        {
          path: "/lift_category_mstr",
          name: "lift_category_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_category_mstr.vue"),
        },
        {
          path: "/lift_category_mstr/add",
          name: "lift_category_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_category_mstradd.vue"),
        },

        {
          path: "/lift_category_mstr/edit/:id",
          name: "lift_category_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_category_mstredit.vue"),
        },
        {
          path: "/lift_make_mstr",
          name: "lift_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/lift_make_mstr.vue"),
        },
        {
          path: "/lift_make_mstr/add",
          name: "lift_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_make_mstradd.vue"),
        },

        {
          path: "/lift_make_mstr/edit/:id",
          name: "lift_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_make_mstredit.vue"),
        },
        {
          path: "/lift_type_mstr",
          name: "lift_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/lift_type_mstr.vue"),
        },
        {
          path: "/lift_type_mstr/add",
          name: "lift_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_type_mstradd.vue"),
        },

        {
          path: "/lift_type_mstr/edit/:id",
          name: "lift_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/lift_type_mstredit.vue"),
        },
        {
          path: "/location_mstr",
          name: "location_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/location_mstr.vue"),
        },
        {
          path: "/location_mstr/add",
          name: "location_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/location_mstradd.vue"),
        },

        {
          path: "/location_mstr/edit/:id",
          name: "location_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/location_mstredit.vue"),
        },
        {
          path: "/receipt_mode_mstr",
          name: "receipt_mode_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/receipt_mode_mstr.vue"),
        },
        {
          path: "/receipt_mode_mstr/add",
          name: "receipt_mode_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/receipt_mode_mstradd.vue"),
        },

        {
          path: "/receipt_mode_mstr/edit/:id",
          name: "receipt_mode_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/receipt_mode_mstredit.vue"),
        },
        {
          path: "/refno_type_mstr",
          name: "refno_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/refno_type_mstr.vue"),
        },
        {
          path: "/refno_type_mstr/add",
          name: "refno_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/refno_type_mstradd.vue"),
        },

        {
          path: "/refno_type_mstr/edit/:id",
          name: "refno_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/refno_type_mstredit.vue"),
        },
        {
          path: "/renewal_type_mstr",
          name: "renewal_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/renewal_type_mstr.vue"),
        },
        {
          path: "/renewal_type_mstr/add",
          name: "renewal_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/renewal_type_mstradd.vue"),
        },

        {
          path: "/renewal_type_mstr/edit/:id",
          name: "renewal_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/renewal_type_mstredit.vue"),
        },
        {
          path: "/route_mstr",
          name: "route_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/route_mstr.vue"),
        },
        {
          path: "/route_mstr/add",
          name: "route_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/route_mstradd.vue"),
        },

        {
          path: "/route_mstr/group",
          name: "route_mstr_group",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/route_mstrgroup.vue"),
        },

        {
          path: "/route_mstr/edit/:id",
          name: "route_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/route_mstredit.vue"),
        },
        {
          path: "/route_mstr/edit/group/:id",
          name: "route_mstr_edit_grp",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/route_mstreditgrp.vue"),
        },
        {
          path: "/schedule_visit_mstr",
          name: "schedule_visit_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/schedule_visit_mstr.vue"),
        },
        {
          path: "/schedule_visit_mstr/add",
          name: "schedule_visit_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/schedule_visit_mstradd.vue"),
        },

        {
          path: "/schedule_visit_mstr/edit/:id",
          name: "schedule_visit_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/schedule_visit_mstredit.vue"),
        },
        {
          path: "/fmsservice",
          name: "fmsservice",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/service.vue"),
        },
        {
          path: "/fmsservice/add",
          name: "fmsservice_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/serviceadd.vue"),
        },

        {
          path: "/fmsservice/edit/:id",
          name: "fmsservice_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/serviceedit.vue"),
        },
        {
          path: "/spare_group_master",
          name: "spare_group_master",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/spare_group_master.vue"),
        },
        {
          path: "/spare_group_master/add",
          name: "spare_group_master_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/spare_group_master_add.vue"),
        },

        {
          path: "/spare_group_master/edit/:id",
          name: "spare_group_master_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/spare_group_master_edit.vue"),
        },
        {
          path: "/spare_parts_master",
          name: "spare_parts_master",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/spare_parts_master.vue"),
        },
        {
          path: "/spare_parts_master/add",
          name: "spare_parts_master_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/spare_parts_master_add.vue"),
        },

        {
          path: "/spare_parts_master/edit/:id",
          name: "spare_parts_master_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/spare_parts_master_edit.vue"),
        },
        {
          path: "/state_mstr",
          name: "state_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/state_mstr.vue"),
        },
        {
          path: "/state_mstr/add",
          name: "state_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/state_mstradd.vue"),
        },

        {
          path: "/state_mstr/edit/:id",
          name: "state_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/state_mstredit.vue"),
        },
        {
          path: "/tax_mstr",
          name: "tax_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/tax_mstr.vue"),
        },
        {
          path: "/tax_mstr/add",
          name: "tax_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/tax_mstradd.vue"),
        },

        {
          path: "/tax_mstr/edit/:id",
          name: "tax_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/tax_mstredit.vue"),
        },
        {
          path: "/tax_category_mstr",
          name: "tax_category_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/tax_category_mstr.vue"),
        },
        {
          path: "/tax_category_mstr/add",
          name: "tax_category_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/tax_category_mstradd.vue"),
        },

        {
          path: "/tax_category_mstr/edit/:id",
          name: "tax_category_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/tax_category_mstredit.vue"),
        },
        {
          path: "/team",
          name: "team",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/team.vue"),
        },
        {
          path: "/team/add",
          name: "team_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/teamadd.vue"),
        },

        {
          path: "/team/edit/:id",
          name: "team_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/teamedit.vue"),
        },
        {
          path: "/ticket_category_mstr",
          name: "ticket_category_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/ticket_category_mstr.vue"),
        },
        {
          path: "/ticket_category_mstr/add",
          name: "ticket_category_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/ticket_category_mstradd.vue"),
        },

        {
          path: "/ticket_category_mstr/edit/:id",
          name: "ticket_category_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/ticket_category_mstredit.vue"),
        },
        {
          path: "/ticket_subcategory_mstr",
          name: "ticket_subcategory_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/ticket_subcategory_mstr.vue"),
        },
        {
          path: "/ticket_subcategory_mstr/add",
          name: "ticket_subcategory_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/ticket_subcategory_mstradd.vue"),
        },

        {
          path: "/ticket_subcategory_mstr/edit/:id",
          name: "ticket_subcategory_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/ticket_subcategory_mstredit.vue"),
        },
        {
          path: "/pause_category",
          name: "pause_category",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/pause_category.vue"),
        },
        {
          path: "/customer_comment",
          name: "customer_comment",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/customer_comment.vue"),
        },
        {
          path: "/pause_category/add",
          name: "pause_category_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/pause_category_add.vue"),
        },
        {
          path: "/pause_category/edit/:id",
          name: "pause_category_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/pause_category_edit.vue"),
        },
        {
          path: "/business_centre",
          name: "business_centre",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/business_centre.vue"),
        },
        {
          path: "/business_centre/add_edit",
          name: "business_centre_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/business_centre_add_edit.vue"),
        },
        {
          path: "/currency_setting",
          name: "currency_setting",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/currency_setting.vue"),
        },
        {
          path: "/warehouse_mstr",
          name: "warehouse_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/warehouse_mstr_landing.vue"),
        },
        {
          path: "/warehouse_mstr/site_mstr/add_edit",
          name: "warehouse_mstr_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/site_mstr_add_edit.vue"),
        },
        {
          path: "/warehouse_mstr/storage_location/add_edit",
          name: "storage_location_mstr_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/storage_location_mstr_add_edit.vue"),
        },
        {
          path: "/warehouse_mstr/stock_point/add_edit",
          name: "stock_point_mstr_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/stock_point_mstr_add_edit.vue"),
        },
        {
          path: "/warehouse_mstr/storage_section/add_edit",
          name: "storage_section_mstr_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/storage_section_mstr_add_edit.vue"),
        },
        {
          path: "/warehouse_mstr/bin_group/add_edit",
          name: "bin_group_mstr_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/bin_group_mstr_add_edit.vue"),
        },
        {
          path: "/warehouse_mstr/bin_mstr/add_edit",
          name: "bin_mstr_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/bin_mstr_add_edit.vue"),
        },
        {
          path: "/division_landing",
          name: "division_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/division_landing.vue"),
        },
        {
          path: "/division_landing/add_edit",
          name: "division_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/division_add_edit.vue"),
        },
        {
          path: "/section_landing",
          name: "section_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/section_landing.vue"),
        },
        {
          path: "/section_landing/add_edit",
          name: "section_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/section_add_edit.vue"),
        },
        {
          path: "/item_category_landing",
          name: "item_category_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_category_landing.vue"),
        },
        {
          path: "/item_category_landing/add_edit",
          name: "item_category_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_category_add_edit.vue"),
        },
        {
          path: "/item_class_landing",
          name: "item_class_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_class_landing.vue"),
        },
        {
          path: "/item_class_landing/add_edit",
          name: "item_class_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_class_add_edit.vue"),
        },
        {
          path: "/hs_code_landing",
          name: "hs_code_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/hs_code_landing.vue"),
        },
        {
          path: "/item_attribute_type",
          name: "item_attribute_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_attribute_type.vue"),
        },
        {
          path: "/item_attribute_type/add_edit",
          name: "item_attribute_type_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_attribute_type_add_edit.vue"),
        },
        {
          path: "/item_attribute_lookup",
          name: "item_attribute_lookup",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_attribute_lookup.vue"),
        },
        {
          path: "/item_attribute_lookup/add_edit",
          name: "item_attribute_lookup_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_attribute_lookup_add_edit.vue"),
        },
        {
          path: "/hs_code_landing/add_edit",
          name: "hs_code_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/hs_code_add_edit.vue"),
        },
        {
          path: "/tax",
          name: "tax",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/tax.vue"),
        },
        {
          path: "/tax/add",
          name: "tax_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/tax_add.vue"),
        },
        {
          path: "/tax/edit/:id",
          name: "tax_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/tax_edit.vue"),
        },
        {
          path: "/tax_rate",
          name: "tax_rate",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/TaxRate/tax_rate.vue"),
        },
        {
          path: "/tax_rate/add",
          name: "tax_rate_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/TaxRate/tax_rate_add.vue"),
        },
        {
          path: "/tax_rate/edit/:id",
          name: "tax_rate_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/TaxRate/tax_rate_edit.vue"),
        },
        {
          path: "/tax_rate/view/:id",
          name: "tax_rate_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "view_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/TaxRate/tax_rate_view.vue"),
        },
        {
          path: "/mr_landing",
          name: "mr_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/MR/mr_landing/mr_landing.vue"),
        },
        {
          path: "/mr_add",
          name: "mr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/mr_add.vue"),
        },
        {
          path: "/mr_edit",
          name: "mr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () => import("../views/FMS/MR/mr_edit.vue"),
        },
        {
          path: "/mr_landing/view",
          name: "mr_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "view",
          },
          component: () => import("../views/FMS/MR/mr_view.vue"),
        },
        {
          path: "/mr_approval/:id",
          name: "mr_approval",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/mr_approval.vue"),
        },
        {
          path: "/mr_approval_tech/:id",
          name: "mr_approval_tech",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/mr_approval_tech.vue"),
        },
        {
          path: "/mr_indent_landing",
          name: "mr_indent_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_MR_INDENT",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/mr_indent_landing.vue"),
        },
        {
          path: "/mr_indent_add/:id/:addflag",
          name: "mr_indent_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_INDENT",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/mr_indent_add.vue"),
        },
        {
          path: "/mr_indent_add_new",
          name: "mr_indent_add_new",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_INDENT",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/MR/mr_indent_add_new.vue"),
        },
        {
          path: "/mr_indent_view/:id",
          name: "mr_indent_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_INDENT",
            page_code: "SCN_FMS",
            page_type: "view",
          },
          component: () => import("../views/FMS/MR/mr_indent_view.vue"),
        },
        {
          path: "/transfer_landing",
          name: "transfer_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TRANSFER",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/transfer_landing.vue"),
        },
        {
          path: "/transfer_add/:id",
          name: "transfer_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TRANSFER",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/transfer_add.vue"),
        },
        {
          path: "/mr_transfer_view/:id",
          name: "mr_transfer_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TRANSFER",
            page_code: "SCN_FMS",
            page_type: "view",
          },
          component: () => import("../views/FMS/MR/mr_transfer_view.vue"),
        },
        {
          path: "/mr_transfer_edit/:id",
          name: "mr_transfer_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TRANSFER",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () => import("../views/FMS/MR/mr_transfer_edit.vue"),
        },
        {
          path: "/mr_transfer_approval/:id",
          name: "mr_transfer_approval",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TRANSFER",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () => import("../views/FMS/MR/mr_transfer_approval.vue"),
        },
        {
          path: "/grn_landing",
          name: "grn_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_GRN",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/MR/grn_landing.vue"),
        },
        {
          path: "/grn_add",
          name: "grn_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_GRN",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/mr_grn_add.vue"),
        },
        {
          path: "/grn_view/:id",
          name: "grn_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_GRN",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/MR/grn_view.vue"),
        },
        {
          path: "/mr_receipt_status_landing",
          name: "mr_receipt_status_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_RECEIPT_STATUS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/MR/mr_receipt_status.vue"),
        },
        {
          path: "/mr_receipt_landing",
          name: "mr_receipt_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_RECEIPT_STATUS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/FMS/MR/mr_receipt/mr_receipt_landing/mr_receipt_landing.vue"
            ),
        },

        {
          path: "/mr_receipt_landing_add",
          name: "mr_receipt_landing_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_RECEIPT_STATUS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/MR/mr_receipt/mr_receipt_add.vue"),
        },
        {
          path: "/mr_stock_report",
          name: "mr_stock_report",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_STOCK_REPORT",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/MR/stock_report.vue"),
        },
        {
          path: "/tis_landing",
          name: "tis_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/TIS/tis_landing.vue"),
        },
        {
          path: "/tis_inspection_edit/:id",
          name: "tis_inspection_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () => import("../views/FMS/TIS/tis_inspection_edit.vue"),
        },
        {
          path: "/tis_inspection_view/:id",
          name: "tis_inspection_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () => import("../views/FMS/TIS/tis_inspection_view.vue"),
        },
        {
          path: "/tis_add",
          name: "tis_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/TIS/tis_add.vue"),
        },
        {
          path: "/tis_add_new",
          name: "tis_add_new",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/TIS/tis_add_new.vue"),
        },
        {
          path: "/tis_inspection/:id",
          name: "tis_inspection",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () => import("../views/FMS/TIS/tis_inspection.vue"),
        },
        {
          path: "/tis_survey_group",
          name: "tis_survey_group",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_GROUP",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_group.vue"),
        },
        {
          path: "/tis_survey_group_add",
          name: "tis_survey_group_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_GROUP",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_group_add.vue"),
        },
        {
          path: "/tis_survey_group_edit/:id",
          name: "tis_survey_group_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_GROUP",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_group_edit.vue"),
        },
        {
          path: "/tis_survey_field",
          name: "tis_survey_field",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_FIELD",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_field.vue"),
        },
        {
          path: "/tis_survey_field_add",
          name: "tis_survey_field_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_FIELD",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_field_add.vue"),
        },
        {
          path: "/tis_survey_field_edit/:id",
          name: "tis_survey_field_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_FIELD",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_field_edit.vue"),
        },
        {
          path: "/tis_survey_type",
          name: "tis_survey_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_TYPE",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_type.vue"),
        },
        {
          path: "/tis_survey_type_add",
          name: "tis_survey_type_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_TYPE",
            page_code: "SCN_FMS",
            page_typvalue: "add",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_type_add.vue"),
        },
        {
          path: "/tis_survey_type_edit/:id",
          name: "tis_survey_type_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_TYPE",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_type_edit.vue"),
        },

        {
          path: "/tis_survey_value",
          name: "tis_survey_value",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_VALUE",
            page_code: "SCN_FMS",
            page_value: "landing",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_value.vue"),
        },
        {
          path: "/tis_survey_value_add",
          name: "tis_survey_value_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_VALUE",
            page_code: "SCN_FMS",
            page_type: "add",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_value_add.vue"),
        },
        {
          path: "/tis_survey_value_edit/:id",
          name: "tis_survey_value_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_TIS_SURVEY_VALUE",
            page_code: "SCN_FMS",
            page_type: "edit",
          },
          component: () =>
            import("../views/FMS/TIS/TIS_Survey/tis_survey_value_edit.vue"),
        },
        {
          path: "/mr_stock_ledger",
          name: "mr_stock_ledger",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_STOCK_LEDGER",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/MR/mr_stock_ledger/stock_ledger.vue"),
        },
        {
          path: "/mr_stock_ledger_view",
          name: "mr_stock_ledger_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS_MR_STOCK_LEDGER",
            page_code: "SCN_FMS",
            page_type: "view",
          },
          component: () =>
            import("../views/FMS/MR/mr_stock_ledger/stock_ledger_view.vue"),
        },
        {
          path: "/item_mstr",
          name: "item_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/item_mstr.vue"),
        },
        {
          path: "/item_mstr/add",
          name: "item_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/item_mstr_add.vue"),
        },
        {
          path: "/item_mstr/edit/:id",
          name: "item_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/item_mstr_edit.vue"),
        },
        {
          path: "/item_mstr/view/:id",
          name: "item_mstr_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/item_mstr_view.vue"),
        },
        {
          path: "/reason_for_requirement",
          name: "reason_for_requirement",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/reason_for_requirement.vue"),
        },
        {
          path: "/reason_for_requirement/add",
          name: "reason_for_requirement_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/reason_for_requirement_add.vue"),
        },
        {
          path: "/reason_for_requirement/edit/:id",
          name: "reason_for_requirement_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/reason_for_requirement_edit.vue"),
        },
        {
          path: "/price_mstr",
          name: "price_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/price_mstr.vue"),
        },
        {
          path: "/price_mstr/add",
          name: "price_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/price_mstr_add.vue"),
        },
        {
          path: "/price_mstr/edit/:item_mstr_id",
          name: "price_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/price_mstr_edit.vue"),
        },
        {
          path: "/price_mstr/view/:item_mstr_id/:branch_id",
          name: "price_mstr_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/price_mstr_view.vue"),
        },
        {
          path: "/vendor_mstr",
          name: "vendor_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/vendor_mstr.vue"),
        },
        {
          path: "/vendor_mstr_add",
          name: "vendor_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/vendor_mstr_add.vue"),
        },
        {
          path: "/vendor_mstr_edit/:id",
          name: "vendor_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/vendor_mstr_edit.vue"),
        },
        {
          path: "/mr_type_landing",
          name: "mr_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/mr_type_landing.vue"),
        },
        {
          path: "/mr_type_add",
          name: "mr_type_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/mr_type_add.vue"),
        },
        {
          path: "/mr_type_edit/:id",
          name: "mr_type_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/mr_type_edit.vue"),
        },
        {
          path: "/root_cause_mstr",
          name: "root_cause_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/root_cause_mstr.vue"),
        },
        {
          path: "/root_cause_mstr_add",
          name: "root_cause_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/root_cause_mstr_add.vue"),
        },
        {
          path: "/root_cause_mstr_edit/:id",
          name: "root_cause_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/root_cause_mstr_edit.vue"),
        },
        {
          path: "/mode_of_transport_mstr",
          name: "mode_of_transport_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/mode_of_transport.vue"),
        },
        {
          path: "/mode_of_transport_mstr_add",
          name: "mode_of_transport_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/mode_of_transport_add.vue"),
        },
        {
          path: "/mode_of_transport_mstr_edit/:id",
          name: "mode_of_transport_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/mode_of_transport_edit.vue"),
        },
        {
          path: "/action_taken_mstr",
          name: "action_taken_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/action_taken_mstr.vue"),
        },
        {
          path: "/action_taken_mstr_add",
          name: "action_taken_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/action_taken_add.vue"),
        },
        {
          path: "/action_taken_mstr_edit/:id",
          name: "action_taken_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/action_taken_edit.vue"),
        },
        {
          path: "/item_mstr_excel_upload",
          name: "item_mstr_excel_upload",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_mstr_excel_upload.vue"),
        },
        {
          path: "/shelf_life_landing",
          name: "shelf_life_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/shelf_life_landing.vue"),
        },
        {
          path: "/shelf_life_landing/add_edit",
          name: "shelf_life_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/shelf_life_add_edit.vue"),
        },
        {
          path: "/item_type_landing",
          name: "item_type_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_type_landing.vue"),
        },
        {
          path: "/item_type_landing/add_edit",
          name: "item_type_add_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/item_type_add_edit.vue"),
        },
        {
          path: "/visit_schedule_mstr",
          name: "visit_schedule_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/visit_schedule_mstr.vue"),
        },
        {
          path: "/visit_schedule_mstr/add",
          name: "visit_schedule_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/visit_schedule_mstradd.vue"),
        },

        {
          path: "/visit_schedule_mstr/edit/:id",
          name: "visit_schedule_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/visit_schedule_mstredit.vue"),
        },
        {
          path: "/policy_type_mstr",
          name: "policy_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/policy_type_mstr.vue"),
        },
        {
          path: "/policy_type_mstr/add",
          name: "policy_type_mstradd",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/policy_type_mstradd.vue"),
        },
        {
          path: "/policy_type_mstr/edit/:id",
          name: "policy_type_mstredit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/policy_type_mstredit.vue"),
        },
        {
          path: "/TicketDefinition",
          name: "TicketDefinition",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/ticket_definition/ticket_definition.vue"),
        },
        {
          path: "/TicketDefinition/add",
          name: "TicketDefinitionAdd",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/ticket_definition/ticket_definition_add.vue"),
        },
        {
          path: "/TicketDefinition/edit/:id",
          name: "TicketDefinitionEdit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/ticket_definition/ticket_definition_edit.vue"),
        },
        {
          path: "/policy_definition",
          name: "policy_definition",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/policy_definition_new.vue"),
        },
        {
          path: "/policy_definition/add",
          name: "policy_definition_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/policy_definition_add.vue"),
        },

        {
          path: "/policy_definition/edit/:id",
          name: "policy_definition_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/policy_definition_edit.vue"),
        },
        {
          path: "/attribute_lookup",
          name: "attribute_lookup",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup.vue"),
        },
        {
          path: "/attribute_lookup_add",
          name: "attribute_lookup_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_add.vue"),
        },

        {
          path: "/attribute_lookup_edit/:id",
          name: "attribute_lookup_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_edit.vue"),
        },
        {
          path: "/attribute_lookup_type",
          name: "attribute_lookup_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_type.vue"),
        },
        {
          path: "/attribute_lookup_type_add",
          name: "attribute_lookup_type_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_type_add.vue"),
        },

        {
          path: "/attribute_lookup_type_edit/:id",
          name: "attribute_lookup_type_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_type_edit.vue"),
        },
        {
          path: "/attribute_lookup_group",
          name: "attribute_lookup_group",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_group.vue"),
        },
        {
          path: "/attribute_lookup_group/add",
          name: "attribute_lookup_group_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_group_add.vue"),
        },

        {
          path: "/attribute_lookup_group_edit/:id",
          name: "attribute_lookup_group_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/jobhistory/attribute_lookup_group_edit.vue"),
        },
        {
          path: "/building",
          name: "building",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/building/building.vue"),
        },
        {
          path: "/building/add",
          name: "buildingAdd",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/building/building_add.vue"),
        },
        {
          path: "/building/edit/:id",
          name: "buildingEdit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/building/building_edit.vue"),
        },
        {
          path: "/building/view/:id",
          name: "buildingView",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/building/building_view.vue"),
        },
        {
          path: "/customer_dtl",
          name: "customer",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/customer/customer.vue"),
        },
        {
          path: "/customer_dtl/add",
          name: "customer_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/customer/customer_add.vue"),
        },
        {
          path: "/customer_dtl/edit/:id",
          name: "customer_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/customer/customer_edit.vue"),
        },
        {
          path: "/customer_dtl/view/:id",
          name: "customer_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "view_screen",
          },
          component: () =>
            // import ('../views/FMS/customer/customer_view_new.vue')
            import("../views/FMS/customer/customer_view.vue"),
        },

        {
          path: "/lift",
          name: "lift",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/lift/lift_landing/lift.vue"),
        },
        {
          path: "/lift_add",
          name: "lift_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/lift/lift_add.vue"),
        },

        {
          path: "/lift_edit/:id",
          name: "lift_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/lift/lift_edit.vue"),
        },
        {
          path: "/lift_copy/:id",
          name: "lift_copy",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/lift/lift_edit.vue"),
        },
        {
          path: "/lift_view/:id",
          name: "lift_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "view_screen",
          },
          component: () => import("../views/FMS/lift/lift_view.vue"),
        },

        {
          path: "/bulk_lift_transfer",
          name: "bulk_lift_transfer",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "transfer_screen",
          },
          component: () => import("../views/FMS/lift/bulk_lift_transfer.vue"),
        },
        {
          path: "/lift_transfer/:id",
          name: "lift_transfer",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "transfer_screen",
          },
          component: () => import("../views/FMS/lift/lift_transfer.vue"),
        },
        {
          path: "/callFunctionType",
          name: "callFunctionType",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/call_function_type.vue"),
        },
        {
          path: "/callFunctionType/add",
          name: "callFunctionType_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/call_function_type_add.vue"),
        },

        {
          path: "/callFunctionType/edit/:id",
          name: "callFunctionType_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/call_function_type_edit.vue"),
        },
        {
          path: "/drive_type_mstr",
          name: "drive_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/drive_type_mstr.vue"),
        },
        {
          path: "/drive_type_mstr/add",
          name: "drive_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/drive_type_mstradd.vue"),
        },

        {
          path: "/drive_type_mstr/edit/:id",
          name: "drive_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/drive_type_mstredit.vue"),
        },
        {
          path: "/highway_landing_type_mstr",
          name: "highway_landing_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/highway_landing_type_mstr.vue"),
        },
        {
          path: "/highway_landing_type_mstr_add",
          name: "highway_landing_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/highway_landing_type_mstr_add.vue"),
        },
        {
          path: "/highway_landing_type_mstr_edit/:id",
          name: "highway_landing_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/highway_landing_type_mstr_edit.vue"),
        },
        {
          path: "/deduction",
          name: "deduction",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/deduction.vue"),
        },
        {
          path: "/deduction_add",
          name: "deduction_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/deduction_add.vue"),
        },
        {
          path: "/deduction_edit/:id",
          name: "deduction_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/deduction_edit.vue"),
        },
        {
          path: "/bank_mstr",
          name: "bank_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/bank_mstr.vue"),
        },
        {
          path: "/bank_mstradd",
          name: "bank_mstradd",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/FmsMaster/bank_mstradd.vue"),
        },
        {
          path: "/bank_mstredit/:id",
          name: "bank_mstredit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/FmsMaster/bank_mstredit.vue"),
        },
        {
          path: "/machineRoomPosition",
          name: "machineRoomPosition",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/machine_room_position.vue"),
        },
        {
          path: "/machineRoomPosition/add",
          name: "machineRoomPosition_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/machine_room_position_add.vue"),
        },

        {
          path: "/machineRoomPosition/edit/:id",
          name: "machineRoomPosition_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/machine_room_position_edit.vue"),
        },
        {
          path: "/payment_type_mstr",
          name: "payment_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_type_mstr.vue"),
        },
        {
          path: "/payment_type_mstr/add",
          name: "payment_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_type_mstradd.vue"),
        },

        {
          path: "/payment_type_mstr/edit/:id",
          name: "payment_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_type_mstredit.vue"),
        },
        {
          path: "/payment_term_mstr",
          name: "payment_term_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_term_mstr.vue"),
        },
        {
          path: "/payment_term_mstr/add",
          name: "payment_term_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_term_mstradd.vue"),
        },

        {
          path: "/payment_term_mstr/edit/:id",
          name: "payment_term_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_term_mstredit.vue"),
        },
        {
          path: "/motor_make_mstr",
          name: "motor_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/motor_make_mstr.vue"),
        },
        {
          path: "/motor_make_mstr/add",
          name: "motor_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/motor_make_mstradd.vue"),
        },

        {
          path: "/motor_make_mstr/edit/:id",
          name: "motor_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/motor_make_mstredit.vue"),
        },
        {
          path: "/menu_access_mstr",
          name: "menu_access_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/menu_access_mstr.vue"),
        },
        {
          path: "/menu_access_mstr/add",
          name: "menu_access_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/menu_access_mstradd.vue"),
        },

        {
          path: "/menu_access_mstr/edit/:id",
          name: "menu_access_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/menu_access_mstredit.vue"),
        },
        {
          path: "/material_mstr",
          name: "material_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/FmsMaster/material_mstr.vue"),
        },
        {
          path: "/material_mstr/add",
          name: "material_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/material_mstradd.vue"),
        },

        {
          path: "/material_mstr/edit/:id",
          name: "material_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/material_mstredit.vue"),
        },

        {
          path: "/maindrive_make_mstr",
          name: "maindrive_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/maindrive_make_mstr.vue"),
        },
        {
          path: "/maindrive_make_mstr/add",
          name: "maindrive_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/maindrive_make_mstradd.vue"),
        },

        {
          path: "/maindrive_make_mstr/edit/:id",
          name: "maindrive_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/maindrive_make_mstredit.vue"),
        },
        {
          path: "/machgear_make_mstr",
          name: "machgear_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/machgear_make_mstr.vue"),
        },
        {
          path: "/machgear_make_mstr/add",
          name: "machgear_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/machgear_make_mstradd.vue"),
        },

        {
          path: "/machgear_make_mstr/edit/:id",
          name: "machgear_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/machgear_make_mstredit.vue"),
        },
        {
          path: "/inverter_make_mstr",
          name: "inverter_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/inverter_make_mstr.vue"),
        },
        {
          path: "/inverter_make_mstr/add",
          name: "inverter_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/inverter_make_mstradd.vue"),
        },

        {
          path: "/inverter_make_mstr/edit/:id",
          name: "inverter_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/inverter_make_mstredit.vue"),
        },
        {
          path: "/instrument_type_mstr",
          name: "instrument_type_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/instrument_type_mstr.vue"),
        },
        {
          path: "/instrument_type_mstr/add",
          name: "instrument_type_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/instrument_type_mstradd.vue"),
        },

        {
          path: "/instrument_type_mstr/edit/:id",
          name: "instrument_type_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/instrument_type_mstredit.vue"),
        },
        {
          path: "/esclation_time_mstr",
          name: "esclation_time_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/esclation_time_mstr.vue"),
        },
        {
          path: "/esclation_time_mstr/add",
          name: "esclation_time_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/esclation_time_mstradd.vue"),
        },

        {
          path: "/esclation_time_mstr/edit/:id",
          name: "esclation_time_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/esclation_time_mstredit.vue"),
        },
        {
          path: "/esclation_percentage_mstr",
          name: "esclation_percentage_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/esclation_percentage_mstr.vue"),
        },
        {
          path: "/esclation_percentage_mstr/add",
          name: "esclation_percentage_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/esclation_percentage_mstradd.vue"),
        },

        {
          path: "/esclation_percentage_mstr/edit/:id",
          name: "esclation_percentage_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/esclation_percentage_mstredit.vue"),
        },
        {
          path: "/encoder_model_mstr",
          name: "encoder_model_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/encoder_model_mstr.vue"),
        },
        {
          path: "/encoder_model_mstr/add",
          name: "encoder_model_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/encoder_model_mstradd.vue"),
        },

        {
          path: "/encoder_model_mstr/edit/:id",
          name: "encoder_model_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/encoder_model_mstredit.vue"),
        },
        {
          path: "/encoder_make_mstr",
          name: "encoder_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/encoder_make_mstr.vue"),
        },
        {
          path: "/encoder_make_mstr/add",
          name: "encoder_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/encoder_make_mstradd.vue"),
        },

        {
          path: "/encoder_make_mstr/edit/:id",
          name: "encoder_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/encoder_make_mstredit.vue"),
        },
        {
          path: "/doordrive_make_mstr",
          name: "doordrive_make_mstr",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/doordrive_make_mstr.vue"),
        },
        {
          path: "/doordrive_make_mstr/add",
          name: "doordrive_make_mstr_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/doordrive_make_mstradd.vue"),
        },

        {
          path: "/doordrive_make_mstr/edit/:id",
          name: "doordrive_make_mstr_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/doordrive_make_mstredit.vue"),
        },
        {
          path: "/employee_field_setting",
          name: "Filed Settings",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () => import("../views/masters/employee_filed_rights.vue"),
        },
        {
          path: "/fms/tickets",
          name: "fms_tickets",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/fms_ticket/fms_tickets.vue"),
        },
        {
          path: "/fms/edit_ticket/:id",
          name: "edit_ticket",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/fms_ticket/edit_ticket.vue"),
        },
        {
          path: "/fms/view_assign_tkt_new",
          name: "view_assign_tkt_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TICKETS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/fms_ticket/view_assign_tkt_new.vue"),
        },
        {
          path: "/raise_tickets",
          name: "Raise_Tickets",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/fms_ticket/raise_tickets.vue"),
        },
        {
          path: "/scheduled_tickets",
          name: "scheduled_tickets",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_SCHEDULED_TICKETS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/fms_ticket/scheduled_tickets.vue"),
        },
        {
          path: "/scheduled_tickets_count",
          name: "scheduled_tickets_count",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_SCHEDULED_TICKETS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/fms_ticket/scheduled_tickets_dashboard.vue"),
        },
        {
          path: "/deposits",
          name: "Deposits",
          meta: {
            auth: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "landing",
          },
          component: () => import("../views/FMS/deposits/deposits.vue"),
        },
        {
          path: "/deposits_add",
          name: "Deposits Add",
          meta: {
            auth: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/deposits/deposits_add.vue"),
        },
        {
          path: "/deposits_edit",
          name: "Deposits Edit",
          meta: {
            auth: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/deposits/deposits_edit.vue"),
        },
        {
          path: "/deposits_view/:id",
          name: "Deposits View",
          meta: {
            auth: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "landing",
          },
          component: () => import("../views/FMS/deposits/deposits_view.vue"),
        },

        {
          path: "/MrQuotation",
          name: "MrQuotationLanding",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/material_request/mr_quotation.vue"),
        },
        {
          path: "/MrQuotationPdf/:id",
          name: "MrQuotationPdf",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/material_request/mr_quotation_pdf.vue"),
        },
        {
          path: "/MrQuotationCardPackPdf/:id",
          name: "MrQuotationCardPackPdf",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/FMS/material_request/mr_quotation_pdf_package_cardview.vue"
            ),
        },
        {
          path: "/MrContract",
          name: "MrContractLanding",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/FMS/MR/mr_contract/mr_contract_landing/mr_contract_landing.vue"
            ),
        },
        {
          path: "/mr_contract_view/:id",
          name: "mr_contract_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/MR/mr_contract/mr_contract_view.vue"),
        },
        {
          path: "/mr_contract_edit/:id",
          name: "mr_contract_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/MR/mr_contract/mr_contract_edit.vue"),
        },
        {
          path: "/Quotation",
          name: "QuotationLanding",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/Quotation/quotation_landing/quotation.vue"),
        },
        {
          path: "/Quotation/pdf/:id",
          name: "quotation_pdf",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () => import("../views/FMS/Quotation/quotation_pdf.vue"),
        },
        {
          path: "/Quotation/pdf/two/:id",
          name: "quotation_pdf_two",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/Quotation/quotation_pdf_two.vue"),
        },
        {
          path: "/Quotation/Add",
          name: "QuotationAdd",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () => import("../views/FMS/Quotation/QuotationAddNew.vue"),
        },
        {
          path: "/Quotation/Edit/:id",
          name: "QuotationEdit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () => import("../views/FMS/Quotation/quotationEdit.vue"),
        },
        {
          path: "/Quotation/View/:id",
          name: "QuotationView",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () => import("../views/FMS/Quotation/quotationView.vue"),
        },
        {
          path: "/Quotation/Cancellation/:id",
          name: "QuotationCancel",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/Quotation/quotation_cancellation.vue"),
        },
        {
          path: "/amc_cancellation/:id",
          name: "AmcCancellation",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_QUOTATION",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/Quotation/amc_cancellation.vue"),
        },
        {
          path: "/lift_merging/:ids/:customer_id",
          name: "LiftMerging",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/lift_merger/liftMerging.vue"),
        },
        {
          path: "/lift_renewal/:ids",
          name: "LiftRenewal",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/lift_renewal/liftRenewal.vue"),
        },
        {
          path: "/contract/demerge/:id",
          name: "Demerger",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/demerger/lift_demerger.vue"),
        },
        {
          path: "/contract_review/demerge/:id",
          name: "demerger_review",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/demerger/demerger_review.vue"),
        },
        {
          path: "/contract_review/merge/:id",
          name: "merger_review",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/lift_merger/merger_review.vue"),
        },
        {
          path: "/merger_with_demerged_lift/:lift_id/:customer_id",
          name: "LiftMerging_with_demerger",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/lift_merger/merger_with_demerged_lift.vue"),
        },
        {
          path: "/Contract",
          name: "ContractLanding",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/contract/contract_landing/contract.vue"),
        },

        // {
        //   path: "/Contract/pdf",
        //   name: "ContractLanding",
        //   meta: {
        //     auth: true,
        //     iscommontoshow: true,
        //     isnoadmintoshow: true,
        //     screen_code: "SCN_FMS",
        //     page_code: "SCN_FMS",
        //     page_type: "landing",
        //   },
        //   component: () => import("../views/FMS/contract/contract_pdf.vue"),
        // },
        {
          path: "/Contract/pdf/:id",
          name: "contract_pdf",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/contract/contract_pdf.vue"),
        },
        {
          path: "/Contract/pdf/two/:id",
          name: "contract_pdf_two",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/contract/contract_pdf_two.vue"),
        },
        {
          path: "/Contract/pdf/three/:id",
          name: "contract_pdf_three",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/contract/contract_pdf_three.vue"),
        },
        {
          path: "/Contract/Add",
          name: "ContractAdd",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "landing",
          },
          component: () => import("../views/FMS/contract/contractAdd.vue"),
        },
        {
          path: "/ContractEdit/:id",
          name: "ContractEdit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "landing",
          },
          component: () => import("../views/FMS/contract/contractEdit.vue"),
        },
        {
          path: "/Contract/View/:id",
          name: "ContractView",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS_CONTRACT",
            page_type: "landing",
          },
          component: () => import("../views/FMS/contract/contractView.vue"),
        },

        {
          path: "/createContract/fromQuotation/:id",
          name: "ContractCreate",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/contract/contractFromQuotation.vue"),
        },
        {
          path: "/approval",
          name: "approval",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () => import("../views/FMS/approval/approval.vue"),
        },
        {
          path: "/approval_list",
          name: "approval_list",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_APPROVAL_LIST",
            page_type: "landing",
          },
          component: () => import("../views/FMS/approval/approval_list.vue"),
        },
        {
          path: "/approval_list_add/add",
          name: "approval_list_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_APPROVAL_LIST",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/approval/approval_list_add.vue"),
        },
        {
          path: "/approval_list_edit/edit/:id",
          name: "approval_list_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_APPROVAL_LIST",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/approval/approval_list_edit.vue"),
        },
        {
          path: "/fms_dashboard_roles",
          name: "fms_dashboard_roles",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_DASHBOARD_ROLES",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/dashboard/fms_dashboard_roles.vue"),
        },
        {
          path: "/fms_dashboard_roles_add",
          name: "fms_dashboard_roles_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_DASHBOARD_ROLES",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/dashboard/fms_dashboard_roles_add.vue"),
        },
        {
          path: "/fms_dashboard_roles_edit/:id",
          name: "fms_dashboard_roles_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_DASHBOARD_ROLES",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/dashboard/fms_dashboard_roles_edit.vue"),
        },
        {
          path: "/fms_dashboard",
          name: "fms_dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_DASHBOARD",
            page_type: "landing",
          },
          component: () => import("../views/FMS/dashboard/fms_dashboard.vue"),
        },

        {
          path: "/approval_process",
          name: "approval_process",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_APPROVAL_LIST",
            page_type: "landing",
          },
          component: () => import("../views/FMS/approval/approval_process.vue"),
        },

        {
          path: "/appraisal_landing",
          name: "appraisal_landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRAISAL_VIEW_APPRAISAL",
            isnoadmintoshow: true,
          },
          component: () => import("../views/masters/appraisal_landing.vue"),
        },

        {
          path: "/my_scorecard",
          name: "my_scorecard",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_APPRAISAL_VIEW_APPRAISAL",
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/kpilist/appraisal/scorecard_landing.vue"),
        },
        {
          path: "/terms_and_conditions",
          name: "terms_and_conditions",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/FMS/terms_and_conditions/terms_and_conditions.vue"
            ),
        },
        {
          path: "/terms_and_conditions_add",
          name: "terms_and_conditions_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/FMS/terms_and_conditions/terms_and_conditions_add.vue"
            ),
        },

        {
          path: "/terms_and_conditions_edit/:id",
          name: "terms_and_conditions_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/FMS/terms_and_conditions/terms_and_conditions_edit.vue"
            ),
        },
        {
          path: "/reason",
          name: "reasons",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "landing",
          },
          component: () => import("../views/FMS/reason/reasons.vue"),
        },
        {
          path: "/reason_add",
          name: "reasons_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/reason/reasons_add.vue"),
        },
        {
          path: "/reason_edit/:id",
          name: "reasons_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            screen_code: "SCN_FMS",
            page_code: "SCN_FMS",
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/reason/reasons_edit.vue"),
        },
        {
          path: "/customer_designation",
          name: "customer_designation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/CustomerDesignation.vue"),
        },
        {
          path: "/terms_group",
          name: "terms_group",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PERFORMANCE_RATING",
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/terms_and_conditions/TermsGroup.vue"),
        },
        {
          path: "/receipt",
          name: "receipt",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/receipt/receipt_landing/receipt.vue"),
        },
        {
          path: "/receipt_add",
          name: "receipt_add_new",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/receipt_add_new.vue"),
        },
        {
          path: "/fms_home",
          name: "fms_home",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
          },
          component: () => import("../views/FMS/fms_home.vue"),
        },
        {
          path: "/receipt_edit/:id",
          name: "receipt_edit",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/receipt/receipt_edit.vue"),
        },
        {
          path: "/billing",
          name: "billing",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () => import("../views/FMS/billing/billing.vue"),
        },
        {
          path: "/billingPDF/:id",
          name: "billing_pdf",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/FMS/receipt/billing_pdf.vue"),
        },
        {
          path: "/receipt_approval/:id",
          name: "receipt_approval",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "approval_screen",
          },
          component: () =>
            import("../views/FMS/receipt_approval/receipt_approval.vue"),
        },
        {
          path: "/visit-log-reports",
          name: "visit-log-reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/visit-log-reports.vue"),
        },
        {
          path: "/receipt_view/:id",
          name: "receipt_view",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "view_screen",
          },
          component: () => import("../views/FMS/receipt/receipt_view.vue"),
        },
        {
          path: "/receipt_narrations",
          name: "receipt_narrations",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/receipt_narrations.vue"),
        },
        {
          path: "/receipt_narrations_add",
          name: "receipt_narrations_add",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/receipt_narrations_add.vue"),
        },
        {
          path: "/receipt_narrations_edit/:id",
          name: "receipt_narrations_edit",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/receipt_narrations_edit.vue"),
        },
        {
          path: "/reports/technical_chart",
          name: "technical_chart",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TECHNICAL_CHART",
            page_type: "landing",
          },
          component: () => import("../views/FMS/reports/technical_chart.vue"),
        },
        {
          path: "/reports/outstanding",
          name: "outstanding",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_OUTSTANDING_REPORT",
            page_type: "landing",
          },
          component: () => import("../views/FMS/reports/outstanding.vue"),
        },
        {
          path: "/reports/lift_reports",
          name: "lift_reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_LIFT_REPORTS",
          },
          component: () => import("../views/FMS/reports/lift_reports.vue"),
        },
        {
          path: "/reports/building_ticket_reports",
          name: "building_ticket_reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_BUILDING_TICKET_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/building_ticket_reports.vue"),
        },
        {
          path: "/reports/breakdown_pm_reports",
          name: "breakdown_pm_reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_BUILDING_TICKET_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/breakdown_pm_reports.vue"),
        },
        {
          path: "/reports/attendance_reports",
          name: "attendance_reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_ATTENDANCE_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/attendance_reports.vue"),
        },
        {
          path: "/reports/daily_attendance_reports",
          name: "daily_attendance_reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_DAILY_ATTENDANCE_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/daily_attendance_reports.vue"),
        },
        {
          path: "/reports/amc_not_renewed_reports_mv",
          name: "Not Renewed List",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_AMC_NOT_RENEWED_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/amc_not_renewed_reports_mv.vue"),
        },
        {
          path: "/reports/current_month_amc_renewal_reports_mv",
          name: "Current Month Renewal List",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_CURRENT_MONTH_AMC_RENEWAL_REPORTS",
          },
          component: () =>
            import(
              "../views/FMS/reports/current_month_amc_renewal_reports_mv.vue"
            ),
        },
        {
          path: "/reports/amc_not_renewed_reports_mv",
          name: "Not Renewed List (MV)",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_AMC_NOT_RENEWED_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/amc_not_renewed_reports_mv.vue"),
        },
        {
          path: "/reports/current_month_amc_renewal_reports_mv",
          name: "Current Month Renewal List (MV)",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_CURRENT_MONTH_AMC_RENEWAL_REPORTS",
          },
          component: () =>
            import(
              "../views/FMS/reports/current_month_amc_renewal_reports_mv.vue"
            ),
        },
        {
          path: "/reports/advance_amc_renewal_reports_mv",
          name: "Advance Renewal Reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_ADVANCE_AMC_RENEWAL_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/advance_amc_renewal_reports_mv.vue"),
        },
        {
          path: "/reports/advance_amc_renewal_reports_mv",
          name: "Advance Renewal Reports MV",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_ADVANCE_AMC_RENEWAL_REPORTS_MV",
          },
          component: () =>
            import("../views/FMS/reports/advance_amc_renewal_reports_mv.vue"),
        },
        {
          path: "/reports/preventive_maintenance_reports_mv",
          name: "Preventive Maintenance Reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_PREVENTIVE_MAINTENANCE_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/preventive_maintenance_reports_mv.vue"),
        },
        {
          path: "/reports/preventive_maintenance_reports_mv",
          name: "Preventive Maintenance Reports MV",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_PREVENTIVE_MAINTENANCE_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/preventive_maintenance_reports_mv.vue"),
        },
        {
          path: "/reports/receipt_booking_status_reports",
          name: "Receipt Booking Status",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_RECEIPT_BOOKING_STATUS_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/receipt_booking_status_reports.vue"),
        },
        {
          path: "/reports/cancelled_contract_reports",
          name: "Cancelled Contract Report",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_CANCELLED_CONTRACT_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/cancelled_contract_reports.vue"),
        },
        {
          path: "/reports/amc_collection_report",
          name: "AMC Collection Report",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_AMC_COLLECTION_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/amc_collection_report.vue"),
        },
        {
          path: "/reports/contract_lift_report",
          name: "Contract Lift Summary Report",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_CONTRACT_LIFT_SUMMARY_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/contract_and_lift_summary.vue"),
        },
        {
          path: "/reports/close_monitoring_report",
          name: "Close Monitoring Report",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_CLOSE_MONITORING_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/close_monitoring_report.vue"),
        },
        {
          path: "/reports/ticket_ageing_report_mv",
          name: "Ticket Ageing Report",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TICKET_AGEING_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/ticket_ageing_report_mv.vue"),
        },
        {
          path: "/reports/ticket_ageing_report_mv",
          name: "Ticket Ageing Report MV",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_TICKET_AGEING_REPORTS",
          },
          component: () =>
            import("../views/FMS/reports/ticket_ageing_report_mv.vue"),
        },
        {
          path: "/reports/dashboard",
          name: "ESCON Dashboard",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_FMS_DASHBOARD_REPORTS",
          },
          component: () =>
            import("../views/escon_dashboard.vue"),
        },
        {
          path: "/payment_received_mstr",
          name: "payment_received_mstr",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "landing",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_received_mstr.vue"),
        },
        {
          path: "/payment_received_mstr_add",
          name: "payment_received_mstr_add",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_received_mstradd.vue"),
        },
        {
          path: "/payment_received_mstr_edit/:id",
          name: "payment_received_mstr_edit",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/FMS/FmsMaster/payment_received_mstredit.vue"),
        },
        {
          path: "/weight_range/add",
          name: "weight_range_add",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () => import("../views/masters/weight_range_add.vue"),
        },
        {
          path: "/weight_range",
          name: "weight_range",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
            breadcrumb: "Masters / Analytics / Weight Range",
          },
          component: () => import("../views/masters/weight_range.vue"),
        },
        {
          path: "/weight_range/edit/:id",
          name: "weight_range_edit",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/weight_range_edit.vue"),
        },
        {
          path: "/jewellery_dashboard_alagar",
          name: "Jewellery",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "SCN_JEWELLERY_DASHBOARD",
            page_code: "SCN_JEWELLERY_DASHBOARD",
          },
          component: () => import("../views/jewellery_dashboard.vue"),
        },
        {
          path: "/jewellery_dashboard_vbj",
          name: "jewellery_dashboard vbj",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "SCN_JEWELLERY_DASHBOARD",
            page_code: "SCN_JEWELLERY_DASHBOARD",
          },
          component: () => import("../views/jewellery_dashboard_vbj.vue"),
        },
        {
          path: "/design/add",
          name: "design_add",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "add_screen",
          },
          component: () => import("../views/masters/design_add.vue"),
        },
        {
          path: "/design/edit/:id",
          name: "design_edit",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/design_edit.vue"),
        },
        {
          path: "/design",
          name: "design",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/design.vue"),
        },
        {
          path: "/oro_to_postgres",
          name: "oro_to_postgres",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/oro/oro_to_postgres.vue"),
        },
        {
          path: "/alagar_dashboard_sync",
          name: "alagar_dashboard_sync",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            page_type: "edit_screen",
          },
          component: () => import("../views/alagar/alagar_dashboard_sync.vue"),
        },
        {
          path: "/kpi_bullseye_new",
          component: () => import("../views/kpilist/kpi_bulls_eye_ui.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_BULLSEYE_NEW",
            page_type: "landing",
          },
          children: [
            { path: "", name: "KPI Bullseye New", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_KPI_BULLSEYE_NEW", page_type: "landing" } },
            { path: "bullseye", name: "be-bullseye", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_KPI_BULLSEYE_NEW", page_type: "landing" } },
            { path: "setup", name: "be-setup", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_KPI_BULLSEYE_NEW", page_type: "landing" } },
            { path: "impact-tree", name: "be-impact_tree", meta: { auth: true, screen_code: "CREATE_MASTERS", page_code: "SCN_KPI_BULLSEYE_NEW", page_type: "landing" } },
          ],
        },
         {
          path: "/kpi_workspace",
          name: "kpi_workspace",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_PMS",
            page_type: "landing",
            kpiaddition: "PMS/ KPI Workspace",
          },
          component: () => import("../views/kpilist/KpiWorkspace.vue"),
        },
        {
          path: "/forms_master",
          name: "Forms",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/masters/forms/form_master.vue"),
        },
         {
          path: "/forms_master_new",
          name: "Forms",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/masters/Form_New/form_master_new.vue"),
        },
        {
          path: "/case_based_workflow",
          name: "Work Flow",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/workflow/case_based_workflow.vue"),
        },
        {
          path: "/work_flow_dashboard",
          name: "Workflow Dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_CASE_BASED",
            page_type: "landing",
          },
          component: () =>
            import("../views/Work_Flow/work_flow_dashboard.vue"),
        },
        {
          path: "/Delegation",
          name: "Delegation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DELEGATION",
            page_type: "landing",
            delegation: "Masters/ Global/ Delegation",
          },
          component: () => import("../views/masters/Delegation.vue"),
        },
        {
          path: "/Delegation_mstr/add",
          name: "Delegation_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DELEGATION",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/Delegation_add.vue"),
        },
        {
          path: "/Delegation_mstr/edit/:id",
          name: "Delegation_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DELEGATION",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/Delegation_edit.vue"),
        },
        {
          path: "/employee_grade",
          name: "employee_grade",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMP_GRADE",
            page_type: "landing",
            employeegrade: "Masters/ Global/ Employee Grade",
          },
          component: () => import("../views/masters/employee_grade.vue"),
        },
        {
          path: "/employee_grade_mstr_add",
          name: "employee_grade_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMP_GRADE",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/employee_grade_add.vue"),
        },
        {
          path: "/employee_grade_mstr_edit/:id",
          name: "employee_grade_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_EMP_GRADE",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/employee_grade_edit.vue"),
        },
        {
          path: "/band_master",
          name: "band_master",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_BAND_MASTER",
            page_type: "landing",
            bandmaster: "Masters/ Global/ Band Master",
          },
          component: () => import("../views/masters/band_master.vue"),
        },
        {
          path: "/band_master_mstr_add",
          name: "band_master_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_BAND_MASTER",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/band_master_add.vue"),
        },
        {
          path: "/band_master_mstr_edit/:id",
          name: "band_master_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_BAND_MASTER",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/band_master_edit.vue"),
        },
        {
          path: "/sub_band_master",
          name: "sub_band_master",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_SUB_BAND_MASTER",
            page_type: "landing",
            subbandmaster: "Masters/ Global/ Sub Band Master",
          },
          component: () => import("../views/masters/sub_band_master.vue"),
        },
        {
          path: "/sub_band_master_mstr_add",
          name: "sub_band_master_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_SUB_BAND_MASTER",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/sub_band_master_add.vue"),
        },
        {
          path: "/sub_band_master_mstr_edit/:id",
          name: "sub_band_master_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_SUB_BAND_MASTER",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/sub_band_master_edit.vue"),
        },
        {
          // NOTE (20260813073704): Also reachable embedded at
          // /settings_dashboard?view=appraisal_display_mode
          path: "/appraisal_display_mode",
          name: "appraisal_display_mode",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_APPRAISAL_DISPLAY_MODE",
            page_type: "landing",
            breadcrumb: "Settings/ Appraisal Display Mode",
          },
          component: () => import("../views/Settings/appraisal_display_mode.vue"),
        },
        {
          path: "/grade_master",
          name: "grade_master",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_GRADE_MASTER",
            page_type: "landing",
            grademaster: "Masters/ Global/ Grade Master",
          },
          component: () => import("../views/masters/grade_master.vue"),
        },
        {
          path: "/grade_master_mstr_add",
          name: "grade_master_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_GRADE_MASTER",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/grade_master_add.vue"),
        },
        {
          path: "/grade_master_mstr_edit/:id",
          name: "grade_master_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_GRADE_MASTER",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/grade_master_edit.vue"),
        },
        {
          path: "/group_master",
          name: "group_master",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_GROUP_MASTER",
            page_type: "landing",
            groupmaster: "Masters/ Global/ Group Master",
          },
          component: () => import("../views/masters/group_master.vue"),
        },
        {
          path: "/group_master_mstr_add",
          name: "group_master_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_GROUP_MASTER",
            page_type: "add_screen",
          },
          component: () => import("../views/masters/group_master_add.vue"),
        },
        {
          path: "/group_master_mstr_edit/:id",
          name: "group_master_edit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_GROUP_MASTER",
            page_type: "edit_screen",
          },
          component: () => import("../views/masters/group_master_edit.vue"),
        },
        {
          path: "/bandwise_score",
          name: "bandwise_score",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCRN_BAND_MASTER",
            page_type: "landing",
            breadcrumb: "Masters / Scores / Bandwise Score",
          },
          component: () => import("../views/masters/bandwise_score.vue"),
        },
        // {
        //     path: '/opening',
        //     name: 'opening',
        //     meta: {
        //         auth: true,
        //         isnoadmintoshow: true,
        //         page_type: 'edit_screen',
        //     },
        //     component: () =>
        //         import ('../views/masters/opening_balance_add.vue')
        // }

        {
          path: "/blog",
          name: "blog",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/blog.vue"),
        },
        {
          path: "/content_hub",
          name: "content_hub",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/content_hub.vue"),
        },
        {
          path: "/blog_sect_categ",
          name: "blog_sect_categ",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/blog_sect_categ.vue"),
        },

        {
          path: "/contacts",
          name: "contacts",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/contacts.vue"),
        },

        {
          path: "/configuration_add",
          name: "configuration_add",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/FMS/configuration_add.vue"),
        },
        {
          path: "/configuration_landing",
          name: "configuration_landing",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/FMS/configuration_landing.vue"),
        },
        {
          path: "/configuration_edit/:id",
          name: "configuration_edit",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/FMS/configuration_edit.vue"),
        },

        // {
        //   path: "/customized_landing",
        //   name: "customized_landing",
        //   meta: {
        //     auth: true,
        //     // iscommontoshow: true,
        //     isnoadmintoshow: true,
        //   },
        //   component: () => import("../views/FMS/customized_landing.vue"),
        // },
        // {
        //   path: "/customized_table_add_edit/",
        //   name: "customized_table_add_edit",
        //   meta: {
        //     auth: true,
        //     // iscommontoshow: true,
        //     isnoadmintoshow: true,
        //   },
        //   component: () => import("../views/FMS/customized_table_add_edit.vue"),
        // },

        // {
        // {
        //   path: "/customized_landing",
        //   name: "customized_landing",
        //   meta: {
        //     auth: true,
        //     // iscommontoshow: true,
        //     isnoadmintoshow: true,
        //   },
        //   component: () => import("../views/FMS/customized_landing.vue"),
        // },
        // {
        //   path: "/customized_table_add_edit/",
        //   name: "customized_table_add_edit",
        //   meta: {
        //     auth: true,
        //     // iscommontoshow: true,
        //     isnoadmintoshow: true,
        //   },
        //   component: () => import("../views/FMS/customized_table_add_edit.vue"),
        // },

        {
          path: "/walkins_age_master",
          name: "walkins_age_master",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/walkin_age_master.vue"),
        },
        {
          path: "/walkins_age_master_add",
          name: "walkins_age_master_add",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/walkin_age_master_add.vue"),
        },

        {
          path: "/walkins_age_master_edit/:id",
          name: "walkins_age_master_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/walkin_age_master_edit.vue"),
        },
        {
          path: "/walkins_dashboard",
          name: "walkins_dashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/walkins_dashboard.vue"),
        },
        {
          path: "/walkins_dashboard_new_module",
          name: "walkins_dashboard_new_module",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/walkins_dashboard_new_module.vue"),
        },
        {
          path: "/goals_new_module",
          name: "goals_new_module",
          meta: {
            auth: true,
            iscommontoshow: true,
          },
          component: () => import("../views/Goals_new_module.vue"),
        },
        {
          path: "/finance_health_questions/:version/:question_type/:customer_type/:customer_id",
          name: "finance_health_questions",
          meta: {
            auth: false,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () => import("../views/actual/fin_health_check.vue"),
        },
        {
          path: "/health_check_dashboard/:flag/:version/:customer_id",
          name: "health_check_dashboard",
          meta: {
            auth: false,
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () => import("../views/actual/health_check_dashboard.vue"),
        },
        // {
        //   path: "/health_check_dashboard_view/:version/:customer_id/:customer_name/:email/:completed_on/:industry/:mobile",
        //   name: "health_check_dashboard_view",
        //   meta: {
        //     auth: false,
        //     screen_code: "TECTALIK_PMS",
        //     page_code: "SCN_BUSINESS_HEALTH_CHECK",
        //     page_type: "add_screen",
        //   },
        // component: () => import("../views/actual/health_check_dashboard_new.vue"),

        // },
        {
          path: "/health_check_dashboard_view/:version/:customer_id/:customer_name/:email/:completed_on/:industry/:mobile",
          name: "health_check_dashboard_view",
          meta: {
            auth: false,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/health_check_dashboard_new.vue"),
        },

        {
          path: "/Financial_healthcheck_dashboard",
          name: "Financial_healthcheck_dashboard",
          meta: {
            auth: false,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/actual/Financial_healthcheck_dashboard.vue"),
        },

        {
          path: "/financial_health_check_results_view",
          name: "financial_health_check_results_view",
          meta: {
            auth: false,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/actual/financial_health_check_results_view.vue"),
        },
        {
          path: "/financial_health_check_dashboard_main",
          component: () =>
            import("../views/actual/Healthcheck_Module_New_UI.vue"),
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "financial_health_check_dashboard_main", meta: { auth: true, isnoadmintoshow: true } },
            { path: "dashboard", name: "hc-dash", meta: { auth: true, isnoadmintoshow: true } },
            { path: "operational", name: "hc-ops", meta: { auth: true, isnoadmintoshow: true } },
            { path: "financial", name: "hc-fin", meta: { auth: true, isnoadmintoshow: true } },
            { path: "take-test", name: "hc-take", meta: { auth: true, isnoadmintoshow: true } },
            { path: "versions", name: "hc-vers", meta: { auth: true, isnoadmintoshow: true } },
            { path: "trends", name: "hc-trends", meta: { auth: true, isnoadmintoshow: true } },
            { path: "config", name: "hc-cfg", meta: { auth: true, isnoadmintoshow: true } },
          ],
        },
        {
          path: "/kml_module_main",
          component: () =>
            import("../views/actual/Kml_Module_UI.vue"),
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "kml_module_main", meta: { auth: true, isnoadmintoshow: true } },
            { path: "business-health", name: "kml-bh", meta: { auth: true, isnoadmintoshow: true } },
            { path: "pnl-dashboard", name: "kml-pnl", meta: { auth: true, isnoadmintoshow: true } },
            { path: "balance-sheet", name: "kml-bs", meta: { auth: true, isnoadmintoshow: true } },
            { path: "pbt-target", name: "kml-pbt", meta: { auth: true, isnoadmintoshow: true } },
            { path: "f08-excel-upload", name: "kml-f08", meta: { auth: true, isnoadmintoshow: true } },
            { path: "production-hours", name: "kml-prodhrs", meta: { auth: true, isnoadmintoshow: true } },
            { path: "production-quantity", name: "kml-prodqty", meta: { auth: true, isnoadmintoshow: true } },
            { path: "ranking", name: "kml-rank", meta: { auth: true, isnoadmintoshow: true } },
            { path: "defect", name: "kml-defect", meta: { auth: true, isnoadmintoshow: true } },
            { path: "reject", name: "kml-reject", meta: { auth: true, isnoadmintoshow: true } },
            { path: "masters", name: "kml-qparam", meta: { auth: true, isnoadmintoshow: true } },
          ],
        },
        // Budget Summary vs Actual dashboard on its own URL. It needs an outlook
        // (?d=… as the Budget vs Actual list passes it); without one it says so.
        // The usual way in is /financial_business_plan → KML Budget vs Actual → View.
        {
          path: "/new_kmlscreen",
          name: "new_kmlscreen",
          component: () => import("../views/AOP/BudgetVsActual/budget_vs_actual_summary_static.vue"),
          meta: { auth: true, isnoadmintoshow: true },
        },

        // The card's Comment screen for that dashboard
        // (?kpi=…&year=…&month=…&units=… as the dashboard passes them).
        {
          path: "/new_kmlscreen/comments",
          name: "new_kmlscreen_comments",
          component: () => import("../views/AOP/BudgetVsActual/business_health_comments.vue"),
          meta: { auth: true, isnoadmintoshow: true },
        },

        // The card's View screen — the KPI drill-down (?d=…&v=… as the
        // dashboard passes them). Named as the dashboard's aopGo calls it.
        {
          path: "/new_kmlscreen/view",
          name: "AopBusinessHealthView",
          component: () => import("../views/AOP/BudgetVsActual/business_health_view.vue"),
          meta: { auth: true, isnoadmintoshow: true },
        },

        // {
        //   path: "/financial_admin_dashboard/:version/:customer_id/:customer_name/:email/:completed_on/:industry/:mobile",
        //   name: "financial_admin_dashboard",
        //   meta: {
        //     auth: true,
        //     screen_code: "TECTALIK_PMS",
        //     page_code: "SCN_BUSINESS_HEALTH_CHECK",
        //     page_type: "landing",
        //     isnoadmintoshow: false
        //   },
        //   component: () => import("../views/actual/financial_admin_dashboard.vue"),
        // },
        {
          path: "/health_check_dashboard_pdf",
          name: "health_check_dashboard_pdf",
          meta: {
            auth: false,
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/actual/finance_health_check_pdf.vue"),
        },

        //---------my work

        {
          path: "/usermanual_master",
          name: "usermanual_master",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/UserManual/usermanual_master.vue"),
        },
        // {
        //   path: "/usermanual_infromation",
        //   name: "usermanual_infromation",
        //   meta: {
        //     auth: true,
        //     // iscommontoshow: true,
        //     isnoadmintoshow: true,
        //   },
        //   component: () => import("../views/UserManual/usermanual_information.vue"),
        // },
        {
          path: "/usermanual_add",
          name: "usermanual_add",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/UserManual/usermanual_add.vue"),
        },
        {
          path: "/usermanual_add/:id",
          name: "usermanual_add_child",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/UserManual/usermanual_add.vue"),
        },
        {
          path: "/usermanual_edit/:batch_value/:id",
          // path: "/usermanual_edit/:batch_value",
          name: "usermanual_edit",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/UserManual/usermanual_edit.vue"),
        },
        {
          path: "/usermanual_view/:batch_value",
          name: "usermanual_view",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/UserManual/usermanual_view.vue"),
        },
        {
          path: "/financials_input_scrn",
          name: "financials_input_scrn",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/financials_input_scrn.vue"),
        },
        {
          path: "/financials_input_scrn_edit",
          name: "financials_input_scrn_edit",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/financials_input_scrn_edit.vue"),
        },
        {
          path: "/financials_view_screen",
          name: "financials_view_screen",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/financials_view_screen.vue"),
        },
        {
          path: "/financials_landing",
          name: "financials_landing",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/financials_landing.vue"),
        },

        {
          path: "/combination_of_masters",
          name: "combination_of_masters",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/combination_of_masters/combination_of_masters_landing.vue"
            ),
        },
        {
          path: "/combination_of_masters/add",
          name: "combination_of_masters/add",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/combination_of_masters/combination_of_masters_add.vue"
            ),
        },

        {
          path: "/what_if_landing",
          name: "what_if_landing",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/what_if_landing.vue"),
        },
        {
          path: "/what_if_add",
          name: "what_if_add",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () => import("../views/whatifanalysis/what_if_add.vue"),
        },

        {
          path: "/what_if_add_new",
          name: "what_if_add_new",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/what_if_add_new.vue"),
        },

        {
          path: "/what_if_landing_dynamic",
          name: "what_if_landing_dynamic",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/what_if_landing_dynamic.vue"),
        },
        {
          path: "/what_if_dynamic_add",
          name: "what_if_dynamic_add",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/whatifanalysis/what_if_dynamic_add.vue"),
        },
        {
          path: "/customer_performance_report_landing",
          name: "customer_performance_report_landing",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/Customer_performance_report/customer_performance_report_landing.vue"
            ),
        },
        {
          path: "/media_page",
          name: "media_page",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import("../views/Customer_performance_report/media_page.vue"),
        },
        {
          path: "/dashboard_kpi_impact_landing",
          name: "dashboard_kpi_impact_landing",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/dashboard_kpi_impact_landing.vue"),
        },
        {
          path: "/dashboard_kpi_impact_add",
          name: "dashboard_kpi_impact_add",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_KPI_IMPACT_SETUP",
            page_type: "landing",
          },
          component: () =>
            import("../views/kpilist/dashboard_kpi_impact_add.vue"),
        },

        // ITC ===> ME014 ==> Starts
        {
          path: "/coa_landing",
          name: "coa_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/coa_landing.vue"),
        },

        // kalyan sir ui
                {
          path: "/aop_ui",
          name: "aop_ui",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/aop_ui.vue"),
        },

                        {
          path: "/aop_ui_2",
          name: "aop_ui_2",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/AopPlanner.vue"),
        },

                        {
          path: "/vmosa_ui",
          component: () => import("@/views/ITC/ME014/COA/vmosa_ui.vue"),
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "vmosa_ui", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "dashboard", name: "vmosa-dashboard", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "vision-mission", name: "vmosa-vmv", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "assessment", name: "vmosa-assessment", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "planner", name: "vmosa-planner", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "goals", name: "vmosa-goals", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "history", name: "vmosa-history", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "goal-tracker-new", name: "vmosa-goalnew", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "strategy-planner-new", name: "vmosa-strategynew", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
          ],
        },
        {
          path: "/crm",
          name: "crm",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/crm.vue"),
        },
        {
          path: "/rasi_ui",
          name: "rasi_ui",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/rasi_ui.vue"),
        },
        {
          path: "/project_management",
          name: "project_management",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/projectManagementModule.vue"),
        },
        {
          path: "/project_management_v2",
          name: "project_management_v2",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/ProjectManagement/index.vue"),
        },
        {
          path: "/chat_hub",
          name: "chat_hub",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/chat_hub/ChatHub.vue"),
        },
        // kalyan sir ui
        {
          path: "/template_builder",
          name: "template_builder",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreationDynamic/template_builder.vue"
            ),
        },
        {
          path: "/template_builder_add",
          name: "template_builder_add",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreationDynamic/template_builder_add.vue"
            ),
        },
        {
          path: "/field_creation",
          name: "field_creation",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/FieldCreation/field_creation.vue"),
        },
        {
          path: "/field_creation_add",
          name: "field_creation_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/FieldCreation/field_creation_add.vue"),
        },
        {
          path: "/field_creation/edit/:id",
          name: "field_creation_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/FieldCreation/field_creation_edit.vue"),
        },
        {
          path: "/customized_field_creation",
          name: "customized_field_creation",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreation/customized_field_creation.vue"
            ),
        },
        {
          path: "/volume_price_landing",
          name: "volume_price_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/Volume_Price/volume_price_landing.vue"),
        },
        {
          path: "/volume_price/view/:id/:version",
          name: "volume_price_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/Volume_Price/volume_price_view.vue"),
        },
        {
          path: "/volume_price/edit/:id/:version",
          name: "volume_price_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/Volume_Price/volume_price_edit.vue"),
        },
        {
          path: "/coa_order_by",
          name: "coa_order_by",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/coa_order_by.vue"),
        },
        {
          path: "/itc_product_dtls",
          name: "itc_product_dtls",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/Master/itc_product_dtls.vue"),
        },
        {
          path: "/itc_segment_tax_dtls",
          name: "itc_segment_tax_dtls",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/Master/itc_segment_tax_dtls.vue"),
        },
        {
          path: "/itc_volume_export",
          name: "itc_volume_export",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ITC/ME014/Master/temp_itc_volume_export.vue"),
        },
        {
          path: "/field_creation_template",
          name: "field_creation_template",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreationTemplate/field_creation_template.vue"
            ),
        },
        {
          path: "/field_creation_template/add",
          name: "field_creation_template_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreationTemplate/field_creation_template_add.vue"
            ),
        },
        {
          path: "/field_creation_template/edit/:id",
          name: "field_creation_template_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreationTemplate/field_creation_template_edit.vue"
            ),
        },
        {
          path: "/out_look_entries_landing",
          name: "out_look_entries_landing",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014_V2/OutLookEntries/out_look_entries_landing.vue"
            ),
        },
        {
          path: "/out_look_entries/view/:id",
          name: "out_look_entries_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014_V2/OutLookEntries/out_look_entries_view.vue"
            ),
        },
        {
          path: "/input_template/view/:id",
          name: "input_template_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ITC/ME014/FieldCreationTemplate/Input/input_template_view.vue"
            ),
        },
        // ITC ===> ME014 ==> Ends
        {
          path: "/financial_health_input_form/:version/:question_type/:customer_type/:customer_id",
          name: "financial_health_input_form",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/actual/financial_health_input_form.vue"),
        },
        {
          path: "/financial_health_input_details/:version/:question_type/:customer_type/:customer_id",
          name: "financial_health_input_details",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/actual/financial_health_input_details.vue"),
        },
        {
          path: "/health_check_answer_landing/:industry/:country/:version/:question_type/:customer_type/:customer_id",
          name: "health_check_answer_landing",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/health_check_answer_landing.vue"),
        },
        {
          path: "/health_check_answer_operational_landing/:industry/:country/:version/:question_type/:customer_type/:customer_id",
          name: "health_check_answer_operational_landing",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import(
              "../views/actual/health_check_answer_operational_landing.vue"
            ),
        },

        {
          path: "/act_meeting_form",
          name: "act_meeting_form",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/actual/act_meeting_form.vue"),
        },

        //kalyan sir ui
        // Audit Plan ===> ME014 ==> Starts
        {
          path: "/audit_module",
          name: "audit_module",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ITC/ME014/COA/auditModule.vue"),
        },
        {
          path: "/risk_assessment",
          component: () => import("@/views/ITC/ME014/COA/riskAssessment.vue"),
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "risk_assessment", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "dashboard", name: "ra-dashboard", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "processes", name: "ra-processes", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "register", name: "ra-register", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "assessment", name: "ra-assessment", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "controls", name: "ra-controls", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "frameworks", name: "ra-frameworks", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
          ],
        },
        //kalyan sir ui
        {
          path: "/audit_process",
          name: "audit_process",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Process",
          },
          component: () =>
            import("@/views/ME014/AuditPlan/Master/Process/audit_process.vue"),
        },
        {
          path: "/audit_process/add",
          name: "audit_process_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_process_add.vue"
            ),
        },
        {
          path: "/audit_process/edit/:id",
          name: "audit_process_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_process_edit.vue"
            ),
        },
        {
          path: "/audit_sub_process",
          name: "audit_sub_process",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Sub Process",
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_sub_process.vue"
            ),
        },
        {
          path: "/audit_sub_process/edit/:id",
          name: "audit_sub_process_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_sub_process_edit.vue"
            ),
        },
        {
          path: "/audit_risk_type/edit/:id",
          name: "audit_risk_type_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_type_edit.vue"
            ),
        },
        {
          path: "/audit_sub_process/add",
          name: "audit_sub_process_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_sub_process_add.vue"
            ),
        },
        {
          path: "/audit_risk_type",
          name: "audit_risk_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Risk Type",
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_type.vue"
            ),
        },
        {
          path: "/audit_risk_type/add",
          name: "audit_risk_type_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_type_add.vue"
            ),
        },
        {
          path: "/audit_control_type",
          name: "audit_control_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Control Type",
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_control_type.vue"
            ),
        },
        {
          path: "/audit_control_type/add",
          name: "audit_control_type_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_control_type_add.vue"
            ),
        },
        {
          path: "/audit_control_type/edit/:id",
          name: "audit_control_type_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_control_type_edit.vue"
            ),
        },
        {
          path: "/audit_likelihood",
          name: "audit_likelihood",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit likelihood",
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_likelihood.vue"
            ),
        },
        {
          path: "/audit_likelihood/add",
          name: "audit_likelihood_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_likelihood_add.vue"
            ),
        },
        {
          path: "/audit_likelihood/edit/:id",
          name: "audit_likelihood_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_likelihood_edit.vue"
            ),
        },
        {
          path: "/audit_impact",
          name: "audit_impact",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Impact",
          },
          component: () =>
            import("@/views/ME014/AuditPlan/Master/Process/audit_impact.vue"),
        },
        {
          path: "/audit_impact/add",
          name: "audit_impact_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_impact_add.vue"
            ),
        },
        {
          path: "/audit_impact/edit/:id",
          name: "audit_impact_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_impact_edit.vue"
            ),
        },
        {
          path: "/audit_controls",
          name: "audit_controls",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Controls",
          },
          component: () =>
            import("@/views/ME014/AuditPlan/Master/Process/audit_controls.vue"),
        },
        {
          path: "/audit_controls/add",
          name: "audit_controls_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_controls_add.vue"
            ),
        },
        {
          path: "/audit_controls/edit/:id",
          name: "audit_controls_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_controls_edit.vue"
            ),
        },
        {
          path: "/audit_risk",
          name: "audit_risk",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Risk",
          },
          component: () =>
            import("@/views/ME014/AuditPlan/Master/Process/audit_risk.vue"),
        },
        {
          path: "/audit_risk/add",
          name: "audit_risk_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ME014/AuditPlan/Master/Process/audit_risk_add.vue"),
        },
        {
          path: "/audit_risk/edit/:id",
          name: "audit_risk_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_edit.vue"
            ),
        },
        {
          path: "/audit_work_flow_creator",
          name: "audit_work_flow_creator",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / Audit / Audit Work Flow Creator",
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_work_flow_creator.vue"
            ),
        },
        {
          path: "/audit_workflow_creator/add",
          name: "audit_workflow_creator_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_workflow_creator_add.vue"
            ),
        },
        {
          path: "/audit_workflow_creator/edit/:id",
          name: "audit_workflow_creator_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_work_flow_creator_edit.vue"
            ),
        },
        {
          path: "/audit_risk_matrix_view",
          name: "audit_risk_matrix_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_matrix_view.vue"
            ),
        },
        {
          path: "/audit_risk_matrix_view_new",
          name: "audit_risk_matrix_view_new",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_matrix_view_new.vue"
            ),
        },

        {
          path: "/audit_risk_matrix_view_new",
          name: "audit_risk_matrix_view_new",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import(
              "@/views/ME014/AuditPlan/Master/Process/audit_risk_matrix_view_new.vue"
            ),
        },

        //        {
        //   path: "/sop_process",
        //   name: "sop_process",
        //   meta: {
        //     auth: true,
        //     iscommontoshow: true,
        //     isnoadmintoshow: true,
        //     breadcrumb:"Act / SOP / SOP Process",
        //   },
        //   // component: () => import("@/views/ME014/SOP/sop_process.vue"),
        //   component: () => import("@/views/ME014/SOP/sopnewadd.vue"),
        // },
        //            {
        //   path: "/sop_process_add",
        //   name: "sop_process_add",
        //   meta: {
        //     auth: true,
        //     iscommontoshow: true,
        //     isnoadmintoshow: true,
        //   },
        //   component: () => import("@/views/ME014/SOP/sop_process_add.vue"),
        // },

        {
          path: "/sop-builder",
          component: () => import("@/views/SOP_Builder/SopBuilder.vue"),
          meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true },
          children: [
            { path: "", redirect: "dashboard" },
            { path: "dashboard", name: "SopDashboard", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / Dashboard" }, component: () => import("@/views/SOP_Builder/Sop_Dashboard.vue") },
            { path: "all", name: "SopAll", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / All SOPs" }, component: () => import("@/views/SOP_Builder/All_sop.vue") },
            { path: "hierarchy", name: "SopHierarchy", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / Hierarchy" }, component: () => import("@/views/SOP_Builder/Sop_Process_hierarchy.vue") },
            { path: "ai-upload", name: "SopAiUpload", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / AI Upload" }, component: () => import("@/views/SOP_Builder/Sop_Ai_upload.vue") },
            { path: "upload", name: "SopUpload", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, defaultTab: "by", breadcrumb: "Act / SOP / Upload SOP" }, component: () => import("@/views/SOP_Builder/Sop_FileUpload.vue") },
            { path: "assigned", name: "SopAssigned", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, defaultTab: "to", breadcrumb: "Act / SOP / Assigned SOP" }, component: () => import("@/views/SOP_Builder/Sop_FileUpload.vue") },
            { path: "detail/:id", name: "SopDetail", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / Detail" }, component: () => import("@/views/SOP_Builder/Sop_Detail.vue") },
            { path: "flow-editor/:id", name: "SopFlowEditor", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / Flowchart Editor" }, component: () => import("@/views/SOP_Builder/Sop_FlowEditor.vue") },
            { path: "table-editor/:id", name: "SopTableEditor", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / Table Editor" }, component: () => import("@/views/SOP_Builder/Sop_TableEditor.vue") },
            { path: "pdf/:id", name: "SopPdfPreview", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / PDF Preview" }, component: () => import("@/views/SOP_Builder/Sop_PdfPreview.vue") },
            { path: "published", name: "SopPublished", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "Act / SOP / Published" }, component: () => import("@/views/SOP_Builder/SopPublished.vue") },
          ]
        },

        {
          path: "/doa",
          component: () => import("@/views/DOA/DoaBuilder.vue"),
          meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true },
          children: [
            { path: "", redirect: "dashboard" },
            { path: "dashboard", name: "DoaDashboard", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Dashboard" }, component: () => import("@/views/DOA/DOA_Dashboard.vue") },
            { path: "matrix", name: "DoaMatrix", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Matrix" }, component: () => import("@/views/DOA/DOA_Matrix.vue") },
            { path: "limits", name: "DoaLimits", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Authority Limits" }, component: () => import("@/views/DOA/Authority_Limit.vue") },
            { path: "roles", name: "DoaRoles", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Role Mapping" }, component: () => import("@/views/DOA/Role_Mapping.vue") },
            { path: "requests", name: "DoaRequests", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Requests" }, component: () => import("@/views/DOA/DOA_Request.vue") },
            { path: "pending", name: "DoaPending", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / My Approvals" }, component: () => import("@/views/DOA/DOA_My_Approval.vue") },
            { path: "tracker", name: "DoaTracker", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Approval Tracker" }, component: () => import("@/views/DOA/Approval_Tracker.vue") },
            { path: "decisions", name: "DoaDecisions", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Decision Log" }, component: () => import("@/views/DOA/Decision_log.vue") },
            { path: "analytics", name: "DoaAnalytics", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Analytics" }, component: () => import("@/views/DOA/DOA_Analytics.vue") },
            { path: "settings", name: "DoaSettings", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true, breadcrumb: "DOA / Settings" }, component: () => import("@/views/DOA/DOA_Settings.vue") },
          ]
        },

        {
          path: "/soppolicy_add",
          name: "soppolicy_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ME014/SOP/soppolicy_add.vue"),
        },

        {
          path: "/sop_Flow",
          name: "sop_Flow",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / View Sub-Process",
          },
          component: () => import("@/views/ME014/SOP/sopnewadd.vue"),
        },

        {
          path: "/sop_responsiblity",
          name: "sop_responsiblity",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / SOP RESPONSIBILITY",
          },
          component: () => import("@/views/ME014/SOP/sop_responsibility.vue"),
        },
        {
          path: "/sop_Approver",
          name: "sop Approver",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / Sop Approver",
          },
          component: () => import("@/views/ME014/SOP/Sop_Approver.vue"),
        },

        {
          path: "/sop/subprocess/detail/:id",
          name: "SubProcessDetail",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / Sub-Process Detail",
          },
          component: () => import("@/views/ME014/SOP/SubProcessDetail.vue"),
        },
        {
          path: "/sop/activity/management/:parentId",
          name: "ActivityManagement",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / Activity Management",
          },
          component: () => import("@/views/ME014/SOP/ActivityManagement.vue"),
        },
        {
          path: "/sop/workflow/manager/:id?",
          name: "SopWorkflowManager",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / Workflow Manager",
          },
          component: () => import("@/views/ME014/SOP/SopWorkflowManager.vue"),
        },
        {
          path: "/sop/process/detail/:id",
          name: "ProcessDetail",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / Process Detail",
          },
          component: () => import("@/views/ME014/SOP/ProcessDetail.vue"),
        },
        {
          path: "/Sop_Activity",
          name: "sop Activity",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Act / SOP / Sop Activity",
          },
          component: () => import("@/views/ME014/SOP/Sop_Activity.vue"),
        },

        // Audit Plan ===> ME014 ==> Ends

        // Board DashBoard ===> ME014 ==> Starts
        {
          path: "/BoardDashBoard",
          name: "BoardDashBoard",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ME014/Board_DashBoard/BoardDashBoard.vue"),
        },

        {
          path: "/EmployeeDashBoard",
          name: "EmployeeDashBoard",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ME014/Employee_DashBoard/EmployeeDashBoard.vue"),
        },
        {
          path: "/SecretaryBoard",
          name: "SecretaryBoard",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ME014/SecretaryBoard/SecretaryBoard.vue"),
        },
        {
          path: "/CommitteeDashboard",
          name: "CommitteeDashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/ME014/CommitteeDashboard/CommitteeDashboard.vue"),
        },
        // Board DashBoard ===> ME014 ==> Ends

        // PollS ===> ME014 ==> Starts
        {
          path: "/polls",
          name: "polls",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ME014/PollS/polls.vue"),
        },
        {
          path: "/polls/add",
          name: "polls_add",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ME014/PollS/polls_add.vue"),
        },
        {
          path: "/polls/view/:id",
          name: "polls_view",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ME014/PollS/polls_view.vue"),
        },
        {
          path: "/polls/edit/:id",
          name: "polls_edit",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/ME014/PollS/polls_edit.vue"),
        },
        // PollS ===> ME014 ==> Ends
        {
          path: "/health_check_invite_new",
          name: "health_check_invite_new",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/actual/health_check_invite_new.vue"),
        },
        {
          path: "/health_check_view_answer_new/:customer_id/:version/:sub_domain",
          name: "health_check_view_answer_new",
          meta: {
            auth: true,
            screede: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/actual/health_check_view_answer_new.vue"),
        },
        {
          path: "/scorecard_new",
          name: "scorecard_new",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/scorecard_new/scorecard_new.vue"),
        },
        {
          path: "/scorecard_board",
          name: "scorecard_board",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/scorecard_new/scorecard_board.vue"),
        },

        {
          path: "/workflow_landing",
          name: "WorkflowLanding",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/act_workflow/act_workflow_landing.vue"),
        },
        {
          path: "/checklist_new",
          name: "checklistNew",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/act_checklist_new/act_checklist_new_landing.vue"),
        },
         {
          path: "/checklist_dashboard",
          name: "checklistDashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/checklist_dashboard.vue"),
        },
        {
          path: "/learning_academy",
          component: () =>
            import("@/views/learning_academy.vue"),
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          children: [
            { path: "", name: "learningAcademy", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "library", name: "learningAcademy-library", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "lists", name: "learningAcademy-lists", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "exams", name: "learningAcademy-exams", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "analytics", name: "learningAcademy-analytics", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
            { path: "builder", name: "learningAcademy-builder", meta: { auth: true, iscommontoshow: true, isnoadmintoshow: true } },
          ],
        },
        {
          path: "/Board_Designation",
          name: "Board_Designation",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/Board/Designation/Board_Designation.vue"),
        },
        {
          path: "/BoardUnits",
          name: "BoardUnits",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/Board/BoardUnits/BoardUnits.vue"),
        },
        {
          path: "/board_types",
          name: "board_types",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/Board/BoardTypes/board_types.vue"),
        },
        {
          path: "/board_positions",
          name: "board_positions",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/Board/BoardPositions/board_positions.vue"),
        },
        {
          path: "/checklist_new_instance",
          name: "ChecklistInstanceTasksTable",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/act_checklist_new/checklist_instance_table.vue"),
        },
        {
          path: "/Healthcheck_Dashboards",
          name: "Healthcheck_Dashboards",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/Healthcheck_Dashboards.vue"),
        },
        {
          path: "/feedback_dashboards",
          name: "feedback_dashboards",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/Feedback_Dashboards.vue"),
        },
        {
          path: "/feedback_report",
          name: "feedback_report",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/feedback_report.vue"),
        },

        {
          path: "/Healthcheck_Dashboards_financial",
          name: "Healthcheck_Dashboards_financial",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/dashboard_financial_home.vue"),
        },

        {
          path: "/Healthcheck_Dashboards_operational",
          name: "Healthcheck_Dashboards_operational",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Healthcheck_Dashboards_operational.vue"),
        },
        {
          path: "/Healthcheck_Dashboards",
          name: "Show_list",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/show_list.vue"),
        },
        {
          path: "/health_check_config_landing",
          name: "health_check_config_landing",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/health_check_config_landing.vue"),
        },
        {
          path: "/health_check_config_add",
          name: "health_check_config_add",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/health_check_config_add.vue"),
        },
        {
          path: "/dashboard_compliance",
          name: "dashboard_compliance",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/dashboard_compliance/compliance_table.vue"),
        },
        {
          path: "/dashboard_scorecard",
          name: "dashboard_scorecard",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/dashboard_scorecard/scorecard_table.vue"),
        },
        {
          path: "/dashboard_compliance_task",
          name: "dashboard_compliance_task",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/dashboard_compliance/compliance_task_table.vue"),
        },
        {
          path: "/statutory_acts",
          name: "statutory_acts",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/forms_master/statutory_acts.vue"),
        },

        {
          path: "/form_gt4",
          name: "form_gt4",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/forms_master/form_gt4.vue"),
        },

        {
          path: "/forms_master_new",
          name: "forms_master_new",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/forms_master/forms_master_new.vue"),
        },

        {
          path: "/forms_transactions",
          name: "forms_transactions",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/forms_master/forms_transactions.vue"),
        },

        {
          path: "/detailed_kpi_config",
          name: "detailed_kpi_config",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/Settings/detailed_kpi_config.vue"),
        },

        {
          path: "/tbl_emp_kpi_feedback_dtls",
          name: "tbl_emp_kpi_feedback_dtls",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/Settings/tbl_emp_kpi_feedback_dtls.vue"),
        },

        {
          path: "/mail_config_setting",
          name: "mail_config_setting",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/Settings/mail_config_setting.vue"),
        },

        {
          path: "/kpi_summary_reports",
          name: "kpi_summary_reports",
          meta: {
            auth: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("../views/kpilist/Targets_Actuals/kpi_summary_reports.vue"),
        },
        {
          path: "/document_repository",
          name: "document_repository",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/actual/document_repository.vue"),
        },
        {
          path: "/dms_dashboard",
          name: "dms_dashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/actual/dms_dashboard.vue"),
        },
        {
          path: "/AI_Transcription",
          name: "AI_Transcription",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/AI_tools/Transcription.vue"),
        },

        {
          path: "/forms_landing",
          name: "Forms Landing",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Forms/forms_landing.vue"),
        },
        {
          path: "/forms_dashboard_legacy",
          name: "Forms Dashboard Legacy",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Forms/forms_dashboard.vue"),
        },
        {
          path: "/Forms_Dashboard",
          name: "Forms_Dashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () =>
            import("../views/Forms/Forms_dashboard/NewForms_dashboard.vue"),
        },
        {
          path: "/forms_add",
          name: "Forms Add",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Forms/forms_add.vue"),
        },
        {
          path: "/forms_preview",
          name: "Forms Preview",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Forms/forms_preview.vue"),
        },
        {
          path: "/forms_edit",
          name: "Forms Edit",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Forms/forms_edit.vue"),
        },
        {
          path: "/forms_view_add_data",
          name: "Forms View Add Data",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Forms/forms_view_add_data.vue"),
        },

        {
          path: "/Emp_KPI_Rating_Report",
          name: "Emp_KPI_Rating_Report",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
            breadcrumb: "Rewards / Appraisal / KPI Rating Report",
          },
          component: () => import("../views/reports/Emp_KPI_Rating_Report.vue"),
        },

        {
          path: "/CEO_DashBoard",
          name: "CEO_DashBoard",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
            breadcrumb: "CEO Dashboard",
          },
          component: () =>
            import("../views/ME014/CEODashBoard/CEO_DashBoard.vue"),
        },
        {
          path: "/familybook/Family_Forms",
          name: "Family_Forms",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("@/views/Familybook_Forums/Forums_Tree.vue"),
        },
        {
          path: "/familybook/Forums_subtree",
          name: "Forums_subtree",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/Familybook_Forums/Forums_subdetails.vue"),
        },
        {
          path: "/familybook/Familybook_Subtree_Version2",
          name: "Familybook_Subtree_Version2",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/Familybook_Forums/Familybook_Subdetails_Version2.vue"),
        },
        {
          path: "/familybook/Family_socialmedia",
          name: "Family_socialmedia",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/Familybook_Forums/Familybook_conversation.vue"),
        },
        {
          path: "/drona_agent",
          name: "Drona_agent",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
          },
          component: () => import("../views/Drona_agent/drona_agent.vue"),
        },
        {
          path: "/familybook/FamilyDetails",
          name: "FamilyDetails",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_FAMILY_DETAILS",
            page_type: "landing",
            breadcrumb: "Masters / Family Details",
          },
          component: () => import("../views/masters/FamilyDetails.vue"),
        },
        {
          path: "/familybook/FamilyDetails/Add",
          name: "FamilyDetailsAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_FAMILY_DETAILS",
            page_type: "add_screen",
            breadcrumb: "Masters / Family Details",
          },
          component: () => import("../views/masters/FamilyDetailsAdd.vue"),
        },
        {
          path: "/familybook/FamilyDetails/Edit",
          name: "FamilyDetailsEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_FAMILY_DETAILS",
            page_type: "edit_screen",
            breadcrumb: "Masters / Family Details",
          },
          component: () => import("../views/masters/FamilyDetailsEdit.vue"),
        },
        {
          path: "/familybook/FamilyOrgChart",
          name: "FamilyOrgChart",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_FAMILY_ORG_CHART",
            page_type: "landing",
            breadcrumb: "Masters / Family Org Chart",
          },
          component: () => import("../views/masters/FamilyOrgChart.vue"),
        },
        {
          path: "/familybook/RelationMaster",
          name: "RelationMaster",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_RELATION_MASTER",
            page_type: "landing",
            breadcrumb: "Masters / Relation Master",
          },
          component: () => import("../views/masters/RelationMaster.vue"),
        },
        {
          path: "/familybook/RelationMaster/Add",
          name: "RelationMasterAdd",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_RELATION_MASTER",
            page_type: "add_screen",
            breadcrumb: "Masters / Relation Master",
          },
          component: () => import("../views/masters/RelationMasterAdd.vue"),
        },
        {
          path: "/familybook/RelationMaster/Edit",
          name: "RelationMasterEdit",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            //isnoadmintoshow: true,
            page_code: "SCN_RELATION_MASTER",
            page_type: "edit_screen",
            breadcrumb: "Masters / Relation Master",
          },
          component: () => import("../views/masters/RelationMasterEdit.vue"),
        },
        {
          path: "/drona_usage",
          name: "Drona_usage",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
          },
          component: () => import("../views/Drona_agent/drona_usage.vue"),
        },
        {
          path: "/industry_benchmark_dashboard",
          name: "Industry_benchmark_dashboard",
          meta: {
            auth: true,
            iscommontoshow: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
          },
          component: () => import("../views/ITC/ME014/COA/industry_benchmark_dashboard.vue"),
        },
        {
          path: "/recruitment",
          component: () => import("../views/recruitment_dashboard/recruitment.vue"),
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
          },
          children: [
            { path: "", name: "recruitment", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "pipeline", name: "recruitment-pipeline", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "requisitions", name: "recruitment-requisitions", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "sourcing", name: "recruitment-sourcing", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "screening", name: "recruitment-screening", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "interviews", name: "recruitment-interviews", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "assessments", name: "recruitment-assessments", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "offers", name: "recruitment-offers", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "onboarding", name: "recruitment-onboarding", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "tools-qb", name: "recruitment-tools-qb", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "tools-cl", name: "recruitment-tools-cl", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
            { path: "tools-set", name: "recruitment-tools-set", meta: { auth: true, screen_code: "", page_code: "", page_type: "landing" } },
          ],
        },
        {
          path: "/company_master",
          name: "Company Master",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            breadcrumb: "Masters/ Global/ Company Master",
          },
          component: () =>
            import(
              "../views/masters/company_master/company_master_landing.vue"
            ),
        },
        {
          path: "/familybook/company_master",
          name: "Company Master",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            breadcrumb: "Masters/ Global/ Company Master",
          },
          component: () =>
            import(
              "../views/masters/company_master/company_master_landing.vue"
            ),
        },
        {
          path: "/company_master_add",
          name: "Company Master Add",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/masters/company_master/company_master_add.vue"),
        },
        {
          path: "/CompanyMasterEdit/:id",
          name: "CompanyMasterEdit",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/masters/company_master/company_master_add.vue"),
        },
        {
          path: "/familybook/family_tree",
          name: "family_tree",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "edit_screen",
          },
          component: () => import("../views/family_tree/family_tree_new.vue"),
        },
        {
          path: "/familybook/family_office",
          name: "family_office",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "edit_screen",
          },
          component: () => import("../views/family_tree/family_office_new.vue"),
        },
        {
          path: "/familybook/FamilyDashboard",
          name: "FamilyHome",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../components/Family/FamilyHome.vue"),
        },
        {
          path: "/familybook/family_meetings_landing",
          name: "family_meetings_landing",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
          },
          component: () => import("../views/meeting_landing.vue"),
        },
        {
          path: "/familybook/meeting_type",
          name: "family_meeting_type",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "landing",
          },
          component: () =>
            import("../views/masters/meeting_type/meeting_type.vue"),
        },
        {
          path: "/familybook/meeting_type_add",
          name: "family_meeting_type_add",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/masters/meeting_type/meeting_type_add.vue"),
        },
        {
          path: "/familybook/meeting_type_edit/:id",
          name: "family_meeting_type_edit",
          meta: {
            auth: true,
            screen_code: "",
            page_code: "",
            page_type: "edit_screen",
          },
          component: () =>
            import("../views/masters/meeting_type/meeting_type_edit.vue"),
        },
        {
          path: "/familybook/document_repository",
          name: "document_repository",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/actual/document_repository.vue"),
        },
        {
          path: "/familybook/ticket",
          name: "Ticket",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_TICKETS",
            page_type: "landing",
          },
          component: () => import("../views/tickets/ticketIndex/newMain.vue"),
        },
        {
          path: "/familybook/MyTasks",
          name: "My Check List",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/show_list_bulk_update_Task.vue"),
        },
        {
          path: "/familybook/role",
          name: "role",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_ROLE",
            page_type: "landing",
            isnoadmintoshow: true,
            breadcrumb: "Settings / Global / Role",
          },
          component: () => import("../views/role/role.vue"),
        },
        {
          path: "/familybook/department",
          name: "Department",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DEPARTMENT",
            page_type: "landing",
            department: "Masters/ Global/ Department",
          },
          component: () => import("../views/masters/Department.vue"),
        },
        {
          path: "/familybook/designation",
          name: "Designation",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_DESIGNATION",
            page_type: "landing",
            designation: "Masters/ Global/ Designation",
          },
          component: () => import("../views/masters/Designation.vue"),
        },
        {
          path: "/familybook/health_check_invite_new",
          name: "health_check_invite_new",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "add_screen",
          },
          component: () =>
            import("../views/actual/health_check_invite_new.vue"),
        },
        {
          path: "/familybook/Forums_category",
          name: "Forums_category",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Master / Forums Category",
          },
          component: () => import("../views/masters/Forums_category.vue"),
        },
        {
          path: "/familybook/Forums_announcement_type",
          name: "Forums_announcement_type",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
            breadcrumb: "Master / Forums Announcement Type",
          },
          component: () =>
            import("../views/masters/Forums_announcement_type.vue"),
        },
        {
          path: "/familybook/admin_health_check_homescreen",
          name: "admin_health_check_homescreen",
          meta: {
            auth: true,
            screen_code: "TECTALIK_PMS",
            page_code: "SCN_BUSINESS_HEALTH_CHECK",
            page_type: "landing",
            isnoadmintoshow: false,
          },
          component: () =>
            import("../views/actual/admin_health_check_homescreen.vue"),
        },
        {
          path: "/familybook/Healthcheck_Dashboards_financial",
          name: "Healthcheck_Dashboards_financial",
          meta: {
            auth: true,
            // iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () => import("../views/dashboard_financial_home.vue"),
        },
        {
          path: "/familybook/service_category",
          name: "Service Category",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/masters/Service_category.vue"),
        },
        {
          path: "/familybook/service",
          name: "Service",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/masters/service.vue"),
        },
        {
          path: "/familybook/actual_new",
          name: "actual_new",
          meta: {
            auth: true,
            screen_code: "CREATE_MASTERS",
            page_code: "SCN_BUDGET",
            page_type: "landing",
            isnoadmintoshow: true,
          },
          component: () => import("../views/Actual_New/actualNewUI.vue"),
        },
        {
          path: "/familybook/showlist_all_report",
          name: "Reports",
          meta: {
            auth: true,
            screen_code: "RUN_REPORTS",
            page_code: "SCN_CHCK_REPORTS",
            page_type: "landing",
          },
          component: () =>
            import(
              "../views/master_checklist/reports/showlist_all_report_new.vue"
            ),
        },
        {
          path: "/familybook/tickets_report",
          name: "TicketReport",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TKT_REPORTS",
            page_type: "landing",
          },
          component: () => import("../views/tickets/Reports/report_view.vue"),
        },
        {
          path: "/familybook/checklist_new",
          name: "checklistNew",
          meta: {
            auth: true,
            iscommontoshow: true,
            isnoadmintoshow: true,
          },
          component: () =>
            import("@/views/act_checklist_new/act_checklist_new_landing.vue"),
        },
        {
          path: "/familybook/forms_master",
          name: "Forms",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/masters/forms/form_master.vue"),
        },
         {
          path: "/familybook/constitution",
          name: "Constitution",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_CHCK_MY_CHECKLIST",
            page_type: "landing",
          },
          component: () => import("../views/Familybook_Forums/Familybook_constitution.vue"),
        },
        {
          path: "/familybook/password_portal",
          name: "password_portal",
          meta: {
            auth: true,
            screen_code: "CREATE_USERS",
            page_code: "SCN_PASSWORD_PORTAL",
            page_type: "landing",
            breadcrumb: "Setting / Users / Password Portal",
          },
          component: () => import("../views/masters/password_portal.vue"),
        },
        {
          path: "/command-centre",
          name: "CommandCentre",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_COMMAND_CENTRE",
            page_type: "landing",
          },
          component: () => import("../views/Command_Centre_Dashboard/CC_Dashboard.vue"),
        },
        {
          path: "/command-centre/clarity",
          name: "CommandCentreClarity",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_COMMAND_CENTRE_CLARITY",
            page_type: "landing",
          },
          component: () => import("../views/Command_Centre_Dashboard/CC_Clarity.vue"),
        },
        {
          path: "/command-centre/accountability",
          name: "CommandCentreAccountability",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_COMMAND_CENTRE_ACCOUNTABILITY",
            page_type: "landing",
          },
          component: () => import("../views/Command_Centre_Dashboard/CC_Accountability.vue"),
        },
        {
          path: "/command-centre/control",
          name: "CommandCentreControl",
          meta: {
            auth: true,
            isnoadmintoshow: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_COMMAND_CENTRE_CONTROL",
            page_type: "landing",
          },
          component: () => import("../views/Command_Centre_Dashboard/CC_Control.vue"),
        },
        {
          path: "/executive-summary",
          component: () => import("../views/Executive_summary_Dashboard/Executive_summary.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_EXECUTIVE_SUMMARY",
            page_type: "landing",
          },
          children: [
            { path: "", name: "ExecutiveSummary", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_EXECUTIVE_SUMMARY", page_type: "landing" } },
            { path: "bell", name: "ExecutiveSummary-bell", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_EXECUTIVE_SUMMARY", page_type: "landing" } },
            { path: "dept", name: "ExecutiveSummary-dept", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_EXECUTIVE_SUMMARY", page_type: "landing" } },
            { path: "desig", name: "ExecutiveSummary-desig", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_EXECUTIVE_SUMMARY", page_type: "landing" } },
            { path: "roster", name: "ExecutiveSummary-roster", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_EXECUTIVE_SUMMARY", page_type: "landing" } },
            { path: "ai", name: "ExecutiveSummary-ai", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_EXECUTIVE_SUMMARY", page_type: "landing" } },
          ],
        },
        ...aopRoutes,
        ...workshopRoutes,
        // ── Financial Business Plan ──────────────────────────────────────
        {
          path: "/financial_business_plan",
          component: () => import("../views/Business_planning/Financial_Business_plan.vue"),
          meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" },
          children: [
            { path: "", name: "FinancialBusinessPlan", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "dashboard", name: "fbp-dash", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "configurator", name: "fbp-config", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "sales", name: "fbp-sales", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "cogs", name: "fbp-cogs", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "manpower", name: "fbp-mp", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "expenses", name: "fbp-exp", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "debt", name: "fbp-debt", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "statements", name: "fbp-stmt", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "plan-vs-actuals", name: "fbp-var", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "scenarios", name: "fbp-sc", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "seasonality", name: "fbp-season", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "ledger-mapping", name: "fbp-ledger", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "what-if-scenario", name: "fbp-whatif", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "actual", name: "fbp-actual", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "budget", name: "fbp-budget", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
            { path: "budget-vs-actual", name: "fbp-bva", meta: { auth: true, page_code: "SCN_BP_DASHBOARD", page_type: "landing" } },
          ],
        },
        // ── Financial Planning (BP) ──────────────────────────────────────
        {
          path: "/bp",
          component: () => import("../views/Business_planning/BP_Layout.vue"),
          redirect: "/bp/dashboard",
          meta: { auth: true },
          children: [
            { path: "dashboard",   name: "BPDashboard",    meta: { auth: true, page_code: "SCN_BP_DASHBOARD",  page_type: "landing" }, component: () => import("../views/Business_planning/BP_dashboard.vue") },
            { path: "configurator",name: "BPConfigurator", meta: { auth: true, page_code: "SCN_BP_CONFIG",     page_type: "landing" }, component: () => import("../views/Business_planning/BP_Configurator.vue") },
            { path: "sales",       name: "BPSales",        meta: { auth: true, page_code: "SCN_BP_SALES",      page_type: "landing" }, component: () => import("../views/Business_planning/BP_SalesForecast.vue") },
            { path: "cogs",        name: "BPCOGS",         meta: { auth: true, page_code: "SCN_BP_COGS",       page_type: "landing" }, component: () => import("../views/Business_planning/BP_COGS.vue") },
            { path: "manpower",    name: "BPManpower",     meta: { auth: true, page_code: "SCN_BP_MANPOWER",   page_type: "landing" }, component: () => import("../views/Business_planning/BP_Manpower.vue") },
            { path: "expenses",    name: "BPExpenses",     meta: { auth: true, page_code: "SCN_BP_EXPENSES",   page_type: "landing" }, component: () => import("../views/Business_planning/BP_Expenses.vue") },
            { path: "debt",        name: "BPDebt",         meta: { auth: true, page_code: "SCN_BP_DEBT",       page_type: "landing" }, component: () => import("../views/Business_planning/BP_Debt_schedule.vue") },
            { path: "statements",  name: "BPStatements",   meta: { auth: true, page_code: "SCN_BP_STATEMENTS", page_type: "landing" }, component: () => import("../views/Business_planning/BP_Statement.vue") },
            { path: "variance",    name: "BPVariance",     meta: { auth: true, page_code: "SCN_BP_VARIANCE",   page_type: "landing" }, component: () => import("../views/Business_planning/BP_BudgetvsActual.vue") },
            { path: "scenarios",   name: "BPScenarios",    meta: { auth: true, page_code: "SCN_BP_SCENARIOS",  page_type: "landing" }, component: () => import("../views/Business_planning/BP_Scenarios.vue") },
          ],
        },
        {
          path: "/policies_dashboard",
          name: "PoliciesDashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_POLICIES_DASHBOARD",
            page_type: "landing",
          },
          component: () => import("../views/Policies_dashboard/policies_dashboard.vue"),
        },
        {
          path: "/rewards_dashboard",
          name: "rewardsDashboard",
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_REWARDS_DASHBOARD",
            page_type: "landing",
          },
          component: () => import("../views/rewards_incentive/rewards_incentive.vue"),
        },
        {
          path: "/training_dashboard",
          component: () => import("../views/TrainingDashboard/training_dashboard.vue"),
          meta: {
            auth: true,
            screen_code: "CREATE_CHK",
            page_code: "SCN_TRAINING_DASHBOARD",
            page_type: "landing",
          },
          children: [
            { path: "", name: "trainingdashboard", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "calendar", name: "trainingdashboard-calendar", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "programs", name: "trainingdashboard-programs", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "sessions", name: "trainingdashboard-sessions", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "catalog", name: "trainingdashboard-catalog", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "workflows", name: "trainingdashboard-workflows", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "live", name: "trainingdashboard-live", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "sme", name: "trainingdashboard-sme", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "employees", name: "trainingdashboard-employees", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "certs", name: "trainingdashboard-certs", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "gaps", name: "trainingdashboard-gaps", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "effect", name: "trainingdashboard-effect", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "assess", name: "trainingdashboard-assess", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
            { path: "config", name: "trainingdashboard-config", meta: { auth: true, screen_code: "CREATE_CHK", page_code: "SCN_TRAINING_DASHBOARD", page_type: "landing" } },
          ],
        },
        {
          path: "/starr_implementation_programme",
          name: "StarrImplementationProgramme",
          meta: { auth: true, page_type: "landing" },
          component: () => import("@/views/StarrImplementationProgramme.vue"),
        },
      ],
    },
  ],
});
